/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  JSON: { input: string; output: string; }
  bigint: { input: string; output: string; }
  bpchar: { input: string; output: string; }
  daterange: { input: string; output: string; }
  jsonb: { input: string; output: string; }
  smallint: { input: number; output: number; }
  timestamptz: { input: string; output: string; }
  uuid: { input: string; output: string; }
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type BigintComparisonExp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type BooleanComparisonExp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** Boolean expression to compare columns of type "bpchar". All fields are combined with logical 'AND'. */
export type BpcharComparisonExp = {
  _eq?: InputMaybe<Scalars['bpchar']['input']>;
  _gt?: InputMaybe<Scalars['bpchar']['input']>;
  _gte?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['bpchar']['input']>;
  _in?: InputMaybe<Array<Scalars['bpchar']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['bpchar']['input']>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['bpchar']['input']>;
  _lt?: InputMaybe<Scalars['bpchar']['input']>;
  _lte?: InputMaybe<Scalars['bpchar']['input']>;
  _neq?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['bpchar']['input']>;
  _nin?: InputMaybe<Array<Scalars['bpchar']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['bpchar']['input']>;
};

export type CreateDemoPgDatasourceResult = {
  __typename?: 'CreateDemoPgDatasourceResult';
  datasource?: Maybe<Datasources>;
  datasourceId: Scalars['String']['output'];
};

export type CreateEnvironmentPgDatasourceResult = {
  __typename?: 'CreateEnvironmentPgDatasourceResult';
  datasource: Array<Datasources>;
  datasourceId: Scalars['String']['output'];
  initialSchemamapSql: Scalars['String']['output'];
};


export type CreateEnvironmentPgDatasourceResultDatasourceArgs = {
  distinctOn?: InputMaybe<Array<DatasourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DatasourcesOrderBy>>;
  where?: InputMaybe<DatasourcesBoolExp>;
};

/** ordering argument of a cursor */
export enum CursorOrdering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

export type D2LodSvg = {
  __typename?: 'D2LODSvg';
  d2Svg: Scalars['String']['output'];
  d2Text: Scalars['String']['output'];
  lod: Scalars['Int']['output'];
};

export type DataMigration = {
  __typename?: 'DataMigration';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  importStartedAt?: Maybe<Scalars['String']['output']>;
  importedAt?: Maybe<Scalars['String']['output']>;
  mdeName: Scalars['String']['output'];
  requesterEmail?: Maybe<Scalars['String']['output']>;
  requesterUserId?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  state: Scalars['String']['output'];
  summary?: Maybe<Scalars['JSON']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  tenantName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

/** columns and relationships of "datasource_i18ns" */
export type DatasourceI18ns = {
  __typename?: 'DatasourceI18ns';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  datasource: Datasources;
  datasourceId: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  lastSeenAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['bigint']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  value: Scalars['jsonb']['output'];
  valueHash: Scalars['String']['output'];
};


/** columns and relationships of "datasource_i18ns" */
export type DatasourceI18nsValueArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "datasource_i18ns" */
export type DatasourceI18nsAggregateOrderBy = {
  avg?: InputMaybe<DatasourceI18nsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DatasourceI18nsMaxOrderBy>;
  min?: InputMaybe<DatasourceI18nsMinOrderBy>;
  stddev?: InputMaybe<DatasourceI18nsStddevOrderBy>;
  stddevPop?: InputMaybe<DatasourceI18nsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<DatasourceI18nsStddevSampOrderBy>;
  sum?: InputMaybe<DatasourceI18nsSumOrderBy>;
  varPop?: InputMaybe<DatasourceI18nsVarPopOrderBy>;
  varSamp?: InputMaybe<DatasourceI18nsVarSampOrderBy>;
  variance?: InputMaybe<DatasourceI18nsVarianceOrderBy>;
};

/** order by avg() on columns of table "datasource_i18ns" */
export type DatasourceI18nsAvgOrderBy = {
  datasourceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "datasource_i18ns". All fields are combined with a logical 'AND'. */
export type DatasourceI18nsBoolExp = {
  _and?: InputMaybe<Array<DatasourceI18nsBoolExp>>;
  _not?: InputMaybe<DatasourceI18nsBoolExp>;
  _or?: InputMaybe<Array<DatasourceI18nsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  datasource?: InputMaybe<DatasourcesBoolExp>;
  datasourceId?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  lastSeenAt?: InputMaybe<TimestamptzComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<BigintComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  value?: InputMaybe<JsonbComparisonExp>;
  valueHash?: InputMaybe<StringComparisonExp>;
};

/** order by max() on columns of table "datasource_i18ns" */
export type DatasourceI18nsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  datasourceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastSeenAt?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  valueHash?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "datasource_i18ns" */
export type DatasourceI18nsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  datasourceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastSeenAt?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  valueHash?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "datasource_i18ns". */
export type DatasourceI18nsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  datasource?: InputMaybe<DatasourcesOrderBy>;
  datasourceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastSeenAt?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
  valueHash?: InputMaybe<OrderBy>;
};

/** select columns of table "datasource_i18ns" */
export enum DatasourceI18nsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DatasourceId = 'datasourceId',
  /** column name */
  Id = 'id',
  /** column name */
  LastSeenAt = 'lastSeenAt',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Value = 'value',
  /** column name */
  ValueHash = 'valueHash'
}

/** order by stddev() on columns of table "datasource_i18ns" */
export type DatasourceI18nsStddevOrderBy = {
  datasourceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "datasource_i18ns" */
export type DatasourceI18nsStddevPopOrderBy = {
  datasourceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "datasource_i18ns" */
export type DatasourceI18nsStddevSampOrderBy = {
  datasourceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "datasource_i18ns" */
export type DatasourceI18nsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DatasourceI18nsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DatasourceI18nsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  datasourceId?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lastSeenAt?: InputMaybe<Scalars['timestamptz']['input']>;
  tenantId?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['jsonb']['input']>;
  valueHash?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "datasource_i18ns" */
export type DatasourceI18nsSumOrderBy = {
  datasourceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "datasource_i18ns" */
export type DatasourceI18nsVarPopOrderBy = {
  datasourceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "datasource_i18ns" */
export type DatasourceI18nsVarSampOrderBy = {
  datasourceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "datasource_i18ns" */
export type DatasourceI18nsVarianceOrderBy = {
  datasourceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "datasource_schema_metadata_overview" */
export type DatasourceSchemaMetadataOverview = {
  __typename?: 'DatasourceSchemaMetadataOverview';
  attnum?: Maybe<Scalars['smallint']['output']>;
  columnDescription?: Maybe<Scalars['String']['output']>;
  columnName: Scalars['String']['output'];
  constraints?: Maybe<Scalars['jsonb']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  dataType: Scalars['String']['output'];
  /** An object relationship */
  datasource: Datasources;
  datasourceId: Scalars['bigint']['output'];
  defaultValue?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  indexes?: Maybe<Scalars['jsonb']['output']>;
  lastSeenAt: Scalars['timestamptz']['output'];
  notNull: Scalars['Boolean']['output'];
  objectType: Scalars['bpchar']['output'];
  schemaName: Scalars['String']['output'];
  tableDescription?: Maybe<Scalars['String']['output']>;
  tableName: Scalars['String']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['bigint']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  valueHash: Scalars['String']['output'];
};


/** columns and relationships of "datasource_schema_metadata_overview" */
export type DatasourceSchemaMetadataOverviewConstraintsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "datasource_schema_metadata_overview" */
export type DatasourceSchemaMetadataOverviewIndexesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "datasource_schema_metadata_overview" */
export type DatasourceSchemaMetadataOverviewAggregateOrderBy = {
  avg?: InputMaybe<DatasourceSchemaMetadataOverviewAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DatasourceSchemaMetadataOverviewMaxOrderBy>;
  min?: InputMaybe<DatasourceSchemaMetadataOverviewMinOrderBy>;
  stddev?: InputMaybe<DatasourceSchemaMetadataOverviewStddevOrderBy>;
  stddevPop?: InputMaybe<DatasourceSchemaMetadataOverviewStddevPopOrderBy>;
  stddevSamp?: InputMaybe<DatasourceSchemaMetadataOverviewStddevSampOrderBy>;
  sum?: InputMaybe<DatasourceSchemaMetadataOverviewSumOrderBy>;
  varPop?: InputMaybe<DatasourceSchemaMetadataOverviewVarPopOrderBy>;
  varSamp?: InputMaybe<DatasourceSchemaMetadataOverviewVarSampOrderBy>;
  variance?: InputMaybe<DatasourceSchemaMetadataOverviewVarianceOrderBy>;
};

/** order by avg() on columns of table "datasource_schema_metadata_overview" */
export type DatasourceSchemaMetadataOverviewAvgOrderBy = {
  attnum?: InputMaybe<OrderBy>;
  datasourceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "datasource_schema_metadata_overview". All fields are combined with a logical 'AND'. */
export type DatasourceSchemaMetadataOverviewBoolExp = {
  _and?: InputMaybe<Array<DatasourceSchemaMetadataOverviewBoolExp>>;
  _not?: InputMaybe<DatasourceSchemaMetadataOverviewBoolExp>;
  _or?: InputMaybe<Array<DatasourceSchemaMetadataOverviewBoolExp>>;
  attnum?: InputMaybe<SmallintComparisonExp>;
  columnDescription?: InputMaybe<StringComparisonExp>;
  columnName?: InputMaybe<StringComparisonExp>;
  constraints?: InputMaybe<JsonbComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dataType?: InputMaybe<StringComparisonExp>;
  datasource?: InputMaybe<DatasourcesBoolExp>;
  datasourceId?: InputMaybe<BigintComparisonExp>;
  defaultValue?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  indexes?: InputMaybe<JsonbComparisonExp>;
  lastSeenAt?: InputMaybe<TimestamptzComparisonExp>;
  notNull?: InputMaybe<BooleanComparisonExp>;
  objectType?: InputMaybe<BpcharComparisonExp>;
  schemaName?: InputMaybe<StringComparisonExp>;
  tableDescription?: InputMaybe<StringComparisonExp>;
  tableName?: InputMaybe<StringComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<BigintComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  valueHash?: InputMaybe<StringComparisonExp>;
};

/** order by max() on columns of table "datasource_schema_metadata_overview" */
export type DatasourceSchemaMetadataOverviewMaxOrderBy = {
  attnum?: InputMaybe<OrderBy>;
  columnDescription?: InputMaybe<OrderBy>;
  columnName?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dataType?: InputMaybe<OrderBy>;
  datasourceId?: InputMaybe<OrderBy>;
  defaultValue?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastSeenAt?: InputMaybe<OrderBy>;
  objectType?: InputMaybe<OrderBy>;
  schemaName?: InputMaybe<OrderBy>;
  tableDescription?: InputMaybe<OrderBy>;
  tableName?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  valueHash?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "datasource_schema_metadata_overview" */
export type DatasourceSchemaMetadataOverviewMinOrderBy = {
  attnum?: InputMaybe<OrderBy>;
  columnDescription?: InputMaybe<OrderBy>;
  columnName?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dataType?: InputMaybe<OrderBy>;
  datasourceId?: InputMaybe<OrderBy>;
  defaultValue?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastSeenAt?: InputMaybe<OrderBy>;
  objectType?: InputMaybe<OrderBy>;
  schemaName?: InputMaybe<OrderBy>;
  tableDescription?: InputMaybe<OrderBy>;
  tableName?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  valueHash?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "datasource_schema_metadata_overview". */
export type DatasourceSchemaMetadataOverviewOrderBy = {
  attnum?: InputMaybe<OrderBy>;
  columnDescription?: InputMaybe<OrderBy>;
  columnName?: InputMaybe<OrderBy>;
  constraints?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dataType?: InputMaybe<OrderBy>;
  datasource?: InputMaybe<DatasourcesOrderBy>;
  datasourceId?: InputMaybe<OrderBy>;
  defaultValue?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  indexes?: InputMaybe<OrderBy>;
  lastSeenAt?: InputMaybe<OrderBy>;
  notNull?: InputMaybe<OrderBy>;
  objectType?: InputMaybe<OrderBy>;
  schemaName?: InputMaybe<OrderBy>;
  tableDescription?: InputMaybe<OrderBy>;
  tableName?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  valueHash?: InputMaybe<OrderBy>;
};

/** select columns of table "datasource_schema_metadata_overview" */
export enum DatasourceSchemaMetadataOverviewSelectColumn {
  /** column name */
  Attnum = 'attnum',
  /** column name */
  ColumnDescription = 'columnDescription',
  /** column name */
  ColumnName = 'columnName',
  /** column name */
  Constraints = 'constraints',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DataType = 'dataType',
  /** column name */
  DatasourceId = 'datasourceId',
  /** column name */
  DefaultValue = 'defaultValue',
  /** column name */
  Id = 'id',
  /** column name */
  Indexes = 'indexes',
  /** column name */
  LastSeenAt = 'lastSeenAt',
  /** column name */
  NotNull = 'notNull',
  /** column name */
  ObjectType = 'objectType',
  /** column name */
  SchemaName = 'schemaName',
  /** column name */
  TableDescription = 'tableDescription',
  /** column name */
  TableName = 'tableName',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  ValueHash = 'valueHash'
}

/** order by stddev() on columns of table "datasource_schema_metadata_overview" */
export type DatasourceSchemaMetadataOverviewStddevOrderBy = {
  attnum?: InputMaybe<OrderBy>;
  datasourceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "datasource_schema_metadata_overview" */
export type DatasourceSchemaMetadataOverviewStddevPopOrderBy = {
  attnum?: InputMaybe<OrderBy>;
  datasourceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "datasource_schema_metadata_overview" */
export type DatasourceSchemaMetadataOverviewStddevSampOrderBy = {
  attnum?: InputMaybe<OrderBy>;
  datasourceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "datasource_schema_metadata_overview" */
export type DatasourceSchemaMetadataOverviewStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DatasourceSchemaMetadataOverviewStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DatasourceSchemaMetadataOverviewStreamCursorValueInput = {
  attnum?: InputMaybe<Scalars['smallint']['input']>;
  columnDescription?: InputMaybe<Scalars['String']['input']>;
  columnName?: InputMaybe<Scalars['String']['input']>;
  constraints?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataType?: InputMaybe<Scalars['String']['input']>;
  datasourceId?: InputMaybe<Scalars['bigint']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  indexes?: InputMaybe<Scalars['jsonb']['input']>;
  lastSeenAt?: InputMaybe<Scalars['timestamptz']['input']>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  objectType?: InputMaybe<Scalars['bpchar']['input']>;
  schemaName?: InputMaybe<Scalars['String']['input']>;
  tableDescription?: InputMaybe<Scalars['String']['input']>;
  tableName?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  valueHash?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "datasource_schema_metadata_overview" */
export type DatasourceSchemaMetadataOverviewSumOrderBy = {
  attnum?: InputMaybe<OrderBy>;
  datasourceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "datasource_schema_metadata_overview" */
export type DatasourceSchemaMetadataOverviewVarPopOrderBy = {
  attnum?: InputMaybe<OrderBy>;
  datasourceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "datasource_schema_metadata_overview" */
export type DatasourceSchemaMetadataOverviewVarSampOrderBy = {
  attnum?: InputMaybe<OrderBy>;
  datasourceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "datasource_schema_metadata_overview" */
export type DatasourceSchemaMetadataOverviewVarianceOrderBy = {
  attnum?: InputMaybe<OrderBy>;
  datasourceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "datasources" */
export type Datasources = {
  __typename?: 'Datasources';
  createdAt: Scalars['timestamptz']['output'];
  database: Scalars['String']['output'];
  /** An array relationship */
  datasourceI18ns: Array<DatasourceI18ns>;
  /** An array relationship */
  datasourceSchemaMetadataOverviews: Array<DatasourceSchemaMetadataOverview>;
  /** An object relationship */
  environment: Environments;
  environmentId: Scalars['bigint']['output'];
  /** An array relationship */
  googleSpreadsheetSyncs: Array<GoogleSpreadsheetSyncs>;
  /** An aggregate relationship */
  googleSpreadsheetSyncsAggregate: GoogleSpreadsheetSyncsAggregate;
  host: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  lastConnectionAttemptAt?: Maybe<Scalars['timestamptz']['output']>;
  lastSuccessfulConnectionAttemptAt?: Maybe<Scalars['timestamptz']['output']>;
  port: Scalars['Int']['output'];
  /** An array relationship */
  readonlyGoogleSpreadsheets: Array<GoogleSpreadsheets>;
  /** An aggregate relationship */
  readonlyGoogleSpreadsheetsAggregate: GoogleSpreadsheetsAggregate;
  rootcert?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  rwGoogleSpreadsheets: Array<GoogleSpreadsheets>;
  /** An aggregate relationship */
  rwGoogleSpreadsheetsAggregate: GoogleSpreadsheetsAggregate;
  sslmode: Scalars['String']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['bigint']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  username: Scalars['String']['output'];
};


/** columns and relationships of "datasources" */
export type DatasourcesDatasourceI18nsArgs = {
  distinctOn?: InputMaybe<Array<DatasourceI18nsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DatasourceI18nsOrderBy>>;
  where?: InputMaybe<DatasourceI18nsBoolExp>;
};


/** columns and relationships of "datasources" */
export type DatasourcesDatasourceSchemaMetadataOverviewsArgs = {
  distinctOn?: InputMaybe<Array<DatasourceSchemaMetadataOverviewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DatasourceSchemaMetadataOverviewOrderBy>>;
  where?: InputMaybe<DatasourceSchemaMetadataOverviewBoolExp>;
};


/** columns and relationships of "datasources" */
export type DatasourcesGoogleSpreadsheetSyncsArgs = {
  distinctOn?: InputMaybe<Array<GoogleSpreadsheetSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSpreadsheetSyncsOrderBy>>;
  where?: InputMaybe<GoogleSpreadsheetSyncsBoolExp>;
};


/** columns and relationships of "datasources" */
export type DatasourcesGoogleSpreadsheetSyncsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GoogleSpreadsheetSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSpreadsheetSyncsOrderBy>>;
  where?: InputMaybe<GoogleSpreadsheetSyncsBoolExp>;
};


/** columns and relationships of "datasources" */
export type DatasourcesReadonlyGoogleSpreadsheetsArgs = {
  distinctOn?: InputMaybe<Array<GoogleSpreadsheetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSpreadsheetsOrderBy>>;
  where?: InputMaybe<GoogleSpreadsheetsBoolExp>;
};


/** columns and relationships of "datasources" */
export type DatasourcesReadonlyGoogleSpreadsheetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GoogleSpreadsheetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSpreadsheetsOrderBy>>;
  where?: InputMaybe<GoogleSpreadsheetsBoolExp>;
};


/** columns and relationships of "datasources" */
export type DatasourcesRwGoogleSpreadsheetsArgs = {
  distinctOn?: InputMaybe<Array<GoogleSpreadsheetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSpreadsheetsOrderBy>>;
  where?: InputMaybe<GoogleSpreadsheetsBoolExp>;
};


/** columns and relationships of "datasources" */
export type DatasourcesRwGoogleSpreadsheetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GoogleSpreadsheetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSpreadsheetsOrderBy>>;
  where?: InputMaybe<GoogleSpreadsheetsBoolExp>;
};

/** order by aggregate values of table "datasources" */
export type DatasourcesAggregateOrderBy = {
  avg?: InputMaybe<DatasourcesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DatasourcesMaxOrderBy>;
  min?: InputMaybe<DatasourcesMinOrderBy>;
  stddev?: InputMaybe<DatasourcesStddevOrderBy>;
  stddevPop?: InputMaybe<DatasourcesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<DatasourcesStddevSampOrderBy>;
  sum?: InputMaybe<DatasourcesSumOrderBy>;
  varPop?: InputMaybe<DatasourcesVarPopOrderBy>;
  varSamp?: InputMaybe<DatasourcesVarSampOrderBy>;
  variance?: InputMaybe<DatasourcesVarianceOrderBy>;
};

/** order by avg() on columns of table "datasources" */
export type DatasourcesAvgOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  port?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "datasources". All fields are combined with a logical 'AND'. */
export type DatasourcesBoolExp = {
  _and?: InputMaybe<Array<DatasourcesBoolExp>>;
  _not?: InputMaybe<DatasourcesBoolExp>;
  _or?: InputMaybe<Array<DatasourcesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  database?: InputMaybe<StringComparisonExp>;
  datasourceI18ns?: InputMaybe<DatasourceI18nsBoolExp>;
  datasourceSchemaMetadataOverviews?: InputMaybe<DatasourceSchemaMetadataOverviewBoolExp>;
  environment?: InputMaybe<EnvironmentsBoolExp>;
  environmentId?: InputMaybe<BigintComparisonExp>;
  googleSpreadsheetSyncs?: InputMaybe<GoogleSpreadsheetSyncsBoolExp>;
  googleSpreadsheetSyncsAggregate?: InputMaybe<GoogleSpreadsheetSyncsAggregateBoolExp>;
  host?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  lastConnectionAttemptAt?: InputMaybe<TimestamptzComparisonExp>;
  lastSuccessfulConnectionAttemptAt?: InputMaybe<TimestamptzComparisonExp>;
  port?: InputMaybe<IntComparisonExp>;
  readonlyGoogleSpreadsheets?: InputMaybe<GoogleSpreadsheetsBoolExp>;
  readonlyGoogleSpreadsheetsAggregate?: InputMaybe<GoogleSpreadsheetsAggregateBoolExp>;
  rootcert?: InputMaybe<StringComparisonExp>;
  rwGoogleSpreadsheets?: InputMaybe<GoogleSpreadsheetsBoolExp>;
  rwGoogleSpreadsheetsAggregate?: InputMaybe<GoogleSpreadsheetsAggregateBoolExp>;
  sslmode?: InputMaybe<StringComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<BigintComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  username?: InputMaybe<StringComparisonExp>;
};

/** order by max() on columns of table "datasources" */
export type DatasourcesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  database?: InputMaybe<OrderBy>;
  environmentId?: InputMaybe<OrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastConnectionAttemptAt?: InputMaybe<OrderBy>;
  lastSuccessfulConnectionAttemptAt?: InputMaybe<OrderBy>;
  port?: InputMaybe<OrderBy>;
  rootcert?: InputMaybe<OrderBy>;
  sslmode?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  username?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "datasources" */
export type DatasourcesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  database?: InputMaybe<OrderBy>;
  environmentId?: InputMaybe<OrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastConnectionAttemptAt?: InputMaybe<OrderBy>;
  lastSuccessfulConnectionAttemptAt?: InputMaybe<OrderBy>;
  port?: InputMaybe<OrderBy>;
  rootcert?: InputMaybe<OrderBy>;
  sslmode?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  username?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "datasources" */
export type DatasourcesMutationResponse = {
  __typename?: 'DatasourcesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Datasources>;
};

/** Ordering options when selecting data from "datasources". */
export type DatasourcesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  database?: InputMaybe<OrderBy>;
  datasourceI18nsAggregate?: InputMaybe<DatasourceI18nsAggregateOrderBy>;
  datasourceSchemaMetadataOverviewsAggregate?: InputMaybe<DatasourceSchemaMetadataOverviewAggregateOrderBy>;
  environment?: InputMaybe<EnvironmentsOrderBy>;
  environmentId?: InputMaybe<OrderBy>;
  googleSpreadsheetSyncsAggregate?: InputMaybe<GoogleSpreadsheetSyncsAggregateOrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastConnectionAttemptAt?: InputMaybe<OrderBy>;
  lastSuccessfulConnectionAttemptAt?: InputMaybe<OrderBy>;
  port?: InputMaybe<OrderBy>;
  readonlyGoogleSpreadsheetsAggregate?: InputMaybe<GoogleSpreadsheetsAggregateOrderBy>;
  rootcert?: InputMaybe<OrderBy>;
  rwGoogleSpreadsheetsAggregate?: InputMaybe<GoogleSpreadsheetsAggregateOrderBy>;
  sslmode?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  username?: InputMaybe<OrderBy>;
};

/** select columns of table "datasources" */
export enum DatasourcesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Database = 'database',
  /** column name */
  EnvironmentId = 'environmentId',
  /** column name */
  Host = 'host',
  /** column name */
  Id = 'id',
  /** column name */
  LastConnectionAttemptAt = 'lastConnectionAttemptAt',
  /** column name */
  LastSuccessfulConnectionAttemptAt = 'lastSuccessfulConnectionAttemptAt',
  /** column name */
  Port = 'port',
  /** column name */
  Rootcert = 'rootcert',
  /** column name */
  Sslmode = 'sslmode',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Username = 'username'
}

/** order by stddev() on columns of table "datasources" */
export type DatasourcesStddevOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  port?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "datasources" */
export type DatasourcesStddevPopOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  port?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "datasources" */
export type DatasourcesStddevSampOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  port?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "datasources" */
export type DatasourcesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DatasourcesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DatasourcesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  database?: InputMaybe<Scalars['String']['input']>;
  environmentId?: InputMaybe<Scalars['bigint']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lastConnectionAttemptAt?: InputMaybe<Scalars['timestamptz']['input']>;
  lastSuccessfulConnectionAttemptAt?: InputMaybe<Scalars['timestamptz']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
  rootcert?: InputMaybe<Scalars['String']['input']>;
  sslmode?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "datasources" */
export type DatasourcesSumOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  port?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "datasources" */
export type DatasourcesVarPopOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  port?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "datasources" */
export type DatasourcesVarSampOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  port?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "datasources" */
export type DatasourcesVarianceOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  port?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** Boolean expression to compare columns of type "daterange". All fields are combined with logical 'AND'. */
export type DaterangeComparisonExp = {
  _eq?: InputMaybe<Scalars['daterange']['input']>;
  _gt?: InputMaybe<Scalars['daterange']['input']>;
  _gte?: InputMaybe<Scalars['daterange']['input']>;
  _in?: InputMaybe<Array<Scalars['daterange']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['daterange']['input']>;
  _lte?: InputMaybe<Scalars['daterange']['input']>;
  _neq?: InputMaybe<Scalars['daterange']['input']>;
  _nin?: InputMaybe<Array<Scalars['daterange']['input']>>;
};

/** columns and relationships of "environment_types" */
export type EnvironmentTypes = {
  __typename?: 'EnvironmentTypes';
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "environment_types". All fields are combined with a logical 'AND'. */
export type EnvironmentTypesBoolExp = {
  _and?: InputMaybe<Array<EnvironmentTypesBoolExp>>;
  _not?: InputMaybe<EnvironmentTypesBoolExp>;
  _or?: InputMaybe<Array<EnvironmentTypesBoolExp>>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum EnvironmentTypesEnum {
  Dev = 'DEV',
  DisasterRecovery = 'DISASTER_RECOVERY',
  Local = 'LOCAL',
  Performance = 'PERFORMANCE',
  Preprod = 'PREPROD',
  Prod = 'PROD',
  Qa = 'QA',
  Sandbox = 'SANDBOX',
  Staging = 'STAGING',
  Test = 'TEST',
  Training = 'TRAINING',
  Uat = 'UAT'
}

/** Boolean expression to compare columns of type "EnvironmentTypesEnum". All fields are combined with logical 'AND'. */
export type EnvironmentTypesEnumComparisonExp = {
  _eq?: InputMaybe<EnvironmentTypesEnum>;
  _in?: InputMaybe<Array<EnvironmentTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<EnvironmentTypesEnum>;
  _nin?: InputMaybe<Array<EnvironmentTypesEnum>>;
};

/** Ordering options when selecting data from "environment_types". */
export type EnvironmentTypesOrderBy = {
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "environment_types" */
export enum EnvironmentTypesSelectColumn {
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "environment_types" */
export type EnvironmentTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EnvironmentTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EnvironmentTypesStreamCursorValueInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "environments" */
export type Environments = {
  __typename?: 'Environments';
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  datasources: Array<Datasources>;
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  googleSpreadsheets: Array<GoogleSpreadsheets>;
  /** An aggregate relationship */
  googleSpreadsheetsAggregate: GoogleSpreadsheetsAggregate;
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  pgtunnelPorts: Array<PgtunnelPorts>;
  /** An object relationship */
  project?: Maybe<Projects>;
  projectId?: Maybe<Scalars['bigint']['output']>;
  slug: Scalars['String']['output'];
  /** An object relationship */
  tenant?: Maybe<Tenants>;
  /** An array relationship */
  trackedMdeEnvironments: Array<TrackedMdeEnvironments>;
  /** An array relationship */
  trackedTenantEnvironments: Array<TrackedTenantEnvironments>;
  type: EnvironmentTypesEnum;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "environments" */
export type EnvironmentsDatasourcesArgs = {
  distinctOn?: InputMaybe<Array<DatasourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DatasourcesOrderBy>>;
  where?: InputMaybe<DatasourcesBoolExp>;
};


/** columns and relationships of "environments" */
export type EnvironmentsGoogleSpreadsheetsArgs = {
  distinctOn?: InputMaybe<Array<GoogleSpreadsheetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSpreadsheetsOrderBy>>;
  where?: InputMaybe<GoogleSpreadsheetsBoolExp>;
};


/** columns and relationships of "environments" */
export type EnvironmentsGoogleSpreadsheetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GoogleSpreadsheetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSpreadsheetsOrderBy>>;
  where?: InputMaybe<GoogleSpreadsheetsBoolExp>;
};


/** columns and relationships of "environments" */
export type EnvironmentsPgtunnelPortsArgs = {
  distinctOn?: InputMaybe<Array<PgtunnelPortsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PgtunnelPortsOrderBy>>;
  where?: InputMaybe<PgtunnelPortsBoolExp>;
};


/** columns and relationships of "environments" */
export type EnvironmentsTrackedMdeEnvironmentsArgs = {
  distinctOn?: InputMaybe<Array<TrackedMdeEnvironmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrackedMdeEnvironmentsOrderBy>>;
  where?: InputMaybe<TrackedMdeEnvironmentsBoolExp>;
};


/** columns and relationships of "environments" */
export type EnvironmentsTrackedTenantEnvironmentsArgs = {
  distinctOn?: InputMaybe<Array<TrackedTenantEnvironmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrackedTenantEnvironmentsOrderBy>>;
  where?: InputMaybe<TrackedTenantEnvironmentsBoolExp>;
};

/** order by aggregate values of table "environments" */
export type EnvironmentsAggregateOrderBy = {
  avg?: InputMaybe<EnvironmentsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EnvironmentsMaxOrderBy>;
  min?: InputMaybe<EnvironmentsMinOrderBy>;
  stddev?: InputMaybe<EnvironmentsStddevOrderBy>;
  stddevPop?: InputMaybe<EnvironmentsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EnvironmentsStddevSampOrderBy>;
  sum?: InputMaybe<EnvironmentsSumOrderBy>;
  varPop?: InputMaybe<EnvironmentsVarPopOrderBy>;
  varSamp?: InputMaybe<EnvironmentsVarSampOrderBy>;
  variance?: InputMaybe<EnvironmentsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "environments" */
export type EnvironmentsArrRelInsertInput = {
  data: Array<EnvironmentsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EnvironmentsOnConflict>;
};

/** order by avg() on columns of table "environments" */
export type EnvironmentsAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "environments". All fields are combined with a logical 'AND'. */
export type EnvironmentsBoolExp = {
  _and?: InputMaybe<Array<EnvironmentsBoolExp>>;
  _not?: InputMaybe<EnvironmentsBoolExp>;
  _or?: InputMaybe<Array<EnvironmentsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  datasources?: InputMaybe<DatasourcesBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  googleSpreadsheets?: InputMaybe<GoogleSpreadsheetsBoolExp>;
  googleSpreadsheetsAggregate?: InputMaybe<GoogleSpreadsheetsAggregateBoolExp>;
  id?: InputMaybe<BigintComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  pgtunnelPorts?: InputMaybe<PgtunnelPortsBoolExp>;
  project?: InputMaybe<ProjectsBoolExp>;
  projectId?: InputMaybe<BigintComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  trackedMdeEnvironments?: InputMaybe<TrackedMdeEnvironmentsBoolExp>;
  trackedTenantEnvironments?: InputMaybe<TrackedTenantEnvironmentsBoolExp>;
  type?: InputMaybe<EnvironmentTypesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "environments" */
export enum EnvironmentsConstraint {
  /** unique or primary key constraint on columns "id" */
  EnvironmentsPkey = 'environments_pkey',
  /** unique or primary key constraint on columns "project_id", "slug" */
  EnvironmentsProjectIdSlugKey = 'environments_project_id_slug_key',
  /** unique or primary key constraint on columns "project_id", "name", "tenant_id" */
  EnvironmentsTenantIdProjectIdNameUniq = 'environments_tenant_id_project_id_name_uniq'
}

/** input type for incrementing numeric columns in table "environments" */
export type EnvironmentsIncInput = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  projectId?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "environments" */
export type EnvironmentsInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<ProjectsObjRelInsertInput>;
  projectId?: InputMaybe<Scalars['bigint']['input']>;
  tenantId?: InputMaybe<Scalars['bigint']['input']>;
  trackedMdeEnvironments?: InputMaybe<TrackedMdeEnvironmentsArrRelInsertInput>;
  trackedTenantEnvironments?: InputMaybe<TrackedTenantEnvironmentsArrRelInsertInput>;
  type?: InputMaybe<EnvironmentTypesEnum>;
};

/** order by max() on columns of table "environments" */
export type EnvironmentsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "environments" */
export type EnvironmentsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "environments" */
export type EnvironmentsMutationResponse = {
  __typename?: 'EnvironmentsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Environments>;
};

/** input type for inserting object relation for remote table "environments" */
export type EnvironmentsObjRelInsertInput = {
  data: EnvironmentsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EnvironmentsOnConflict>;
};

/** on_conflict condition type for table "environments" */
export type EnvironmentsOnConflict = {
  constraint: EnvironmentsConstraint;
  updateColumns?: Array<EnvironmentsUpdateColumn>;
  where?: InputMaybe<EnvironmentsBoolExp>;
};

/** Ordering options when selecting data from "environments". */
export type EnvironmentsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  datasourcesAggregate?: InputMaybe<DatasourcesAggregateOrderBy>;
  description?: InputMaybe<OrderBy>;
  googleSpreadsheetsAggregate?: InputMaybe<GoogleSpreadsheetsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  pgtunnelPortsAggregate?: InputMaybe<PgtunnelPortsAggregateOrderBy>;
  project?: InputMaybe<ProjectsOrderBy>;
  projectId?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  trackedMdeEnvironmentsAggregate?: InputMaybe<TrackedMdeEnvironmentsAggregateOrderBy>;
  trackedTenantEnvironmentsAggregate?: InputMaybe<TrackedTenantEnvironmentsAggregateOrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: environments */
export type EnvironmentsPkColumnsInput = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "environments" */
export enum EnvironmentsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  Slug = 'slug',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "environments" */
export type EnvironmentsSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['bigint']['input']>;
  type?: InputMaybe<EnvironmentTypesEnum>;
};

/** order by stddev() on columns of table "environments" */
export type EnvironmentsStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "environments" */
export type EnvironmentsStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "environments" */
export type EnvironmentsStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "environments" */
export type EnvironmentsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EnvironmentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EnvironmentsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['bigint']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnvironmentTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "environments" */
export type EnvironmentsSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
};

/** update columns of table "environments" */
export enum EnvironmentsUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  Type = 'type'
}

export type EnvironmentsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EnvironmentsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EnvironmentsSetInput>;
  /** filter the rows which have to be updated */
  where: EnvironmentsBoolExp;
};

/** order by varPop() on columns of table "environments" */
export type EnvironmentsVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "environments" */
export type EnvironmentsVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "environments" */
export type EnvironmentsVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "events" */
export type Events = {
  __typename?: 'Events';
  action: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deferredAt?: Maybe<Scalars['timestamptz']['output']>;
  details?: Maybe<Scalars['jsonb']['output']>;
  eventGroupId: Scalars['uuid']['output'];
  eventTime: Scalars['timestamptz']['output'];
  id: Scalars['bigint']['output'];
  origin: Scalars['String']['output'];
  type: Scalars['String']['output'];
};


/** columns and relationships of "events" */
export type EventsDetailsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "events". All fields are combined with a logical 'AND'. */
export type EventsBoolExp = {
  _and?: InputMaybe<Array<EventsBoolExp>>;
  _not?: InputMaybe<EventsBoolExp>;
  _or?: InputMaybe<Array<EventsBoolExp>>;
  action?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deferredAt?: InputMaybe<TimestamptzComparisonExp>;
  details?: InputMaybe<JsonbComparisonExp>;
  eventGroupId?: InputMaybe<UuidComparisonExp>;
  eventTime?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  origin?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
};

/** Ordering options when selecting data from "events". */
export type EventsOrderBy = {
  action?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deferredAt?: InputMaybe<OrderBy>;
  details?: InputMaybe<OrderBy>;
  eventGroupId?: InputMaybe<OrderBy>;
  eventTime?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  origin?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** select columns of table "events" */
export enum EventsSelectColumn {
  /** column name */
  Action = 'action',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeferredAt = 'deferredAt',
  /** column name */
  Details = 'details',
  /** column name */
  EventGroupId = 'eventGroupId',
  /** column name */
  EventTime = 'eventTime',
  /** column name */
  Id = 'id',
  /** column name */
  Origin = 'origin',
  /** column name */
  Type = 'type'
}

/** Streaming cursor of the table "events" */
export type EventsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventsStreamCursorValueInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deferredAt?: InputMaybe<Scalars['timestamptz']['input']>;
  details?: InputMaybe<Scalars['jsonb']['input']>;
  eventGroupId?: InputMaybe<Scalars['uuid']['input']>;
  eventTime?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FlywaySchemaHistory = {
  __typename?: 'FlywaySchemaHistory';
  checksum?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  executionTime?: Maybe<Scalars['Int']['output']>;
  installedBy?: Maybe<Scalars['String']['output']>;
  installedOn?: Maybe<Scalars['String']['output']>;
  installedRank?: Maybe<Scalars['Int']['output']>;
  script?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type GoogleDriveFolder = {
  __typename?: 'GoogleDriveFolder';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type GoogleOauth2CredsInput = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
};

export type GoogleOauth2TokensInput = {
  accessToken: Scalars['String']['input'];
  accessTokenExpiryDate: Scalars['String']['input'];
  refreshToken: Scalars['String']['input'];
  scopes: Array<Scalars['String']['input']>;
  tokenType: Scalars['String']['input'];
};

export type GoogleServiceAccountCredsInput = {
  auth_provider_x509_cert_url: Scalars['String']['input'];
  auth_uri: Scalars['String']['input'];
  client_email: Scalars['String']['input'];
  client_id: Scalars['String']['input'];
  client_x509_cert_url: Scalars['String']['input'];
  private_key: Scalars['String']['input'];
  private_key_id: Scalars['String']['input'];
  project_id: Scalars['String']['input'];
  token_uri: Scalars['String']['input'];
  type: Scalars['String']['input'];
  universe_domain: Scalars['String']['input'];
};

/** columns and relationships of "google_sheets" */
export type GoogleSheets = {
  __typename?: 'GoogleSheets';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  googleSpreadsheet: GoogleSpreadsheets;
  googleSpreadsheetId: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  lastSyncedAt?: Maybe<Scalars['timestamptz']['output']>;
  name: Scalars['String']['output'];
  /** An object relationship */
  project: Projects;
  projectId: Scalars['bigint']['output'];
  sheetId: Scalars['Int']['output'];
  /** An object relationship */
  tenant: Tenants;
  updatedAt: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "google_sheets" */
export type GoogleSheetsAggregateOrderBy = {
  avg?: InputMaybe<GoogleSheetsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<GoogleSheetsMaxOrderBy>;
  min?: InputMaybe<GoogleSheetsMinOrderBy>;
  stddev?: InputMaybe<GoogleSheetsStddevOrderBy>;
  stddevPop?: InputMaybe<GoogleSheetsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<GoogleSheetsStddevSampOrderBy>;
  sum?: InputMaybe<GoogleSheetsSumOrderBy>;
  varPop?: InputMaybe<GoogleSheetsVarPopOrderBy>;
  varSamp?: InputMaybe<GoogleSheetsVarSampOrderBy>;
  variance?: InputMaybe<GoogleSheetsVarianceOrderBy>;
};

/** order by avg() on columns of table "google_sheets" */
export type GoogleSheetsAvgOrderBy = {
  googleSpreadsheetId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  sheetId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "google_sheets". All fields are combined with a logical 'AND'. */
export type GoogleSheetsBoolExp = {
  _and?: InputMaybe<Array<GoogleSheetsBoolExp>>;
  _not?: InputMaybe<GoogleSheetsBoolExp>;
  _or?: InputMaybe<Array<GoogleSheetsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  googleSpreadsheet?: InputMaybe<GoogleSpreadsheetsBoolExp>;
  googleSpreadsheetId?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  lastSyncedAt?: InputMaybe<TimestamptzComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  project?: InputMaybe<ProjectsBoolExp>;
  projectId?: InputMaybe<BigintComparisonExp>;
  sheetId?: InputMaybe<IntComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** order by max() on columns of table "google_sheets" */
export type GoogleSheetsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  googleSpreadsheetId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastSyncedAt?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  sheetId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "google_sheets" */
export type GoogleSheetsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  googleSpreadsheetId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastSyncedAt?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  sheetId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "google_sheets". */
export type GoogleSheetsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  googleSpreadsheet?: InputMaybe<GoogleSpreadsheetsOrderBy>;
  googleSpreadsheetId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastSyncedAt?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  project?: InputMaybe<ProjectsOrderBy>;
  projectId?: InputMaybe<OrderBy>;
  sheetId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "google_sheets" */
export enum GoogleSheetsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  GoogleSpreadsheetId = 'googleSpreadsheetId',
  /** column name */
  Id = 'id',
  /** column name */
  LastSyncedAt = 'lastSyncedAt',
  /** column name */
  Name = 'name',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  SheetId = 'sheetId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** order by stddev() on columns of table "google_sheets" */
export type GoogleSheetsStddevOrderBy = {
  googleSpreadsheetId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  sheetId?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "google_sheets" */
export type GoogleSheetsStddevPopOrderBy = {
  googleSpreadsheetId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  sheetId?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "google_sheets" */
export type GoogleSheetsStddevSampOrderBy = {
  googleSpreadsheetId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  sheetId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "google_sheets" */
export type GoogleSheetsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GoogleSheetsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GoogleSheetsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  googleSpreadsheetId?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lastSyncedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['bigint']['input']>;
  sheetId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "google_sheets" */
export type GoogleSheetsSumOrderBy = {
  googleSpreadsheetId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  sheetId?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "google_sheets" */
export type GoogleSheetsVarPopOrderBy = {
  googleSpreadsheetId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  sheetId?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "google_sheets" */
export type GoogleSheetsVarSampOrderBy = {
  googleSpreadsheetId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  sheetId?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "google_sheets" */
export type GoogleSheetsVarianceOrderBy = {
  googleSpreadsheetId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  sheetId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "google_spreadsheet_overviews" */
export type GoogleSpreadsheetOverviews = {
  __typename?: 'GoogleSpreadsheetOverviews';
  /** An object relationship */
  environment: Environments;
  /** An object relationship */
  googleSpreadsheet?: Maybe<GoogleSpreadsheets>;
  /** An object relationship */
  trackedMde: TrackedMdes;
  /** An object relationship */
  trackedMdeEnvironment: TrackedMdeEnvironments;
  /** An object relationship */
  trackedTenant: TrackedTenants;
  /** An object relationship */
  trackedTenantEnvironment: TrackedTenantEnvironments;
};

/** Boolean expression to filter rows from the table "google_spreadsheet_overviews". All fields are combined with a logical 'AND'. */
export type GoogleSpreadsheetOverviewsBoolExp = {
  _and?: InputMaybe<Array<GoogleSpreadsheetOverviewsBoolExp>>;
  _not?: InputMaybe<GoogleSpreadsheetOverviewsBoolExp>;
  _or?: InputMaybe<Array<GoogleSpreadsheetOverviewsBoolExp>>;
  environment?: InputMaybe<EnvironmentsBoolExp>;
  googleSpreadsheet?: InputMaybe<GoogleSpreadsheetsBoolExp>;
  trackedMde?: InputMaybe<TrackedMdesBoolExp>;
  trackedMdeEnvironment?: InputMaybe<TrackedMdeEnvironmentsBoolExp>;
  trackedTenant?: InputMaybe<TrackedTenantsBoolExp>;
  trackedTenantEnvironment?: InputMaybe<TrackedTenantEnvironmentsBoolExp>;
};

/** Ordering options when selecting data from "google_spreadsheet_overviews". */
export type GoogleSpreadsheetOverviewsOrderBy = {
  environment?: InputMaybe<EnvironmentsOrderBy>;
  googleSpreadsheet?: InputMaybe<GoogleSpreadsheetsOrderBy>;
  trackedMde?: InputMaybe<TrackedMdesOrderBy>;
  trackedMdeEnvironment?: InputMaybe<TrackedMdeEnvironmentsOrderBy>;
  trackedTenant?: InputMaybe<TrackedTenantsOrderBy>;
  trackedTenantEnvironment?: InputMaybe<TrackedTenantEnvironmentsOrderBy>;
};

export type GoogleSpreadsheetReactFlow = {
  __typename?: 'GoogleSpreadsheetReactFlow';
  edges: Array<GoogleSpreadsheetReactFlowEdge>;
  nodes: Array<GoogleSpreadsheetReactFlowNode>;
  viewport: ReactFlowViewport;
};

export type GoogleSpreadsheetReactFlowEdge = {
  __typename?: 'GoogleSpreadsheetReactFlowEdge';
  animated?: Maybe<Scalars['Boolean']['output']>;
  data?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['String']['output'];
  markerEnd?: Maybe<GoogleSpreadsheetReactFlowEdgeMarker>;
  markerStart?: Maybe<GoogleSpreadsheetReactFlowEdgeMarker>;
  selected?: Maybe<Scalars['Boolean']['output']>;
  source: Scalars['String']['output'];
  target: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type GoogleSpreadsheetReactFlowEdgeInput = {
  animated?: InputMaybe<Scalars['Boolean']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id: Scalars['String']['input'];
  markerEnd?: InputMaybe<GoogleSpreadsheetReactFlowEdgeMarkerInput>;
  markerStart?: InputMaybe<GoogleSpreadsheetReactFlowEdgeMarkerInput>;
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  source: Scalars['String']['input'];
  target: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type GoogleSpreadsheetReactFlowEdgeMarker = {
  __typename?: 'GoogleSpreadsheetReactFlowEdgeMarker';
  color?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  markerUnits?: Maybe<Scalars['String']['output']>;
  orient?: Maybe<Scalars['String']['output']>;
  strokeWidth?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  width?: Maybe<Scalars['Float']['output']>;
};

export type GoogleSpreadsheetReactFlowEdgeMarkerInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  markerUnits?: InputMaybe<Scalars['String']['input']>;
  orient?: InputMaybe<Scalars['String']['input']>;
  strokeWidth?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type GoogleSpreadsheetReactFlowInput = {
  edges: Array<GoogleSpreadsheetReactFlowEdgeInput>;
  nodes: Array<GoogleSpreadsheetReactFlowNodeInput>;
  viewport: ReactFlowViewportInput;
};

export type GoogleSpreadsheetReactFlowNode = {
  __typename?: 'GoogleSpreadsheetReactFlowNode';
  data: Scalars['jsonb']['output'];
  deletable?: Maybe<Scalars['Boolean']['output']>;
  draggable?: Maybe<Scalars['Boolean']['output']>;
  dragging?: Maybe<Scalars['Boolean']['output']>;
  expandParent?: Maybe<Scalars['Boolean']['output']>;
  extent?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  parentNode?: Maybe<Scalars['String']['output']>;
  position: XyPosition;
  positionAbsolute?: Maybe<XyPosition>;
  selected?: Maybe<Scalars['Boolean']['output']>;
  style?: Maybe<Scalars['jsonb']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type GoogleSpreadsheetReactFlowNodeInput = {
  data: Scalars['jsonb']['input'];
  deletable?: InputMaybe<Scalars['Boolean']['input']>;
  draggable?: InputMaybe<Scalars['Boolean']['input']>;
  dragging?: InputMaybe<Scalars['Boolean']['input']>;
  expandParent?: InputMaybe<Scalars['Boolean']['input']>;
  extent?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  parentNode?: InputMaybe<Scalars['String']['input']>;
  position: XyPositionInput;
  positionAbsolute?: InputMaybe<XyPositionInput>;
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  style?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export enum GoogleSpreadsheetSyncStatesEnum {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Requested = 'REQUESTED'
}

/** Boolean expression to compare columns of type "GoogleSpreadsheetSyncStatesEnum". All fields are combined with logical 'AND'. */
export type GoogleSpreadsheetSyncStatesEnumComparisonExp = {
  _eq?: InputMaybe<GoogleSpreadsheetSyncStatesEnum>;
  _in?: InputMaybe<Array<GoogleSpreadsheetSyncStatesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<GoogleSpreadsheetSyncStatesEnum>;
  _nin?: InputMaybe<Array<GoogleSpreadsheetSyncStatesEnum>>;
};

export enum GoogleSpreadsheetSyncTypesEnum {
  DbToSheet = 'DB_TO_SHEET',
  SheetToDb = 'SHEET_TO_DB'
}

/** Boolean expression to compare columns of type "GoogleSpreadsheetSyncTypesEnum". All fields are combined with logical 'AND'. */
export type GoogleSpreadsheetSyncTypesEnumComparisonExp = {
  _eq?: InputMaybe<GoogleSpreadsheetSyncTypesEnum>;
  _in?: InputMaybe<Array<GoogleSpreadsheetSyncTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<GoogleSpreadsheetSyncTypesEnum>;
  _nin?: InputMaybe<Array<GoogleSpreadsheetSyncTypesEnum>>;
};

/** columns and relationships of "google_spreadsheet_syncs" */
export type GoogleSpreadsheetSyncs = {
  __typename?: 'GoogleSpreadsheetSyncs';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  datasource: Datasources;
  datasourceId: Scalars['bigint']['output'];
  finishedAt?: Maybe<Scalars['timestamptz']['output']>;
  flow: Scalars['jsonb']['output'];
  /** An object relationship */
  googleSpreadsheet: GoogleSpreadsheets;
  googleSpreadsheetId: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  requesterEmail?: Maybe<Scalars['String']['output']>;
  requesterUserId?: Maybe<Scalars['bigint']['output']>;
  state: GoogleSpreadsheetSyncStatesEnum;
  syncType: GoogleSpreadsheetSyncTypesEnum;
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['bigint']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
};


/** columns and relationships of "google_spreadsheet_syncs" */
export type GoogleSpreadsheetSyncsFlowArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "google_spreadsheet_syncs" */
export type GoogleSpreadsheetSyncsAggregate = {
  __typename?: 'GoogleSpreadsheetSyncsAggregate';
  aggregate?: Maybe<GoogleSpreadsheetSyncsAggregateFields>;
  nodes: Array<GoogleSpreadsheetSyncs>;
};

export type GoogleSpreadsheetSyncsAggregateBoolExp = {
  count?: InputMaybe<GoogleSpreadsheetSyncsAggregateBoolExpCount>;
};

/** aggregate fields of "google_spreadsheet_syncs" */
export type GoogleSpreadsheetSyncsAggregateFields = {
  __typename?: 'GoogleSpreadsheetSyncsAggregateFields';
  avg?: Maybe<GoogleSpreadsheetSyncsAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<GoogleSpreadsheetSyncsMaxFields>;
  min?: Maybe<GoogleSpreadsheetSyncsMinFields>;
  stddev?: Maybe<GoogleSpreadsheetSyncsStddevFields>;
  stddevPop?: Maybe<GoogleSpreadsheetSyncsStddevPopFields>;
  stddevSamp?: Maybe<GoogleSpreadsheetSyncsStddevSampFields>;
  sum?: Maybe<GoogleSpreadsheetSyncsSumFields>;
  varPop?: Maybe<GoogleSpreadsheetSyncsVarPopFields>;
  varSamp?: Maybe<GoogleSpreadsheetSyncsVarSampFields>;
  variance?: Maybe<GoogleSpreadsheetSyncsVarianceFields>;
};


/** aggregate fields of "google_spreadsheet_syncs" */
export type GoogleSpreadsheetSyncsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<GoogleSpreadsheetSyncsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "google_spreadsheet_syncs" */
export type GoogleSpreadsheetSyncsAggregateOrderBy = {
  avg?: InputMaybe<GoogleSpreadsheetSyncsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<GoogleSpreadsheetSyncsMaxOrderBy>;
  min?: InputMaybe<GoogleSpreadsheetSyncsMinOrderBy>;
  stddev?: InputMaybe<GoogleSpreadsheetSyncsStddevOrderBy>;
  stddevPop?: InputMaybe<GoogleSpreadsheetSyncsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<GoogleSpreadsheetSyncsStddevSampOrderBy>;
  sum?: InputMaybe<GoogleSpreadsheetSyncsSumOrderBy>;
  varPop?: InputMaybe<GoogleSpreadsheetSyncsVarPopOrderBy>;
  varSamp?: InputMaybe<GoogleSpreadsheetSyncsVarSampOrderBy>;
  variance?: InputMaybe<GoogleSpreadsheetSyncsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type GoogleSpreadsheetSyncsAvgFields = {
  __typename?: 'GoogleSpreadsheetSyncsAvgFields';
  datasourceId?: Maybe<Scalars['Float']['output']>;
  googleSpreadsheetId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  requesterUserId?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "google_spreadsheet_syncs" */
export type GoogleSpreadsheetSyncsAvgOrderBy = {
  datasourceId?: InputMaybe<OrderBy>;
  googleSpreadsheetId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requesterUserId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "google_spreadsheet_syncs". All fields are combined with a logical 'AND'. */
export type GoogleSpreadsheetSyncsBoolExp = {
  _and?: InputMaybe<Array<GoogleSpreadsheetSyncsBoolExp>>;
  _not?: InputMaybe<GoogleSpreadsheetSyncsBoolExp>;
  _or?: InputMaybe<Array<GoogleSpreadsheetSyncsBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  datasource?: InputMaybe<DatasourcesBoolExp>;
  datasourceId?: InputMaybe<BigintComparisonExp>;
  finishedAt?: InputMaybe<TimestamptzComparisonExp>;
  flow?: InputMaybe<JsonbComparisonExp>;
  googleSpreadsheet?: InputMaybe<GoogleSpreadsheetsBoolExp>;
  googleSpreadsheetId?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  requesterEmail?: InputMaybe<StringComparisonExp>;
  requesterUserId?: InputMaybe<BigintComparisonExp>;
  state?: InputMaybe<GoogleSpreadsheetSyncStatesEnumComparisonExp>;
  syncType?: InputMaybe<GoogleSpreadsheetSyncTypesEnumComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<BigintComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
};

/** aggregate max on columns */
export type GoogleSpreadsheetSyncsMaxFields = {
  __typename?: 'GoogleSpreadsheetSyncsMaxFields';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  datasourceId?: Maybe<Scalars['bigint']['output']>;
  finishedAt?: Maybe<Scalars['timestamptz']['output']>;
  googleSpreadsheetId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  requesterEmail?: Maybe<Scalars['String']['output']>;
  requesterUserId?: Maybe<Scalars['bigint']['output']>;
  tenantId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "google_spreadsheet_syncs" */
export type GoogleSpreadsheetSyncsMaxOrderBy = {
  comment?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  datasourceId?: InputMaybe<OrderBy>;
  finishedAt?: InputMaybe<OrderBy>;
  googleSpreadsheetId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requesterEmail?: InputMaybe<OrderBy>;
  requesterUserId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type GoogleSpreadsheetSyncsMinFields = {
  __typename?: 'GoogleSpreadsheetSyncsMinFields';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  datasourceId?: Maybe<Scalars['bigint']['output']>;
  finishedAt?: Maybe<Scalars['timestamptz']['output']>;
  googleSpreadsheetId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  requesterEmail?: Maybe<Scalars['String']['output']>;
  requesterUserId?: Maybe<Scalars['bigint']['output']>;
  tenantId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "google_spreadsheet_syncs" */
export type GoogleSpreadsheetSyncsMinOrderBy = {
  comment?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  datasourceId?: InputMaybe<OrderBy>;
  finishedAt?: InputMaybe<OrderBy>;
  googleSpreadsheetId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requesterEmail?: InputMaybe<OrderBy>;
  requesterUserId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "google_spreadsheet_syncs". */
export type GoogleSpreadsheetSyncsOrderBy = {
  comment?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  datasource?: InputMaybe<DatasourcesOrderBy>;
  datasourceId?: InputMaybe<OrderBy>;
  finishedAt?: InputMaybe<OrderBy>;
  flow?: InputMaybe<OrderBy>;
  googleSpreadsheet?: InputMaybe<GoogleSpreadsheetsOrderBy>;
  googleSpreadsheetId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requesterEmail?: InputMaybe<OrderBy>;
  requesterUserId?: InputMaybe<OrderBy>;
  state?: InputMaybe<OrderBy>;
  syncType?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
};

/** select columns of table "google_spreadsheet_syncs" */
export enum GoogleSpreadsheetSyncsSelectColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DatasourceId = 'datasourceId',
  /** column name */
  FinishedAt = 'finishedAt',
  /** column name */
  Flow = 'flow',
  /** column name */
  GoogleSpreadsheetId = 'googleSpreadsheetId',
  /** column name */
  Id = 'id',
  /** column name */
  RequesterEmail = 'requesterEmail',
  /** column name */
  RequesterUserId = 'requesterUserId',
  /** column name */
  State = 'state',
  /** column name */
  SyncType = 'syncType',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** aggregate stddev on columns */
export type GoogleSpreadsheetSyncsStddevFields = {
  __typename?: 'GoogleSpreadsheetSyncsStddevFields';
  datasourceId?: Maybe<Scalars['Float']['output']>;
  googleSpreadsheetId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  requesterUserId?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "google_spreadsheet_syncs" */
export type GoogleSpreadsheetSyncsStddevOrderBy = {
  datasourceId?: InputMaybe<OrderBy>;
  googleSpreadsheetId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requesterUserId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type GoogleSpreadsheetSyncsStddevPopFields = {
  __typename?: 'GoogleSpreadsheetSyncsStddevPopFields';
  datasourceId?: Maybe<Scalars['Float']['output']>;
  googleSpreadsheetId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  requesterUserId?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevPop() on columns of table "google_spreadsheet_syncs" */
export type GoogleSpreadsheetSyncsStddevPopOrderBy = {
  datasourceId?: InputMaybe<OrderBy>;
  googleSpreadsheetId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requesterUserId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type GoogleSpreadsheetSyncsStddevSampFields = {
  __typename?: 'GoogleSpreadsheetSyncsStddevSampFields';
  datasourceId?: Maybe<Scalars['Float']['output']>;
  googleSpreadsheetId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  requesterUserId?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevSamp() on columns of table "google_spreadsheet_syncs" */
export type GoogleSpreadsheetSyncsStddevSampOrderBy = {
  datasourceId?: InputMaybe<OrderBy>;
  googleSpreadsheetId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requesterUserId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "google_spreadsheet_syncs" */
export type GoogleSpreadsheetSyncsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GoogleSpreadsheetSyncsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GoogleSpreadsheetSyncsStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  datasourceId?: InputMaybe<Scalars['bigint']['input']>;
  finishedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  flow?: InputMaybe<Scalars['jsonb']['input']>;
  googleSpreadsheetId?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  requesterEmail?: InputMaybe<Scalars['String']['input']>;
  requesterUserId?: InputMaybe<Scalars['bigint']['input']>;
  state?: InputMaybe<GoogleSpreadsheetSyncStatesEnum>;
  syncType?: InputMaybe<GoogleSpreadsheetSyncTypesEnum>;
  tenantId?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type GoogleSpreadsheetSyncsSumFields = {
  __typename?: 'GoogleSpreadsheetSyncsSumFields';
  datasourceId?: Maybe<Scalars['bigint']['output']>;
  googleSpreadsheetId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  requesterUserId?: Maybe<Scalars['bigint']['output']>;
  tenantId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "google_spreadsheet_syncs" */
export type GoogleSpreadsheetSyncsSumOrderBy = {
  datasourceId?: InputMaybe<OrderBy>;
  googleSpreadsheetId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requesterUserId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** aggregate varPop on columns */
export type GoogleSpreadsheetSyncsVarPopFields = {
  __typename?: 'GoogleSpreadsheetSyncsVarPopFields';
  datasourceId?: Maybe<Scalars['Float']['output']>;
  googleSpreadsheetId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  requesterUserId?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['Float']['output']>;
};

/** order by varPop() on columns of table "google_spreadsheet_syncs" */
export type GoogleSpreadsheetSyncsVarPopOrderBy = {
  datasourceId?: InputMaybe<OrderBy>;
  googleSpreadsheetId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requesterUserId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type GoogleSpreadsheetSyncsVarSampFields = {
  __typename?: 'GoogleSpreadsheetSyncsVarSampFields';
  datasourceId?: Maybe<Scalars['Float']['output']>;
  googleSpreadsheetId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  requesterUserId?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['Float']['output']>;
};

/** order by varSamp() on columns of table "google_spreadsheet_syncs" */
export type GoogleSpreadsheetSyncsVarSampOrderBy = {
  datasourceId?: InputMaybe<OrderBy>;
  googleSpreadsheetId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requesterUserId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type GoogleSpreadsheetSyncsVarianceFields = {
  __typename?: 'GoogleSpreadsheetSyncsVarianceFields';
  datasourceId?: Maybe<Scalars['Float']['output']>;
  googleSpreadsheetId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  requesterUserId?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "google_spreadsheet_syncs" */
export type GoogleSpreadsheetSyncsVarianceOrderBy = {
  datasourceId?: InputMaybe<OrderBy>;
  googleSpreadsheetId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requesterUserId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "google_spreadsheets" */
export type GoogleSpreadsheets = {
  __typename?: 'GoogleSpreadsheets';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  environment: Environments;
  environmentId: Scalars['bigint']['output'];
  googleScriptId: Scalars['String']['output'];
  /** An array relationship */
  googleSheets: Array<GoogleSheets>;
  /** An array relationship */
  googleSpreadsheetSyncs: Array<GoogleSpreadsheetSyncs>;
  /** An aggregate relationship */
  googleSpreadsheetSyncsAggregate: GoogleSpreadsheetSyncsAggregate;
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  project: Projects;
  projectId: Scalars['bigint']['output'];
  /** An object relationship */
  readonlyDatasource?: Maybe<Datasources>;
  readonlyDatasourceId?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  rwDatasource?: Maybe<Datasources>;
  rwDatasourceId?: Maybe<Scalars['bigint']['output']>;
  spreadsheetId: Scalars['String']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['bigint']['output'];
  /** An object relationship */
  trackedMde: TrackedMdes;
  trackedMdeId: Scalars['bigint']['output'];
  /** An object relationship */
  trackedTenant: TrackedTenants;
  trackedTenantId: Scalars['bigint']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "google_spreadsheets" */
export type GoogleSpreadsheetsGoogleSheetsArgs = {
  distinctOn?: InputMaybe<Array<GoogleSheetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSheetsOrderBy>>;
  where?: InputMaybe<GoogleSheetsBoolExp>;
};


/** columns and relationships of "google_spreadsheets" */
export type GoogleSpreadsheetsGoogleSpreadsheetSyncsArgs = {
  distinctOn?: InputMaybe<Array<GoogleSpreadsheetSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSpreadsheetSyncsOrderBy>>;
  where?: InputMaybe<GoogleSpreadsheetSyncsBoolExp>;
};


/** columns and relationships of "google_spreadsheets" */
export type GoogleSpreadsheetsGoogleSpreadsheetSyncsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GoogleSpreadsheetSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSpreadsheetSyncsOrderBy>>;
  where?: InputMaybe<GoogleSpreadsheetSyncsBoolExp>;
};

/** aggregated selection of "google_spreadsheets" */
export type GoogleSpreadsheetsAggregate = {
  __typename?: 'GoogleSpreadsheetsAggregate';
  aggregate?: Maybe<GoogleSpreadsheetsAggregateFields>;
  nodes: Array<GoogleSpreadsheets>;
};

export type GoogleSpreadsheetsAggregateBoolExp = {
  count?: InputMaybe<GoogleSpreadsheetsAggregateBoolExpCount>;
};

/** aggregate fields of "google_spreadsheets" */
export type GoogleSpreadsheetsAggregateFields = {
  __typename?: 'GoogleSpreadsheetsAggregateFields';
  avg?: Maybe<GoogleSpreadsheetsAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<GoogleSpreadsheetsMaxFields>;
  min?: Maybe<GoogleSpreadsheetsMinFields>;
  stddev?: Maybe<GoogleSpreadsheetsStddevFields>;
  stddevPop?: Maybe<GoogleSpreadsheetsStddevPopFields>;
  stddevSamp?: Maybe<GoogleSpreadsheetsStddevSampFields>;
  sum?: Maybe<GoogleSpreadsheetsSumFields>;
  varPop?: Maybe<GoogleSpreadsheetsVarPopFields>;
  varSamp?: Maybe<GoogleSpreadsheetsVarSampFields>;
  variance?: Maybe<GoogleSpreadsheetsVarianceFields>;
};


/** aggregate fields of "google_spreadsheets" */
export type GoogleSpreadsheetsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<GoogleSpreadsheetsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "google_spreadsheets" */
export type GoogleSpreadsheetsAggregateOrderBy = {
  avg?: InputMaybe<GoogleSpreadsheetsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<GoogleSpreadsheetsMaxOrderBy>;
  min?: InputMaybe<GoogleSpreadsheetsMinOrderBy>;
  stddev?: InputMaybe<GoogleSpreadsheetsStddevOrderBy>;
  stddevPop?: InputMaybe<GoogleSpreadsheetsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<GoogleSpreadsheetsStddevSampOrderBy>;
  sum?: InputMaybe<GoogleSpreadsheetsSumOrderBy>;
  varPop?: InputMaybe<GoogleSpreadsheetsVarPopOrderBy>;
  varSamp?: InputMaybe<GoogleSpreadsheetsVarSampOrderBy>;
  variance?: InputMaybe<GoogleSpreadsheetsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type GoogleSpreadsheetsAvgFields = {
  __typename?: 'GoogleSpreadsheetsAvgFields';
  environmentId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  projectId?: Maybe<Scalars['Float']['output']>;
  readonlyDatasourceId?: Maybe<Scalars['Float']['output']>;
  rwDatasourceId?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['Float']['output']>;
  trackedMdeId?: Maybe<Scalars['Float']['output']>;
  trackedTenantId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "google_spreadsheets" */
export type GoogleSpreadsheetsAvgOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  readonlyDatasourceId?: InputMaybe<OrderBy>;
  rwDatasourceId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  trackedMdeId?: InputMaybe<OrderBy>;
  trackedTenantId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "google_spreadsheets". All fields are combined with a logical 'AND'. */
export type GoogleSpreadsheetsBoolExp = {
  _and?: InputMaybe<Array<GoogleSpreadsheetsBoolExp>>;
  _not?: InputMaybe<GoogleSpreadsheetsBoolExp>;
  _or?: InputMaybe<Array<GoogleSpreadsheetsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  environment?: InputMaybe<EnvironmentsBoolExp>;
  environmentId?: InputMaybe<BigintComparisonExp>;
  googleScriptId?: InputMaybe<StringComparisonExp>;
  googleSheets?: InputMaybe<GoogleSheetsBoolExp>;
  googleSpreadsheetSyncs?: InputMaybe<GoogleSpreadsheetSyncsBoolExp>;
  googleSpreadsheetSyncsAggregate?: InputMaybe<GoogleSpreadsheetSyncsAggregateBoolExp>;
  id?: InputMaybe<BigintComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  project?: InputMaybe<ProjectsBoolExp>;
  projectId?: InputMaybe<BigintComparisonExp>;
  readonlyDatasource?: InputMaybe<DatasourcesBoolExp>;
  readonlyDatasourceId?: InputMaybe<BigintComparisonExp>;
  rwDatasource?: InputMaybe<DatasourcesBoolExp>;
  rwDatasourceId?: InputMaybe<BigintComparisonExp>;
  spreadsheetId?: InputMaybe<StringComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<BigintComparisonExp>;
  trackedMde?: InputMaybe<TrackedMdesBoolExp>;
  trackedMdeId?: InputMaybe<BigintComparisonExp>;
  trackedTenant?: InputMaybe<TrackedTenantsBoolExp>;
  trackedTenantId?: InputMaybe<BigintComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** aggregate max on columns */
export type GoogleSpreadsheetsMaxFields = {
  __typename?: 'GoogleSpreadsheetsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  environmentId?: Maybe<Scalars['bigint']['output']>;
  googleScriptId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['bigint']['output']>;
  readonlyDatasourceId?: Maybe<Scalars['bigint']['output']>;
  rwDatasourceId?: Maybe<Scalars['bigint']['output']>;
  spreadsheetId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['bigint']['output']>;
  trackedMdeId?: Maybe<Scalars['bigint']['output']>;
  trackedTenantId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "google_spreadsheets" */
export type GoogleSpreadsheetsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  environmentId?: InputMaybe<OrderBy>;
  googleScriptId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  readonlyDatasourceId?: InputMaybe<OrderBy>;
  rwDatasourceId?: InputMaybe<OrderBy>;
  spreadsheetId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  trackedMdeId?: InputMaybe<OrderBy>;
  trackedTenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type GoogleSpreadsheetsMinFields = {
  __typename?: 'GoogleSpreadsheetsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  environmentId?: Maybe<Scalars['bigint']['output']>;
  googleScriptId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['bigint']['output']>;
  readonlyDatasourceId?: Maybe<Scalars['bigint']['output']>;
  rwDatasourceId?: Maybe<Scalars['bigint']['output']>;
  spreadsheetId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['bigint']['output']>;
  trackedMdeId?: Maybe<Scalars['bigint']['output']>;
  trackedTenantId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "google_spreadsheets" */
export type GoogleSpreadsheetsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  environmentId?: InputMaybe<OrderBy>;
  googleScriptId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  readonlyDatasourceId?: InputMaybe<OrderBy>;
  rwDatasourceId?: InputMaybe<OrderBy>;
  spreadsheetId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  trackedMdeId?: InputMaybe<OrderBy>;
  trackedTenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "google_spreadsheets". */
export type GoogleSpreadsheetsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  environment?: InputMaybe<EnvironmentsOrderBy>;
  environmentId?: InputMaybe<OrderBy>;
  googleScriptId?: InputMaybe<OrderBy>;
  googleSheetsAggregate?: InputMaybe<GoogleSheetsAggregateOrderBy>;
  googleSpreadsheetSyncsAggregate?: InputMaybe<GoogleSpreadsheetSyncsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  project?: InputMaybe<ProjectsOrderBy>;
  projectId?: InputMaybe<OrderBy>;
  readonlyDatasource?: InputMaybe<DatasourcesOrderBy>;
  readonlyDatasourceId?: InputMaybe<OrderBy>;
  rwDatasource?: InputMaybe<DatasourcesOrderBy>;
  rwDatasourceId?: InputMaybe<OrderBy>;
  spreadsheetId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  trackedMde?: InputMaybe<TrackedMdesOrderBy>;
  trackedMdeId?: InputMaybe<OrderBy>;
  trackedTenant?: InputMaybe<TrackedTenantsOrderBy>;
  trackedTenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "google_spreadsheets" */
export enum GoogleSpreadsheetsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EnvironmentId = 'environmentId',
  /** column name */
  GoogleScriptId = 'googleScriptId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  ReadonlyDatasourceId = 'readonlyDatasourceId',
  /** column name */
  RwDatasourceId = 'rwDatasourceId',
  /** column name */
  SpreadsheetId = 'spreadsheetId',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  TrackedMdeId = 'trackedMdeId',
  /** column name */
  TrackedTenantId = 'trackedTenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** aggregate stddev on columns */
export type GoogleSpreadsheetsStddevFields = {
  __typename?: 'GoogleSpreadsheetsStddevFields';
  environmentId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  projectId?: Maybe<Scalars['Float']['output']>;
  readonlyDatasourceId?: Maybe<Scalars['Float']['output']>;
  rwDatasourceId?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['Float']['output']>;
  trackedMdeId?: Maybe<Scalars['Float']['output']>;
  trackedTenantId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "google_spreadsheets" */
export type GoogleSpreadsheetsStddevOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  readonlyDatasourceId?: InputMaybe<OrderBy>;
  rwDatasourceId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  trackedMdeId?: InputMaybe<OrderBy>;
  trackedTenantId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type GoogleSpreadsheetsStddevPopFields = {
  __typename?: 'GoogleSpreadsheetsStddevPopFields';
  environmentId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  projectId?: Maybe<Scalars['Float']['output']>;
  readonlyDatasourceId?: Maybe<Scalars['Float']['output']>;
  rwDatasourceId?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['Float']['output']>;
  trackedMdeId?: Maybe<Scalars['Float']['output']>;
  trackedTenantId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevPop() on columns of table "google_spreadsheets" */
export type GoogleSpreadsheetsStddevPopOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  readonlyDatasourceId?: InputMaybe<OrderBy>;
  rwDatasourceId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  trackedMdeId?: InputMaybe<OrderBy>;
  trackedTenantId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type GoogleSpreadsheetsStddevSampFields = {
  __typename?: 'GoogleSpreadsheetsStddevSampFields';
  environmentId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  projectId?: Maybe<Scalars['Float']['output']>;
  readonlyDatasourceId?: Maybe<Scalars['Float']['output']>;
  rwDatasourceId?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['Float']['output']>;
  trackedMdeId?: Maybe<Scalars['Float']['output']>;
  trackedTenantId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevSamp() on columns of table "google_spreadsheets" */
export type GoogleSpreadsheetsStddevSampOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  readonlyDatasourceId?: InputMaybe<OrderBy>;
  rwDatasourceId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  trackedMdeId?: InputMaybe<OrderBy>;
  trackedTenantId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "google_spreadsheets" */
export type GoogleSpreadsheetsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GoogleSpreadsheetsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GoogleSpreadsheetsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  environmentId?: InputMaybe<Scalars['bigint']['input']>;
  googleScriptId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['bigint']['input']>;
  readonlyDatasourceId?: InputMaybe<Scalars['bigint']['input']>;
  rwDatasourceId?: InputMaybe<Scalars['bigint']['input']>;
  spreadsheetId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['bigint']['input']>;
  trackedMdeId?: InputMaybe<Scalars['bigint']['input']>;
  trackedTenantId?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type GoogleSpreadsheetsSumFields = {
  __typename?: 'GoogleSpreadsheetsSumFields';
  environmentId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  projectId?: Maybe<Scalars['bigint']['output']>;
  readonlyDatasourceId?: Maybe<Scalars['bigint']['output']>;
  rwDatasourceId?: Maybe<Scalars['bigint']['output']>;
  tenantId?: Maybe<Scalars['bigint']['output']>;
  trackedMdeId?: Maybe<Scalars['bigint']['output']>;
  trackedTenantId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "google_spreadsheets" */
export type GoogleSpreadsheetsSumOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  readonlyDatasourceId?: InputMaybe<OrderBy>;
  rwDatasourceId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  trackedMdeId?: InputMaybe<OrderBy>;
  trackedTenantId?: InputMaybe<OrderBy>;
};

/** aggregate varPop on columns */
export type GoogleSpreadsheetsVarPopFields = {
  __typename?: 'GoogleSpreadsheetsVarPopFields';
  environmentId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  projectId?: Maybe<Scalars['Float']['output']>;
  readonlyDatasourceId?: Maybe<Scalars['Float']['output']>;
  rwDatasourceId?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['Float']['output']>;
  trackedMdeId?: Maybe<Scalars['Float']['output']>;
  trackedTenantId?: Maybe<Scalars['Float']['output']>;
};

/** order by varPop() on columns of table "google_spreadsheets" */
export type GoogleSpreadsheetsVarPopOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  readonlyDatasourceId?: InputMaybe<OrderBy>;
  rwDatasourceId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  trackedMdeId?: InputMaybe<OrderBy>;
  trackedTenantId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type GoogleSpreadsheetsVarSampFields = {
  __typename?: 'GoogleSpreadsheetsVarSampFields';
  environmentId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  projectId?: Maybe<Scalars['Float']['output']>;
  readonlyDatasourceId?: Maybe<Scalars['Float']['output']>;
  rwDatasourceId?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['Float']['output']>;
  trackedMdeId?: Maybe<Scalars['Float']['output']>;
  trackedTenantId?: Maybe<Scalars['Float']['output']>;
};

/** order by varSamp() on columns of table "google_spreadsheets" */
export type GoogleSpreadsheetsVarSampOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  readonlyDatasourceId?: InputMaybe<OrderBy>;
  rwDatasourceId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  trackedMdeId?: InputMaybe<OrderBy>;
  trackedTenantId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type GoogleSpreadsheetsVarianceFields = {
  __typename?: 'GoogleSpreadsheetsVarianceFields';
  environmentId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  projectId?: Maybe<Scalars['Float']['output']>;
  readonlyDatasourceId?: Maybe<Scalars['Float']['output']>;
  rwDatasourceId?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['Float']['output']>;
  trackedMdeId?: Maybe<Scalars['Float']['output']>;
  trackedTenantId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "google_spreadsheets" */
export type GoogleSpreadsheetsVarianceOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  readonlyDatasourceId?: InputMaybe<OrderBy>;
  rwDatasourceId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  trackedMdeId?: InputMaybe<OrderBy>;
  trackedTenantId?: InputMaybe<OrderBy>;
};

export type ImportFromGoogleSpreadsheetResult = {
  __typename?: 'ImportFromGoogleSpreadsheetResult';
  success: Scalars['Boolean']['output'];
};

export type InferGoogleSpreadsheetResult = {
  __typename?: 'InferGoogleSpreadsheetResult';
  flow?: Maybe<GoogleSpreadsheetReactFlow>;
  mdeViewSql: Scalars['String']['output'];
  relatedDatasourceSMOIds: Array<Maybe<Scalars['String']['output']>>;
  relatedDatasourceSMOs: Array<InferredRelatedDatasourceSmo>;
};

export type InferMdeCandidatesResult = {
  __typename?: 'InferMDECandidatesResult';
  candidates: Array<MdeCandidate>;
};

export type InferredRelatedDatasourceSmo = {
  __typename?: 'InferredRelatedDatasourceSMO';
  datasourceSmo?: Maybe<DatasourceSchemaMetadataOverview>;
  id: Scalars['String']['output'];
  index?: Maybe<Scalars['Int']['output']>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type IntComparisonExp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type JsonbCastExp = {
  String?: InputMaybe<StringComparisonExp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type JsonbComparisonExp = {
  _cast?: InputMaybe<JsonbCastExp>;
  /** is the column contained in the given json value */
  _containedIn?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _hasKey?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _hasKeysAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _hasKeysAny?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

export type MdeCandidate = {
  __typename?: 'MDECandidate';
  dependencies: Array<Scalars['String']['output']>;
  depth: Scalars['Int']['output'];
  naturalKeyConstraintAst: Scalars['JSON']['output'];
  neededBy: Array<Scalars['String']['output']>;
  schema: Scalars['String']['output'];
  tableClusterId: Scalars['String']['output'];
  tableName: Scalars['String']['output'];
};

export type MutationOrder = {
  __typename?: 'MutationOrder';
  columns: Array<Scalars['String']['output']>;
  returningColumns: Array<Scalars['String']['output']>;
  table: PostgresTable;
  type: Scalars['String']['output'];
};

/** column ordering options */
export enum OrderBy {
  /** in ascending order, nulls last */
  Asc = 'ASC',
  /** in ascending order, nulls first */
  AscNullsFirst = 'ASC_NULLS_FIRST',
  /** in ascending order, nulls last */
  AscNullsLast = 'ASC_NULLS_LAST',
  /** in descending order, nulls first */
  Desc = 'DESC',
  /** in descending order, nulls first */
  DescNullsFirst = 'DESC_NULLS_FIRST',
  /** in descending order, nulls last */
  DescNullsLast = 'DESC_NULLS_LAST'
}

/** columns and relationships of "pgtunnel_ports" */
export type PgtunnelPorts = {
  __typename?: 'PgtunnelPorts';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  environment?: Maybe<Environments>;
  environmentId?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['bigint']['output'];
  port: Scalars['Int']['output'];
  token: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "pgtunnel_ports" */
export type PgtunnelPortsAggregateOrderBy = {
  avg?: InputMaybe<PgtunnelPortsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PgtunnelPortsMaxOrderBy>;
  min?: InputMaybe<PgtunnelPortsMinOrderBy>;
  stddev?: InputMaybe<PgtunnelPortsStddevOrderBy>;
  stddevPop?: InputMaybe<PgtunnelPortsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<PgtunnelPortsStddevSampOrderBy>;
  sum?: InputMaybe<PgtunnelPortsSumOrderBy>;
  varPop?: InputMaybe<PgtunnelPortsVarPopOrderBy>;
  varSamp?: InputMaybe<PgtunnelPortsVarSampOrderBy>;
  variance?: InputMaybe<PgtunnelPortsVarianceOrderBy>;
};

/** order by avg() on columns of table "pgtunnel_ports" */
export type PgtunnelPortsAvgOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  port?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "pgtunnel_ports". All fields are combined with a logical 'AND'. */
export type PgtunnelPortsBoolExp = {
  _and?: InputMaybe<Array<PgtunnelPortsBoolExp>>;
  _not?: InputMaybe<PgtunnelPortsBoolExp>;
  _or?: InputMaybe<Array<PgtunnelPortsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  environment?: InputMaybe<EnvironmentsBoolExp>;
  environmentId?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  port?: InputMaybe<IntComparisonExp>;
  token?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** order by max() on columns of table "pgtunnel_ports" */
export type PgtunnelPortsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  port?: InputMaybe<OrderBy>;
  token?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "pgtunnel_ports" */
export type PgtunnelPortsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  port?: InputMaybe<OrderBy>;
  token?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "pgtunnel_ports". */
export type PgtunnelPortsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  environment?: InputMaybe<EnvironmentsOrderBy>;
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  port?: InputMaybe<OrderBy>;
  token?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "pgtunnel_ports" */
export enum PgtunnelPortsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EnvironmentId = 'environmentId',
  /** column name */
  Id = 'id',
  /** column name */
  Port = 'port',
  /** column name */
  Token = 'token',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** order by stddev() on columns of table "pgtunnel_ports" */
export type PgtunnelPortsStddevOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  port?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "pgtunnel_ports" */
export type PgtunnelPortsStddevPopOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  port?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "pgtunnel_ports" */
export type PgtunnelPortsStddevSampOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  port?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "pgtunnel_ports" */
export type PgtunnelPortsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PgtunnelPortsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PgtunnelPortsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  environmentId?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "pgtunnel_ports" */
export type PgtunnelPortsSumOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  port?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "pgtunnel_ports" */
export type PgtunnelPortsVarPopOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  port?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "pgtunnel_ports" */
export type PgtunnelPortsVarSampOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  port?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "pgtunnel_ports" */
export type PgtunnelPortsVarianceOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  port?: InputMaybe<OrderBy>;
};

export type PostgresEnvironmentSyncPreview = {
  __typename?: 'PostgresEnvironmentSyncPreview';
  d2LODSvgs: Array<D2LodSvg>;
  d2Svg: Scalars['String']['output'];
  d2Text: Scalars['String']['output'];
  flow: GoogleSpreadsheetReactFlow;
  recordCount: Scalars['Int']['output'];
  sourceMDEs: RemoteReadMdeResult;
  targetMDEs: RemoteReadMdeResult;
};

export type PostgresEnvironmentSyncResult = {
  __typename?: 'PostgresEnvironmentSyncResult';
  dataMigration: DataMigration;
  syncDurationSeconds: Scalars['Int']['output'];
  syncedTotalMegabytes: Scalars['Int']['output'];
  syncedTotalRecords: Scalars['Int']['output'];
};

export type PostgresTable = {
  __typename?: 'PostgresTable';
  name: Scalars['String']['output'];
  schema: Scalars['String']['output'];
};

/** columns and relationships of "projects" */
export type Projects = {
  __typename?: 'Projects';
  createdAt: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  environments: Array<Environments>;
  googleDriveFolderId?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  googleSheets: Array<GoogleSheets>;
  /** An array relationship */
  googleSpreadsheets: Array<GoogleSpreadsheets>;
  /** An aggregate relationship */
  googleSpreadsheetsAggregate: GoogleSpreadsheetsAggregate;
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['bigint']['output'];
  /** An array relationship */
  trackedMdes: Array<TrackedMdes>;
  /** An array relationship */
  trackedTenants: Array<TrackedTenants>;
  /** An aggregate relationship */
  trackedTenantsAggregate: TrackedTenantsAggregate;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "projects" */
export type ProjectsEnvironmentsArgs = {
  distinctOn?: InputMaybe<Array<EnvironmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EnvironmentsOrderBy>>;
  where?: InputMaybe<EnvironmentsBoolExp>;
};


/** columns and relationships of "projects" */
export type ProjectsGoogleSheetsArgs = {
  distinctOn?: InputMaybe<Array<GoogleSheetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSheetsOrderBy>>;
  where?: InputMaybe<GoogleSheetsBoolExp>;
};


/** columns and relationships of "projects" */
export type ProjectsGoogleSpreadsheetsArgs = {
  distinctOn?: InputMaybe<Array<GoogleSpreadsheetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSpreadsheetsOrderBy>>;
  where?: InputMaybe<GoogleSpreadsheetsBoolExp>;
};


/** columns and relationships of "projects" */
export type ProjectsGoogleSpreadsheetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GoogleSpreadsheetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSpreadsheetsOrderBy>>;
  where?: InputMaybe<GoogleSpreadsheetsBoolExp>;
};


/** columns and relationships of "projects" */
export type ProjectsTrackedMdesArgs = {
  distinctOn?: InputMaybe<Array<TrackedMdesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrackedMdesOrderBy>>;
  where?: InputMaybe<TrackedMdesBoolExp>;
};


/** columns and relationships of "projects" */
export type ProjectsTrackedTenantsArgs = {
  distinctOn?: InputMaybe<Array<TrackedTenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrackedTenantsOrderBy>>;
  where?: InputMaybe<TrackedTenantsBoolExp>;
};


/** columns and relationships of "projects" */
export type ProjectsTrackedTenantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TrackedTenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrackedTenantsOrderBy>>;
  where?: InputMaybe<TrackedTenantsBoolExp>;
};

/** order by aggregate values of table "projects" */
export type ProjectsAggregateOrderBy = {
  avg?: InputMaybe<ProjectsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ProjectsMaxOrderBy>;
  min?: InputMaybe<ProjectsMinOrderBy>;
  stddev?: InputMaybe<ProjectsStddevOrderBy>;
  stddevPop?: InputMaybe<ProjectsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<ProjectsStddevSampOrderBy>;
  sum?: InputMaybe<ProjectsSumOrderBy>;
  varPop?: InputMaybe<ProjectsVarPopOrderBy>;
  varSamp?: InputMaybe<ProjectsVarSampOrderBy>;
  variance?: InputMaybe<ProjectsVarianceOrderBy>;
};

/** order by avg() on columns of table "projects" */
export type ProjectsAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "projects". All fields are combined with a logical 'AND'. */
export type ProjectsBoolExp = {
  _and?: InputMaybe<Array<ProjectsBoolExp>>;
  _not?: InputMaybe<ProjectsBoolExp>;
  _or?: InputMaybe<Array<ProjectsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  environments?: InputMaybe<EnvironmentsBoolExp>;
  googleDriveFolderId?: InputMaybe<StringComparisonExp>;
  googleSheets?: InputMaybe<GoogleSheetsBoolExp>;
  googleSpreadsheets?: InputMaybe<GoogleSpreadsheetsBoolExp>;
  googleSpreadsheetsAggregate?: InputMaybe<GoogleSpreadsheetsAggregateBoolExp>;
  id?: InputMaybe<BigintComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<BigintComparisonExp>;
  trackedMdes?: InputMaybe<TrackedMdesBoolExp>;
  trackedTenants?: InputMaybe<TrackedTenantsBoolExp>;
  trackedTenantsAggregate?: InputMaybe<TrackedTenantsAggregateBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "projects" */
export enum ProjectsConstraint {
  /** unique or primary key constraint on columns "id" */
  ProjectsPkey = 'projects_pkey',
  /** unique or primary key constraint on columns "name", "tenant_id" */
  ProjectsTenantIdNameUniq = 'projects_tenant_id_name_uniq',
  /** unique or primary key constraint on columns "slug", "tenant_id" */
  ProjectsTenantIdSlugKey = 'projects_tenant_id_slug_key'
}

/** input type for inserting data into table "projects" */
export type ProjectsInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  environments?: InputMaybe<EnvironmentsArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['bigint']['input']>;
  trackedMdes?: InputMaybe<TrackedMdesArrRelInsertInput>;
  trackedTenants?: InputMaybe<TrackedTenantsArrRelInsertInput>;
};

/** order by max() on columns of table "projects" */
export type ProjectsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  googleDriveFolderId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "projects" */
export type ProjectsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  googleDriveFolderId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "projects" */
export type ProjectsMutationResponse = {
  __typename?: 'ProjectsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Projects>;
};

/** input type for inserting object relation for remote table "projects" */
export type ProjectsObjRelInsertInput = {
  data: ProjectsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ProjectsOnConflict>;
};

/** on_conflict condition type for table "projects" */
export type ProjectsOnConflict = {
  constraint: ProjectsConstraint;
  updateColumns?: Array<ProjectsUpdateColumn>;
  where?: InputMaybe<ProjectsBoolExp>;
};

/** Ordering options when selecting data from "projects". */
export type ProjectsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  environmentsAggregate?: InputMaybe<EnvironmentsAggregateOrderBy>;
  googleDriveFolderId?: InputMaybe<OrderBy>;
  googleSheetsAggregate?: InputMaybe<GoogleSheetsAggregateOrderBy>;
  googleSpreadsheetsAggregate?: InputMaybe<GoogleSpreadsheetsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  trackedMdesAggregate?: InputMaybe<TrackedMdesAggregateOrderBy>;
  trackedTenantsAggregate?: InputMaybe<TrackedTenantsAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: projects */
export type ProjectsPkColumnsInput = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "projects" */
export enum ProjectsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  GoogleDriveFolderId = 'googleDriveFolderId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "projects" */
export type ProjectsSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  googleDriveFolderId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** order by stddev() on columns of table "projects" */
export type ProjectsStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "projects" */
export type ProjectsStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "projects" */
export type ProjectsStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "projects" */
export type ProjectsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ProjectsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  googleDriveFolderId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "projects" */
export type ProjectsSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** update columns of table "projects" */
export enum ProjectsUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  GoogleDriveFolderId = 'googleDriveFolderId',
  /** column name */
  Name = 'name'
}

export type ProjectsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectsSetInput>;
  /** filter the rows which have to be updated */
  where: ProjectsBoolExp;
};

/** order by varPop() on columns of table "projects" */
export type ProjectsVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "projects" */
export type ProjectsVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "projects" */
export type ProjectsVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

export type ReactFlowViewport = {
  __typename?: 'ReactFlowViewport';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
  zoom: Scalars['Float']['output'];
};

export type ReactFlowViewportInput = {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
  zoom: Scalars['Float']['input'];
};

export type RemoteCheckDatasourceResult = {
  __typename?: 'RemoteCheckDatasourceResult';
  connected: Scalars['Boolean']['output'];
  migrations?: Maybe<Array<FlywaySchemaHistory>>;
};

export type RemoteListMdEsResult = {
  __typename?: 'RemoteListMDEsResult';
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
};

export type RemoteListTenantsResult = {
  __typename?: 'RemoteListTenantsResult';
  data?: Maybe<Scalars['jsonb']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
};

export type RemoteReadMdeResult = {
  __typename?: 'RemoteReadMDEResult';
  columns: Array<Scalars['String']['output']>;
  rows: Array<Array<Scalars['String']['output']>>;
};

export type RenderDatasourceSchemaMapResult = {
  __typename?: 'RenderDatasourceSchemaMapResult';
  d2Svg: Scalars['String']['output'];
  d2Text: Scalars['String']['output'];
};

export type SchemaMetricsResult = {
  __typename?: 'SchemaMetricsResult';
  columnCountCurrent: Scalars['Int']['output'];
  columnCountPrevious: Scalars['Int']['output'];
  constraintPerColumnPercentageCurrent: Scalars['Float']['output'];
  constraintPerColumnPercentagePrevious: Scalars['Float']['output'];
  schemaBreakageCurrent: Scalars['Int']['output'];
  schemaBreakagePrevious: Scalars['Int']['output'];
  schemaGrowthCurrent: Scalars['Int']['output'];
  schemaGrowthPrevious: Scalars['Int']['output'];
  status: Scalars['JSON']['output'];
  tableClusters: Array<TableCluster>;
  tableCountCurrent: Scalars['Int']['output'];
  tableCountPrevious: Scalars['Int']['output'];
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type SmallintComparisonExp = {
  _eq?: InputMaybe<Scalars['smallint']['input']>;
  _gt?: InputMaybe<Scalars['smallint']['input']>;
  _gte?: InputMaybe<Scalars['smallint']['input']>;
  _in?: InputMaybe<Array<Scalars['smallint']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['smallint']['input']>;
  _lte?: InputMaybe<Scalars['smallint']['input']>;
  _neq?: InputMaybe<Scalars['smallint']['input']>;
  _nin?: InputMaybe<Array<Scalars['smallint']['input']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringComparisonExp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "subscription_plans" */
export type SubscriptionPlans = {
  __typename?: 'SubscriptionPlans';
  billingIntervalMonths: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  lemonsqueezyCheckoutId?: Maybe<Scalars['String']['output']>;
  lemonsqueezyProductId?: Maybe<Scalars['bigint']['output']>;
  maxGoogleSheets: Scalars['bigint']['output'];
  maxTrackedTenants: Scalars['bigint']['output'];
  monthlyTransferMegabyteLimits: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  overageMbTransferEuroCent?: Maybe<Scalars['bigint']['output']>;
  priceEuroCent?: Maybe<Scalars['bigint']['output']>;
  slug: Scalars['String']['output'];
  /** An aggregate relationship */
  tenantSubscriptionsAggregate: TenantSubscriptionsAggregate;
  /** An array relationship */
  tenant_subscriptions: Array<TenantSubscriptions>;
};


/** columns and relationships of "subscription_plans" */
export type SubscriptionPlansTenantSubscriptionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TenantSubscriptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantSubscriptionsOrderBy>>;
  where?: InputMaybe<TenantSubscriptionsBoolExp>;
};


/** columns and relationships of "subscription_plans" */
export type SubscriptionPlansTenant_SubscriptionsArgs = {
  distinctOn?: InputMaybe<Array<TenantSubscriptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantSubscriptionsOrderBy>>;
  where?: InputMaybe<TenantSubscriptionsBoolExp>;
};

/** Boolean expression to filter rows from the table "subscription_plans". All fields are combined with a logical 'AND'. */
export type SubscriptionPlansBoolExp = {
  _and?: InputMaybe<Array<SubscriptionPlansBoolExp>>;
  _not?: InputMaybe<SubscriptionPlansBoolExp>;
  _or?: InputMaybe<Array<SubscriptionPlansBoolExp>>;
  billingIntervalMonths?: InputMaybe<IntComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  lemonsqueezyCheckoutId?: InputMaybe<StringComparisonExp>;
  lemonsqueezyProductId?: InputMaybe<BigintComparisonExp>;
  maxGoogleSheets?: InputMaybe<BigintComparisonExp>;
  maxTrackedTenants?: InputMaybe<BigintComparisonExp>;
  monthlyTransferMegabyteLimits?: InputMaybe<BigintComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  overageMbTransferEuroCent?: InputMaybe<BigintComparisonExp>;
  priceEuroCent?: InputMaybe<BigintComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  tenant_subscriptions?: InputMaybe<TenantSubscriptionsBoolExp>;
  tenant_subscriptionsAggregate?: InputMaybe<TenantSubscriptionsAggregateBoolExp>;
};

/** Ordering options when selecting data from "subscription_plans". */
export type SubscriptionPlansOrderBy = {
  billingIntervalMonths?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lemonsqueezyCheckoutId?: InputMaybe<OrderBy>;
  lemonsqueezyProductId?: InputMaybe<OrderBy>;
  maxGoogleSheets?: InputMaybe<OrderBy>;
  maxTrackedTenants?: InputMaybe<OrderBy>;
  monthlyTransferMegabyteLimits?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  overageMbTransferEuroCent?: InputMaybe<OrderBy>;
  priceEuroCent?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  tenant_subscriptionsAggregate?: InputMaybe<TenantSubscriptionsAggregateOrderBy>;
};

/** select columns of table "subscription_plans" */
export enum SubscriptionPlansSelectColumn {
  /** column name */
  BillingIntervalMonths = 'billingIntervalMonths',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LemonsqueezyCheckoutId = 'lemonsqueezyCheckoutId',
  /** column name */
  LemonsqueezyProductId = 'lemonsqueezyProductId',
  /** column name */
  MaxGoogleSheets = 'maxGoogleSheets',
  /** column name */
  MaxTrackedTenants = 'maxTrackedTenants',
  /** column name */
  MonthlyTransferMegabyteLimits = 'monthlyTransferMegabyteLimits',
  /** column name */
  Name = 'name',
  /** column name */
  OverageMbTransferEuroCent = 'overageMbTransferEuroCent',
  /** column name */
  PriceEuroCent = 'priceEuroCent',
  /** column name */
  Slug = 'slug'
}

/** Streaming cursor of the table "subscription_plans" */
export type SubscriptionPlansStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: SubscriptionPlansStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SubscriptionPlansStreamCursorValueInput = {
  billingIntervalMonths?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lemonsqueezyCheckoutId?: InputMaybe<Scalars['String']['input']>;
  lemonsqueezyProductId?: InputMaybe<Scalars['bigint']['input']>;
  maxGoogleSheets?: InputMaybe<Scalars['bigint']['input']>;
  maxTrackedTenants?: InputMaybe<Scalars['bigint']['input']>;
  monthlyTransferMegabyteLimits?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overageMbTransferEuroCent?: InputMaybe<Scalars['bigint']['input']>;
  priceEuroCent?: InputMaybe<Scalars['bigint']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type TableCluster = {
  __typename?: 'TableCluster';
  id: Scalars['String']['output'];
  mutationOrders: Array<MutationOrder>;
  tables: Array<PostgresTable>;
};

/** columns and relationships of "tenant_subscriptions" */
export type TenantSubscriptions = {
  __typename?: 'TenantSubscriptions';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['bigint']['output'];
  maxGoogleSheets: Scalars['bigint']['output'];
  maxTrackedTenants: Scalars['bigint']['output'];
  monthlyTransferMegabyteLimits: Scalars['bigint']['output'];
  overageMbTransferEuroCent: Scalars['bigint']['output'];
  priceEuroCent: Scalars['bigint']['output'];
  /** An object relationship */
  subscriptionPlan: SubscriptionPlans;
  subscriptionPlanId: Scalars['bigint']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['bigint']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  valid: Scalars['daterange']['output'];
};

/** aggregated selection of "tenant_subscriptions" */
export type TenantSubscriptionsAggregate = {
  __typename?: 'TenantSubscriptionsAggregate';
  aggregate?: Maybe<TenantSubscriptionsAggregateFields>;
  nodes: Array<TenantSubscriptions>;
};

export type TenantSubscriptionsAggregateBoolExp = {
  count?: InputMaybe<TenantSubscriptionsAggregateBoolExpCount>;
};

/** aggregate fields of "tenant_subscriptions" */
export type TenantSubscriptionsAggregateFields = {
  __typename?: 'TenantSubscriptionsAggregateFields';
  avg?: Maybe<TenantSubscriptionsAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<TenantSubscriptionsMaxFields>;
  min?: Maybe<TenantSubscriptionsMinFields>;
  stddev?: Maybe<TenantSubscriptionsStddevFields>;
  stddevPop?: Maybe<TenantSubscriptionsStddevPopFields>;
  stddevSamp?: Maybe<TenantSubscriptionsStddevSampFields>;
  sum?: Maybe<TenantSubscriptionsSumFields>;
  varPop?: Maybe<TenantSubscriptionsVarPopFields>;
  varSamp?: Maybe<TenantSubscriptionsVarSampFields>;
  variance?: Maybe<TenantSubscriptionsVarianceFields>;
};


/** aggregate fields of "tenant_subscriptions" */
export type TenantSubscriptionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TenantSubscriptionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenant_subscriptions" */
export type TenantSubscriptionsAggregateOrderBy = {
  avg?: InputMaybe<TenantSubscriptionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<TenantSubscriptionsMaxOrderBy>;
  min?: InputMaybe<TenantSubscriptionsMinOrderBy>;
  stddev?: InputMaybe<TenantSubscriptionsStddevOrderBy>;
  stddevPop?: InputMaybe<TenantSubscriptionsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<TenantSubscriptionsStddevSampOrderBy>;
  sum?: InputMaybe<TenantSubscriptionsSumOrderBy>;
  varPop?: InputMaybe<TenantSubscriptionsVarPopOrderBy>;
  varSamp?: InputMaybe<TenantSubscriptionsVarSampOrderBy>;
  variance?: InputMaybe<TenantSubscriptionsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type TenantSubscriptionsAvgFields = {
  __typename?: 'TenantSubscriptionsAvgFields';
  id?: Maybe<Scalars['Float']['output']>;
  maxGoogleSheets?: Maybe<Scalars['Float']['output']>;
  maxTrackedTenants?: Maybe<Scalars['Float']['output']>;
  monthlyTransferMegabyteLimits?: Maybe<Scalars['Float']['output']>;
  overageMbTransferEuroCent?: Maybe<Scalars['Float']['output']>;
  priceEuroCent?: Maybe<Scalars['Float']['output']>;
  subscriptionPlanId?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "tenant_subscriptions" */
export type TenantSubscriptionsAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  maxGoogleSheets?: InputMaybe<OrderBy>;
  maxTrackedTenants?: InputMaybe<OrderBy>;
  monthlyTransferMegabyteLimits?: InputMaybe<OrderBy>;
  overageMbTransferEuroCent?: InputMaybe<OrderBy>;
  priceEuroCent?: InputMaybe<OrderBy>;
  subscriptionPlanId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "tenant_subscriptions". All fields are combined with a logical 'AND'. */
export type TenantSubscriptionsBoolExp = {
  _and?: InputMaybe<Array<TenantSubscriptionsBoolExp>>;
  _not?: InputMaybe<TenantSubscriptionsBoolExp>;
  _or?: InputMaybe<Array<TenantSubscriptionsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  maxGoogleSheets?: InputMaybe<BigintComparisonExp>;
  maxTrackedTenants?: InputMaybe<BigintComparisonExp>;
  monthlyTransferMegabyteLimits?: InputMaybe<BigintComparisonExp>;
  overageMbTransferEuroCent?: InputMaybe<BigintComparisonExp>;
  priceEuroCent?: InputMaybe<BigintComparisonExp>;
  subscriptionPlan?: InputMaybe<SubscriptionPlansBoolExp>;
  subscriptionPlanId?: InputMaybe<BigintComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<BigintComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  valid?: InputMaybe<DaterangeComparisonExp>;
};

/** aggregate max on columns */
export type TenantSubscriptionsMaxFields = {
  __typename?: 'TenantSubscriptionsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  maxGoogleSheets?: Maybe<Scalars['bigint']['output']>;
  maxTrackedTenants?: Maybe<Scalars['bigint']['output']>;
  monthlyTransferMegabyteLimits?: Maybe<Scalars['bigint']['output']>;
  overageMbTransferEuroCent?: Maybe<Scalars['bigint']['output']>;
  priceEuroCent?: Maybe<Scalars['bigint']['output']>;
  subscriptionPlanId?: Maybe<Scalars['bigint']['output']>;
  tenantId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "tenant_subscriptions" */
export type TenantSubscriptionsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maxGoogleSheets?: InputMaybe<OrderBy>;
  maxTrackedTenants?: InputMaybe<OrderBy>;
  monthlyTransferMegabyteLimits?: InputMaybe<OrderBy>;
  overageMbTransferEuroCent?: InputMaybe<OrderBy>;
  priceEuroCent?: InputMaybe<OrderBy>;
  subscriptionPlanId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type TenantSubscriptionsMinFields = {
  __typename?: 'TenantSubscriptionsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  maxGoogleSheets?: Maybe<Scalars['bigint']['output']>;
  maxTrackedTenants?: Maybe<Scalars['bigint']['output']>;
  monthlyTransferMegabyteLimits?: Maybe<Scalars['bigint']['output']>;
  overageMbTransferEuroCent?: Maybe<Scalars['bigint']['output']>;
  priceEuroCent?: Maybe<Scalars['bigint']['output']>;
  subscriptionPlanId?: Maybe<Scalars['bigint']['output']>;
  tenantId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "tenant_subscriptions" */
export type TenantSubscriptionsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maxGoogleSheets?: InputMaybe<OrderBy>;
  maxTrackedTenants?: InputMaybe<OrderBy>;
  monthlyTransferMegabyteLimits?: InputMaybe<OrderBy>;
  overageMbTransferEuroCent?: InputMaybe<OrderBy>;
  priceEuroCent?: InputMaybe<OrderBy>;
  subscriptionPlanId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "tenant_subscriptions". */
export type TenantSubscriptionsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maxGoogleSheets?: InputMaybe<OrderBy>;
  maxTrackedTenants?: InputMaybe<OrderBy>;
  monthlyTransferMegabyteLimits?: InputMaybe<OrderBy>;
  overageMbTransferEuroCent?: InputMaybe<OrderBy>;
  priceEuroCent?: InputMaybe<OrderBy>;
  subscriptionPlan?: InputMaybe<SubscriptionPlansOrderBy>;
  subscriptionPlanId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  valid?: InputMaybe<OrderBy>;
};

/** select columns of table "tenant_subscriptions" */
export enum TenantSubscriptionsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  MaxGoogleSheets = 'maxGoogleSheets',
  /** column name */
  MaxTrackedTenants = 'maxTrackedTenants',
  /** column name */
  MonthlyTransferMegabyteLimits = 'monthlyTransferMegabyteLimits',
  /** column name */
  OverageMbTransferEuroCent = 'overageMbTransferEuroCent',
  /** column name */
  PriceEuroCent = 'priceEuroCent',
  /** column name */
  SubscriptionPlanId = 'subscriptionPlanId',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Valid = 'valid'
}

/** aggregate stddev on columns */
export type TenantSubscriptionsStddevFields = {
  __typename?: 'TenantSubscriptionsStddevFields';
  id?: Maybe<Scalars['Float']['output']>;
  maxGoogleSheets?: Maybe<Scalars['Float']['output']>;
  maxTrackedTenants?: Maybe<Scalars['Float']['output']>;
  monthlyTransferMegabyteLimits?: Maybe<Scalars['Float']['output']>;
  overageMbTransferEuroCent?: Maybe<Scalars['Float']['output']>;
  priceEuroCent?: Maybe<Scalars['Float']['output']>;
  subscriptionPlanId?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "tenant_subscriptions" */
export type TenantSubscriptionsStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  maxGoogleSheets?: InputMaybe<OrderBy>;
  maxTrackedTenants?: InputMaybe<OrderBy>;
  monthlyTransferMegabyteLimits?: InputMaybe<OrderBy>;
  overageMbTransferEuroCent?: InputMaybe<OrderBy>;
  priceEuroCent?: InputMaybe<OrderBy>;
  subscriptionPlanId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type TenantSubscriptionsStddevPopFields = {
  __typename?: 'TenantSubscriptionsStddevPopFields';
  id?: Maybe<Scalars['Float']['output']>;
  maxGoogleSheets?: Maybe<Scalars['Float']['output']>;
  maxTrackedTenants?: Maybe<Scalars['Float']['output']>;
  monthlyTransferMegabyteLimits?: Maybe<Scalars['Float']['output']>;
  overageMbTransferEuroCent?: Maybe<Scalars['Float']['output']>;
  priceEuroCent?: Maybe<Scalars['Float']['output']>;
  subscriptionPlanId?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevPop() on columns of table "tenant_subscriptions" */
export type TenantSubscriptionsStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  maxGoogleSheets?: InputMaybe<OrderBy>;
  maxTrackedTenants?: InputMaybe<OrderBy>;
  monthlyTransferMegabyteLimits?: InputMaybe<OrderBy>;
  overageMbTransferEuroCent?: InputMaybe<OrderBy>;
  priceEuroCent?: InputMaybe<OrderBy>;
  subscriptionPlanId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type TenantSubscriptionsStddevSampFields = {
  __typename?: 'TenantSubscriptionsStddevSampFields';
  id?: Maybe<Scalars['Float']['output']>;
  maxGoogleSheets?: Maybe<Scalars['Float']['output']>;
  maxTrackedTenants?: Maybe<Scalars['Float']['output']>;
  monthlyTransferMegabyteLimits?: Maybe<Scalars['Float']['output']>;
  overageMbTransferEuroCent?: Maybe<Scalars['Float']['output']>;
  priceEuroCent?: Maybe<Scalars['Float']['output']>;
  subscriptionPlanId?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevSamp() on columns of table "tenant_subscriptions" */
export type TenantSubscriptionsStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  maxGoogleSheets?: InputMaybe<OrderBy>;
  maxTrackedTenants?: InputMaybe<OrderBy>;
  monthlyTransferMegabyteLimits?: InputMaybe<OrderBy>;
  overageMbTransferEuroCent?: InputMaybe<OrderBy>;
  priceEuroCent?: InputMaybe<OrderBy>;
  subscriptionPlanId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "tenant_subscriptions" */
export type TenantSubscriptionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TenantSubscriptionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TenantSubscriptionsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  maxGoogleSheets?: InputMaybe<Scalars['bigint']['input']>;
  maxTrackedTenants?: InputMaybe<Scalars['bigint']['input']>;
  monthlyTransferMegabyteLimits?: InputMaybe<Scalars['bigint']['input']>;
  overageMbTransferEuroCent?: InputMaybe<Scalars['bigint']['input']>;
  priceEuroCent?: InputMaybe<Scalars['bigint']['input']>;
  subscriptionPlanId?: InputMaybe<Scalars['bigint']['input']>;
  tenantId?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  valid?: InputMaybe<Scalars['daterange']['input']>;
};

/** aggregate sum on columns */
export type TenantSubscriptionsSumFields = {
  __typename?: 'TenantSubscriptionsSumFields';
  id?: Maybe<Scalars['bigint']['output']>;
  maxGoogleSheets?: Maybe<Scalars['bigint']['output']>;
  maxTrackedTenants?: Maybe<Scalars['bigint']['output']>;
  monthlyTransferMegabyteLimits?: Maybe<Scalars['bigint']['output']>;
  overageMbTransferEuroCent?: Maybe<Scalars['bigint']['output']>;
  priceEuroCent?: Maybe<Scalars['bigint']['output']>;
  subscriptionPlanId?: Maybe<Scalars['bigint']['output']>;
  tenantId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "tenant_subscriptions" */
export type TenantSubscriptionsSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  maxGoogleSheets?: InputMaybe<OrderBy>;
  maxTrackedTenants?: InputMaybe<OrderBy>;
  monthlyTransferMegabyteLimits?: InputMaybe<OrderBy>;
  overageMbTransferEuroCent?: InputMaybe<OrderBy>;
  priceEuroCent?: InputMaybe<OrderBy>;
  subscriptionPlanId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** aggregate varPop on columns */
export type TenantSubscriptionsVarPopFields = {
  __typename?: 'TenantSubscriptionsVarPopFields';
  id?: Maybe<Scalars['Float']['output']>;
  maxGoogleSheets?: Maybe<Scalars['Float']['output']>;
  maxTrackedTenants?: Maybe<Scalars['Float']['output']>;
  monthlyTransferMegabyteLimits?: Maybe<Scalars['Float']['output']>;
  overageMbTransferEuroCent?: Maybe<Scalars['Float']['output']>;
  priceEuroCent?: Maybe<Scalars['Float']['output']>;
  subscriptionPlanId?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['Float']['output']>;
};

/** order by varPop() on columns of table "tenant_subscriptions" */
export type TenantSubscriptionsVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  maxGoogleSheets?: InputMaybe<OrderBy>;
  maxTrackedTenants?: InputMaybe<OrderBy>;
  monthlyTransferMegabyteLimits?: InputMaybe<OrderBy>;
  overageMbTransferEuroCent?: InputMaybe<OrderBy>;
  priceEuroCent?: InputMaybe<OrderBy>;
  subscriptionPlanId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type TenantSubscriptionsVarSampFields = {
  __typename?: 'TenantSubscriptionsVarSampFields';
  id?: Maybe<Scalars['Float']['output']>;
  maxGoogleSheets?: Maybe<Scalars['Float']['output']>;
  maxTrackedTenants?: Maybe<Scalars['Float']['output']>;
  monthlyTransferMegabyteLimits?: Maybe<Scalars['Float']['output']>;
  overageMbTransferEuroCent?: Maybe<Scalars['Float']['output']>;
  priceEuroCent?: Maybe<Scalars['Float']['output']>;
  subscriptionPlanId?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['Float']['output']>;
};

/** order by varSamp() on columns of table "tenant_subscriptions" */
export type TenantSubscriptionsVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  maxGoogleSheets?: InputMaybe<OrderBy>;
  maxTrackedTenants?: InputMaybe<OrderBy>;
  monthlyTransferMegabyteLimits?: InputMaybe<OrderBy>;
  overageMbTransferEuroCent?: InputMaybe<OrderBy>;
  priceEuroCent?: InputMaybe<OrderBy>;
  subscriptionPlanId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type TenantSubscriptionsVarianceFields = {
  __typename?: 'TenantSubscriptionsVarianceFields';
  id?: Maybe<Scalars['Float']['output']>;
  maxGoogleSheets?: Maybe<Scalars['Float']['output']>;
  maxTrackedTenants?: Maybe<Scalars['Float']['output']>;
  monthlyTransferMegabyteLimits?: Maybe<Scalars['Float']['output']>;
  overageMbTransferEuroCent?: Maybe<Scalars['Float']['output']>;
  priceEuroCent?: Maybe<Scalars['Float']['output']>;
  subscriptionPlanId?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "tenant_subscriptions" */
export type TenantSubscriptionsVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  maxGoogleSheets?: InputMaybe<OrderBy>;
  maxTrackedTenants?: InputMaybe<OrderBy>;
  monthlyTransferMegabyteLimits?: InputMaybe<OrderBy>;
  overageMbTransferEuroCent?: InputMaybe<OrderBy>;
  priceEuroCent?: InputMaybe<OrderBy>;
  subscriptionPlanId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "tenants" */
export type Tenants = {
  __typename?: 'Tenants';
  clerkId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  /** Returns either 0 or 1 records given the current subscription as of today. (DB-time) */
  currentSubscription?: Maybe<Array<TenantSubscriptions>>;
  /** An array relationship */
  datasources: Array<Datasources>;
  email?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  environments: Array<Environments>;
  googleDriveFolderId?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  googleSheets: Array<GoogleSheets>;
  /** An array relationship */
  googleSpreadsheets: Array<GoogleSpreadsheets>;
  /** An aggregate relationship */
  googleSpreadsheetsAggregate: GoogleSpreadsheetsAggregate;
  /** A computed field, executes function "has_google_oauth_integration" */
  hasGoogleOauthIntegration?: Maybe<Scalars['Boolean']['output']>;
  /** A computed field, executes function "has_slack_integration" */
  hasSlackIntegration?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['bigint']['output'];
  lastSignIn?: Maybe<Scalars['timestamptz']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** An object relationship */
  ownerUser: Users;
  ownerUserId: Scalars['bigint']['output'];
  plan?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  projects: Array<Projects>;
  slackChannelId?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  /** An aggregate relationship */
  tenantSubscriptionsAggregate: TenantSubscriptionsAggregate;
  /** An array relationship */
  tenant_subscriptions: Array<TenantSubscriptions>;
  /** An array relationship */
  trackedMdeEnvironments: Array<TrackedMdeEnvironments>;
  /** An array relationship */
  trackedMdes: Array<TrackedMdes>;
  /** An array relationship */
  trackedTenantEnvironments: Array<TrackedTenantEnvironments>;
  /** An array relationship */
  trackedTenants: Array<TrackedTenants>;
  /** An aggregate relationship */
  trackedTenantsAggregate: TrackedTenantsAggregate;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  userTenants: Array<UserTenants>;
};


/** columns and relationships of "tenants" */
export type TenantsCurrentSubscriptionArgs = {
  distinctOn?: InputMaybe<Array<TenantSubscriptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantSubscriptionsOrderBy>>;
  where?: InputMaybe<TenantSubscriptionsBoolExp>;
};


/** columns and relationships of "tenants" */
export type TenantsDatasourcesArgs = {
  distinctOn?: InputMaybe<Array<DatasourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DatasourcesOrderBy>>;
  where?: InputMaybe<DatasourcesBoolExp>;
};


/** columns and relationships of "tenants" */
export type TenantsEnvironmentsArgs = {
  distinctOn?: InputMaybe<Array<EnvironmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EnvironmentsOrderBy>>;
  where?: InputMaybe<EnvironmentsBoolExp>;
};


/** columns and relationships of "tenants" */
export type TenantsGoogleSheetsArgs = {
  distinctOn?: InputMaybe<Array<GoogleSheetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSheetsOrderBy>>;
  where?: InputMaybe<GoogleSheetsBoolExp>;
};


/** columns and relationships of "tenants" */
export type TenantsGoogleSpreadsheetsArgs = {
  distinctOn?: InputMaybe<Array<GoogleSpreadsheetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSpreadsheetsOrderBy>>;
  where?: InputMaybe<GoogleSpreadsheetsBoolExp>;
};


/** columns and relationships of "tenants" */
export type TenantsGoogleSpreadsheetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GoogleSpreadsheetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSpreadsheetsOrderBy>>;
  where?: InputMaybe<GoogleSpreadsheetsBoolExp>;
};


/** columns and relationships of "tenants" */
export type TenantsProjectsArgs = {
  distinctOn?: InputMaybe<Array<ProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
  where?: InputMaybe<ProjectsBoolExp>;
};


/** columns and relationships of "tenants" */
export type TenantsTenantSubscriptionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TenantSubscriptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantSubscriptionsOrderBy>>;
  where?: InputMaybe<TenantSubscriptionsBoolExp>;
};


/** columns and relationships of "tenants" */
export type TenantsTenant_SubscriptionsArgs = {
  distinctOn?: InputMaybe<Array<TenantSubscriptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantSubscriptionsOrderBy>>;
  where?: InputMaybe<TenantSubscriptionsBoolExp>;
};


/** columns and relationships of "tenants" */
export type TenantsTrackedMdeEnvironmentsArgs = {
  distinctOn?: InputMaybe<Array<TrackedMdeEnvironmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrackedMdeEnvironmentsOrderBy>>;
  where?: InputMaybe<TrackedMdeEnvironmentsBoolExp>;
};


/** columns and relationships of "tenants" */
export type TenantsTrackedMdesArgs = {
  distinctOn?: InputMaybe<Array<TrackedMdesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrackedMdesOrderBy>>;
  where?: InputMaybe<TrackedMdesBoolExp>;
};


/** columns and relationships of "tenants" */
export type TenantsTrackedTenantEnvironmentsArgs = {
  distinctOn?: InputMaybe<Array<TrackedTenantEnvironmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrackedTenantEnvironmentsOrderBy>>;
  where?: InputMaybe<TrackedTenantEnvironmentsBoolExp>;
};


/** columns and relationships of "tenants" */
export type TenantsTrackedTenantsArgs = {
  distinctOn?: InputMaybe<Array<TrackedTenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrackedTenantsOrderBy>>;
  where?: InputMaybe<TrackedTenantsBoolExp>;
};


/** columns and relationships of "tenants" */
export type TenantsTrackedTenantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TrackedTenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrackedTenantsOrderBy>>;
  where?: InputMaybe<TrackedTenantsBoolExp>;
};


/** columns and relationships of "tenants" */
export type TenantsUserTenantsArgs = {
  distinctOn?: InputMaybe<Array<UserTenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserTenantsOrderBy>>;
  where?: InputMaybe<UserTenantsBoolExp>;
};

/** order by aggregate values of table "tenants" */
export type TenantsAggregateOrderBy = {
  avg?: InputMaybe<TenantsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<TenantsMaxOrderBy>;
  min?: InputMaybe<TenantsMinOrderBy>;
  stddev?: InputMaybe<TenantsStddevOrderBy>;
  stddevPop?: InputMaybe<TenantsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<TenantsStddevSampOrderBy>;
  sum?: InputMaybe<TenantsSumOrderBy>;
  varPop?: InputMaybe<TenantsVarPopOrderBy>;
  varSamp?: InputMaybe<TenantsVarSampOrderBy>;
  variance?: InputMaybe<TenantsVarianceOrderBy>;
};

/** order by avg() on columns of table "tenants" */
export type TenantsAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "tenants". All fields are combined with a logical 'AND'. */
export type TenantsBoolExp = {
  _and?: InputMaybe<Array<TenantsBoolExp>>;
  _not?: InputMaybe<TenantsBoolExp>;
  _or?: InputMaybe<Array<TenantsBoolExp>>;
  clerkId?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currentSubscription?: InputMaybe<TenantSubscriptionsBoolExp>;
  datasources?: InputMaybe<DatasourcesBoolExp>;
  email?: InputMaybe<StringComparisonExp>;
  environments?: InputMaybe<EnvironmentsBoolExp>;
  googleDriveFolderId?: InputMaybe<StringComparisonExp>;
  googleSheets?: InputMaybe<GoogleSheetsBoolExp>;
  googleSpreadsheets?: InputMaybe<GoogleSpreadsheetsBoolExp>;
  googleSpreadsheetsAggregate?: InputMaybe<GoogleSpreadsheetsAggregateBoolExp>;
  hasGoogleOauthIntegration?: InputMaybe<BooleanComparisonExp>;
  hasSlackIntegration?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  lastSignIn?: InputMaybe<TimestamptzComparisonExp>;
  logo?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  ownerUser?: InputMaybe<UsersBoolExp>;
  ownerUserId?: InputMaybe<BigintComparisonExp>;
  plan?: InputMaybe<StringComparisonExp>;
  projects?: InputMaybe<ProjectsBoolExp>;
  slackChannelId?: InputMaybe<StringComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  tenant_subscriptions?: InputMaybe<TenantSubscriptionsBoolExp>;
  tenant_subscriptionsAggregate?: InputMaybe<TenantSubscriptionsAggregateBoolExp>;
  trackedMdeEnvironments?: InputMaybe<TrackedMdeEnvironmentsBoolExp>;
  trackedMdes?: InputMaybe<TrackedMdesBoolExp>;
  trackedTenantEnvironments?: InputMaybe<TrackedTenantEnvironmentsBoolExp>;
  trackedTenants?: InputMaybe<TrackedTenantsBoolExp>;
  trackedTenantsAggregate?: InputMaybe<TrackedTenantsAggregateBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userTenants?: InputMaybe<UserTenantsBoolExp>;
};

/** order by max() on columns of table "tenants" */
export type TenantsMaxOrderBy = {
  clerkId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  googleDriveFolderId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastSignIn?: InputMaybe<OrderBy>;
  logo?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
  plan?: InputMaybe<OrderBy>;
  slackChannelId?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "tenants" */
export type TenantsMinOrderBy = {
  clerkId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  googleDriveFolderId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastSignIn?: InputMaybe<OrderBy>;
  logo?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
  plan?: InputMaybe<OrderBy>;
  slackChannelId?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "tenants". */
export type TenantsOrderBy = {
  clerkId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currentSubscriptionAggregate?: InputMaybe<TenantSubscriptionsAggregateOrderBy>;
  datasourcesAggregate?: InputMaybe<DatasourcesAggregateOrderBy>;
  email?: InputMaybe<OrderBy>;
  environmentsAggregate?: InputMaybe<EnvironmentsAggregateOrderBy>;
  googleDriveFolderId?: InputMaybe<OrderBy>;
  googleSheetsAggregate?: InputMaybe<GoogleSheetsAggregateOrderBy>;
  googleSpreadsheetsAggregate?: InputMaybe<GoogleSpreadsheetsAggregateOrderBy>;
  hasGoogleOauthIntegration?: InputMaybe<OrderBy>;
  hasSlackIntegration?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastSignIn?: InputMaybe<OrderBy>;
  logo?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  ownerUser?: InputMaybe<UsersOrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
  plan?: InputMaybe<OrderBy>;
  projectsAggregate?: InputMaybe<ProjectsAggregateOrderBy>;
  slackChannelId?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  tenant_subscriptionsAggregate?: InputMaybe<TenantSubscriptionsAggregateOrderBy>;
  trackedMdeEnvironmentsAggregate?: InputMaybe<TrackedMdeEnvironmentsAggregateOrderBy>;
  trackedMdesAggregate?: InputMaybe<TrackedMdesAggregateOrderBy>;
  trackedTenantEnvironmentsAggregate?: InputMaybe<TrackedTenantEnvironmentsAggregateOrderBy>;
  trackedTenantsAggregate?: InputMaybe<TrackedTenantsAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userTenantsAggregate?: InputMaybe<UserTenantsAggregateOrderBy>;
};

/** select columns of table "tenants" */
export enum TenantsSelectColumn {
  /** column name */
  ClerkId = 'clerkId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  GoogleDriveFolderId = 'googleDriveFolderId',
  /** column name */
  Id = 'id',
  /** column name */
  LastSignIn = 'lastSignIn',
  /** column name */
  Logo = 'logo',
  /** column name */
  Name = 'name',
  /** column name */
  OwnerUserId = 'ownerUserId',
  /** column name */
  Plan = 'plan',
  /** column name */
  SlackChannelId = 'slackChannelId',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** order by stddev() on columns of table "tenants" */
export type TenantsStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "tenants" */
export type TenantsStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "tenants" */
export type TenantsStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "tenants" */
export type TenantsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TenantsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TenantsStreamCursorValueInput = {
  clerkId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  googleDriveFolderId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lastSignIn?: InputMaybe<Scalars['timestamptz']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerUserId?: InputMaybe<Scalars['bigint']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
  slackChannelId?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "tenants" */
export type TenantsSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "tenants" */
export type TenantsVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "tenants" */
export type TenantsVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "tenants" */
export type TenantsVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type TimestamptzComparisonExp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** columns and relationships of "tracked_mde_environments" */
export type TrackedMdeEnvironments = {
  __typename?: 'TrackedMdeEnvironments';
  /** An object relationship */
  environment: Environments;
  environmentId: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  lastSyncedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  tenant: Tenants;
  /** An object relationship */
  trackedMde: TrackedMdes;
  trackedMdeId: Scalars['bigint']['output'];
};

/** order by aggregate values of table "tracked_mde_environments" */
export type TrackedMdeEnvironmentsAggregateOrderBy = {
  avg?: InputMaybe<TrackedMdeEnvironmentsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<TrackedMdeEnvironmentsMaxOrderBy>;
  min?: InputMaybe<TrackedMdeEnvironmentsMinOrderBy>;
  stddev?: InputMaybe<TrackedMdeEnvironmentsStddevOrderBy>;
  stddevPop?: InputMaybe<TrackedMdeEnvironmentsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<TrackedMdeEnvironmentsStddevSampOrderBy>;
  sum?: InputMaybe<TrackedMdeEnvironmentsSumOrderBy>;
  varPop?: InputMaybe<TrackedMdeEnvironmentsVarPopOrderBy>;
  varSamp?: InputMaybe<TrackedMdeEnvironmentsVarSampOrderBy>;
  variance?: InputMaybe<TrackedMdeEnvironmentsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "tracked_mde_environments" */
export type TrackedMdeEnvironmentsArrRelInsertInput = {
  data: Array<TrackedMdeEnvironmentsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<TrackedMdeEnvironmentsOnConflict>;
};

/** order by avg() on columns of table "tracked_mde_environments" */
export type TrackedMdeEnvironmentsAvgOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  trackedMdeId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "tracked_mde_environments". All fields are combined with a logical 'AND'. */
export type TrackedMdeEnvironmentsBoolExp = {
  _and?: InputMaybe<Array<TrackedMdeEnvironmentsBoolExp>>;
  _not?: InputMaybe<TrackedMdeEnvironmentsBoolExp>;
  _or?: InputMaybe<Array<TrackedMdeEnvironmentsBoolExp>>;
  environment?: InputMaybe<EnvironmentsBoolExp>;
  environmentId?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  lastSyncedAt?: InputMaybe<TimestamptzComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  trackedMde?: InputMaybe<TrackedMdesBoolExp>;
  trackedMdeId?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "tracked_mde_environments" */
export enum TrackedMdeEnvironmentsConstraint {
  /** unique or primary key constraint on columns "tracked_mde_id", "environment_id" */
  TrackedMdeEnvironmentsEnvironmentIdTrackedMdeIdKey = 'tracked_mde_environments_environment_id_tracked_mde_id_key',
  /** unique or primary key constraint on columns "id" */
  TrackedMdeEnvironmentsPkey = 'tracked_mde_environments_pkey'
}

/** input type for inserting data into table "tracked_mde_environments" */
export type TrackedMdeEnvironmentsInsertInput = {
  environment?: InputMaybe<EnvironmentsObjRelInsertInput>;
  environmentId?: InputMaybe<Scalars['bigint']['input']>;
  tenantId?: InputMaybe<Scalars['bigint']['input']>;
  trackedMde?: InputMaybe<TrackedMdesObjRelInsertInput>;
  trackedMdeId?: InputMaybe<Scalars['bigint']['input']>;
};

/** order by max() on columns of table "tracked_mde_environments" */
export type TrackedMdeEnvironmentsMaxOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastSyncedAt?: InputMaybe<OrderBy>;
  trackedMdeId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "tracked_mde_environments" */
export type TrackedMdeEnvironmentsMinOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastSyncedAt?: InputMaybe<OrderBy>;
  trackedMdeId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "tracked_mde_environments" */
export type TrackedMdeEnvironmentsMutationResponse = {
  __typename?: 'TrackedMdeEnvironmentsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TrackedMdeEnvironments>;
};

/** on_conflict condition type for table "tracked_mde_environments" */
export type TrackedMdeEnvironmentsOnConflict = {
  constraint: TrackedMdeEnvironmentsConstraint;
  updateColumns?: Array<TrackedMdeEnvironmentsUpdateColumn>;
  where?: InputMaybe<TrackedMdeEnvironmentsBoolExp>;
};

/** Ordering options when selecting data from "tracked_mde_environments". */
export type TrackedMdeEnvironmentsOrderBy = {
  environment?: InputMaybe<EnvironmentsOrderBy>;
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastSyncedAt?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  trackedMde?: InputMaybe<TrackedMdesOrderBy>;
  trackedMdeId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: tracked_mde_environments */
export type TrackedMdeEnvironmentsPkColumnsInput = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "tracked_mde_environments" */
export enum TrackedMdeEnvironmentsSelectColumn {
  /** column name */
  EnvironmentId = 'environmentId',
  /** column name */
  Id = 'id',
  /** column name */
  LastSyncedAt = 'lastSyncedAt',
  /** column name */
  TrackedMdeId = 'trackedMdeId'
}

/** input type for updating data in table "tracked_mde_environments" */
export type TrackedMdeEnvironmentsSetInput = {
  lastSyncedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by stddev() on columns of table "tracked_mde_environments" */
export type TrackedMdeEnvironmentsStddevOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  trackedMdeId?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "tracked_mde_environments" */
export type TrackedMdeEnvironmentsStddevPopOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  trackedMdeId?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "tracked_mde_environments" */
export type TrackedMdeEnvironmentsStddevSampOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  trackedMdeId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "tracked_mde_environments" */
export type TrackedMdeEnvironmentsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TrackedMdeEnvironmentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TrackedMdeEnvironmentsStreamCursorValueInput = {
  environmentId?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lastSyncedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  trackedMdeId?: InputMaybe<Scalars['bigint']['input']>;
};

/** order by sum() on columns of table "tracked_mde_environments" */
export type TrackedMdeEnvironmentsSumOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  trackedMdeId?: InputMaybe<OrderBy>;
};

/** update columns of table "tracked_mde_environments" */
export enum TrackedMdeEnvironmentsUpdateColumn {
  /** column name */
  LastSyncedAt = 'lastSyncedAt'
}

export type TrackedMdeEnvironmentsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TrackedMdeEnvironmentsSetInput>;
  /** filter the rows which have to be updated */
  where: TrackedMdeEnvironmentsBoolExp;
};

/** order by varPop() on columns of table "tracked_mde_environments" */
export type TrackedMdeEnvironmentsVarPopOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  trackedMdeId?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "tracked_mde_environments" */
export type TrackedMdeEnvironmentsVarSampOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  trackedMdeId?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "tracked_mde_environments" */
export type TrackedMdeEnvironmentsVarianceOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  trackedMdeId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "tracked_mdes" */
export type TrackedMdes = {
  __typename?: 'TrackedMdes';
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  googleSpreadsheets: Array<GoogleSpreadsheets>;
  /** An aggregate relationship */
  googleSpreadsheetsAggregate: GoogleSpreadsheetsAggregate;
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  project: Projects;
  projectId: Scalars['bigint']['output'];
  shortName: Scalars['String']['output'];
  status: TrackedTenantsStatesEnum;
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['bigint']['output'];
  /** An array relationship */
  trackedMdeEnvironments: Array<TrackedMdeEnvironments>;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "tracked_mdes" */
export type TrackedMdesGoogleSpreadsheetsArgs = {
  distinctOn?: InputMaybe<Array<GoogleSpreadsheetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSpreadsheetsOrderBy>>;
  where?: InputMaybe<GoogleSpreadsheetsBoolExp>;
};


/** columns and relationships of "tracked_mdes" */
export type TrackedMdesGoogleSpreadsheetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GoogleSpreadsheetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSpreadsheetsOrderBy>>;
  where?: InputMaybe<GoogleSpreadsheetsBoolExp>;
};


/** columns and relationships of "tracked_mdes" */
export type TrackedMdesTrackedMdeEnvironmentsArgs = {
  distinctOn?: InputMaybe<Array<TrackedMdeEnvironmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrackedMdeEnvironmentsOrderBy>>;
  where?: InputMaybe<TrackedMdeEnvironmentsBoolExp>;
};

/** order by aggregate values of table "tracked_mdes" */
export type TrackedMdesAggregateOrderBy = {
  avg?: InputMaybe<TrackedMdesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<TrackedMdesMaxOrderBy>;
  min?: InputMaybe<TrackedMdesMinOrderBy>;
  stddev?: InputMaybe<TrackedMdesStddevOrderBy>;
  stddevPop?: InputMaybe<TrackedMdesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<TrackedMdesStddevSampOrderBy>;
  sum?: InputMaybe<TrackedMdesSumOrderBy>;
  varPop?: InputMaybe<TrackedMdesVarPopOrderBy>;
  varSamp?: InputMaybe<TrackedMdesVarSampOrderBy>;
  variance?: InputMaybe<TrackedMdesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "tracked_mdes" */
export type TrackedMdesArrRelInsertInput = {
  data: Array<TrackedMdesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<TrackedMdesOnConflict>;
};

/** order by avg() on columns of table "tracked_mdes" */
export type TrackedMdesAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "tracked_mdes". All fields are combined with a logical 'AND'. */
export type TrackedMdesBoolExp = {
  _and?: InputMaybe<Array<TrackedMdesBoolExp>>;
  _not?: InputMaybe<TrackedMdesBoolExp>;
  _or?: InputMaybe<Array<TrackedMdesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  googleSpreadsheets?: InputMaybe<GoogleSpreadsheetsBoolExp>;
  googleSpreadsheetsAggregate?: InputMaybe<GoogleSpreadsheetsAggregateBoolExp>;
  id?: InputMaybe<BigintComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  project?: InputMaybe<ProjectsBoolExp>;
  projectId?: InputMaybe<BigintComparisonExp>;
  shortName?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<TrackedTenantsStatesEnumComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<BigintComparisonExp>;
  trackedMdeEnvironments?: InputMaybe<TrackedMdeEnvironmentsBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "tracked_mdes" */
export enum TrackedMdesConstraint {
  /** unique or primary key constraint on columns "id" */
  TrackedMdesPkey = 'tracked_mdes_pkey',
  /** unique or primary key constraint on columns "short_name", "project_id" */
  TrackedMdesProjectIdShortNameKey = 'tracked_mdes_project_id_short_name_key'
}

/** input type for inserting data into table "tracked_mdes" */
export type TrackedMdesInsertInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<ProjectsObjRelInsertInput>;
  projectId?: InputMaybe<Scalars['bigint']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['bigint']['input']>;
  trackedMdeEnvironments?: InputMaybe<TrackedMdeEnvironmentsArrRelInsertInput>;
};

/** order by max() on columns of table "tracked_mdes" */
export type TrackedMdesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  shortName?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "tracked_mdes" */
export type TrackedMdesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  shortName?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "tracked_mdes" */
export type TrackedMdesMutationResponse = {
  __typename?: 'TrackedMdesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TrackedMdes>;
};

/** input type for inserting object relation for remote table "tracked_mdes" */
export type TrackedMdesObjRelInsertInput = {
  data: TrackedMdesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<TrackedMdesOnConflict>;
};

/** on_conflict condition type for table "tracked_mdes" */
export type TrackedMdesOnConflict = {
  constraint: TrackedMdesConstraint;
  updateColumns?: Array<TrackedMdesUpdateColumn>;
  where?: InputMaybe<TrackedMdesBoolExp>;
};

/** Ordering options when selecting data from "tracked_mdes". */
export type TrackedMdesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  googleSpreadsheetsAggregate?: InputMaybe<GoogleSpreadsheetsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  project?: InputMaybe<ProjectsOrderBy>;
  projectId?: InputMaybe<OrderBy>;
  shortName?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  trackedMdeEnvironmentsAggregate?: InputMaybe<TrackedMdeEnvironmentsAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: tracked_mdes */
export type TrackedMdesPkColumnsInput = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "tracked_mdes" */
export enum TrackedMdesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  ShortName = 'shortName',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "tracked_mdes" */
export type TrackedMdesSetInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TrackedTenantsStatesEnum>;
};

/** columns and relationships of "tracked_mdes_states" */
export type TrackedMdesStates = {
  __typename?: 'TrackedMdesStates';
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "tracked_mdes_states". All fields are combined with a logical 'AND'. */
export type TrackedMdesStatesBoolExp = {
  _and?: InputMaybe<Array<TrackedMdesStatesBoolExp>>;
  _not?: InputMaybe<TrackedMdesStatesBoolExp>;
  _or?: InputMaybe<Array<TrackedMdesStatesBoolExp>>;
  value?: InputMaybe<StringComparisonExp>;
};

/** Ordering options when selecting data from "tracked_mdes_states". */
export type TrackedMdesStatesOrderBy = {
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "tracked_mdes_states" */
export enum TrackedMdesStatesSelectColumn {
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "tracked_mdes_states" */
export type TrackedMdesStatesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TrackedMdesStatesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TrackedMdesStatesStreamCursorValueInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** order by stddev() on columns of table "tracked_mdes" */
export type TrackedMdesStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "tracked_mdes" */
export type TrackedMdesStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "tracked_mdes" */
export type TrackedMdesStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "tracked_mdes" */
export type TrackedMdesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TrackedMdesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TrackedMdesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['bigint']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TrackedTenantsStatesEnum>;
  tenantId?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "tracked_mdes" */
export type TrackedMdesSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** update columns of table "tracked_mdes" */
export enum TrackedMdesUpdateColumn {
  /** column name */
  Name = 'name',
  /** column name */
  ShortName = 'shortName',
  /** column name */
  Status = 'status'
}

export type TrackedMdesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TrackedMdesSetInput>;
  /** filter the rows which have to be updated */
  where: TrackedMdesBoolExp;
};

/** order by varPop() on columns of table "tracked_mdes" */
export type TrackedMdesVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "tracked_mdes" */
export type TrackedMdesVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "tracked_mdes" */
export type TrackedMdesVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "tracked_tenant_environments" */
export type TrackedTenantEnvironments = {
  __typename?: 'TrackedTenantEnvironments';
  /** An object relationship */
  environment: Environments;
  environmentId: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  lastKnownTenantId?: Maybe<Scalars['String']['output']>;
  lastSyncedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantData?: Maybe<Scalars['jsonb']['output']>;
  tenantId: Scalars['bigint']['output'];
  tenantLocale?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  trackedTenant: TrackedTenants;
  trackedTenantId: Scalars['bigint']['output'];
};


/** columns and relationships of "tracked_tenant_environments" */
export type TrackedTenantEnvironmentsTenantDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "tracked_tenant_environments" */
export type TrackedTenantEnvironmentsAggregateOrderBy = {
  avg?: InputMaybe<TrackedTenantEnvironmentsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<TrackedTenantEnvironmentsMaxOrderBy>;
  min?: InputMaybe<TrackedTenantEnvironmentsMinOrderBy>;
  stddev?: InputMaybe<TrackedTenantEnvironmentsStddevOrderBy>;
  stddevPop?: InputMaybe<TrackedTenantEnvironmentsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<TrackedTenantEnvironmentsStddevSampOrderBy>;
  sum?: InputMaybe<TrackedTenantEnvironmentsSumOrderBy>;
  varPop?: InputMaybe<TrackedTenantEnvironmentsVarPopOrderBy>;
  varSamp?: InputMaybe<TrackedTenantEnvironmentsVarSampOrderBy>;
  variance?: InputMaybe<TrackedTenantEnvironmentsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type TrackedTenantEnvironmentsAppendInput = {
  tenantData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tracked_tenant_environments" */
export type TrackedTenantEnvironmentsArrRelInsertInput = {
  data: Array<TrackedTenantEnvironmentsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<TrackedTenantEnvironmentsOnConflict>;
};

/** order by avg() on columns of table "tracked_tenant_environments" */
export type TrackedTenantEnvironmentsAvgOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  trackedTenantId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "tracked_tenant_environments". All fields are combined with a logical 'AND'. */
export type TrackedTenantEnvironmentsBoolExp = {
  _and?: InputMaybe<Array<TrackedTenantEnvironmentsBoolExp>>;
  _not?: InputMaybe<TrackedTenantEnvironmentsBoolExp>;
  _or?: InputMaybe<Array<TrackedTenantEnvironmentsBoolExp>>;
  environment?: InputMaybe<EnvironmentsBoolExp>;
  environmentId?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  lastKnownTenantId?: InputMaybe<StringComparisonExp>;
  lastSyncedAt?: InputMaybe<TimestamptzComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantData?: InputMaybe<JsonbComparisonExp>;
  tenantId?: InputMaybe<BigintComparisonExp>;
  tenantLocale?: InputMaybe<StringComparisonExp>;
  trackedTenant?: InputMaybe<TrackedTenantsBoolExp>;
  trackedTenantId?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "tracked_tenant_environments" */
export enum TrackedTenantEnvironmentsConstraint {
  /** unique or primary key constraint on columns "tracked_tenant_id", "environment_id" */
  TrackedTenantEnvironmentsEnvironmentIdTrackedTenantIKey = 'tracked_tenant_environments_environment_id_tracked_tenant_i_key',
  /** unique or primary key constraint on columns "id" */
  TrackedTenantEnvironmentsPkey = 'tracked_tenant_environments_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type TrackedTenantEnvironmentsDeleteAtPathInput = {
  tenantData?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type TrackedTenantEnvironmentsDeleteElemInput = {
  tenantData?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type TrackedTenantEnvironmentsDeleteKeyInput = {
  tenantData?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "tracked_tenant_environments" */
export type TrackedTenantEnvironmentsIncInput = {
  tenantId?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "tracked_tenant_environments" */
export type TrackedTenantEnvironmentsInsertInput = {
  environment?: InputMaybe<EnvironmentsObjRelInsertInput>;
  environmentId?: InputMaybe<Scalars['bigint']['input']>;
  lastKnownTenantId?: InputMaybe<Scalars['String']['input']>;
  lastSyncedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  tenantData?: InputMaybe<Scalars['jsonb']['input']>;
  tenantId?: InputMaybe<Scalars['bigint']['input']>;
  tenantLocale?: InputMaybe<Scalars['String']['input']>;
  trackedTenant?: InputMaybe<TrackedTenantsObjRelInsertInput>;
  trackedTenantId?: InputMaybe<Scalars['bigint']['input']>;
};

/** order by max() on columns of table "tracked_tenant_environments" */
export type TrackedTenantEnvironmentsMaxOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastKnownTenantId?: InputMaybe<OrderBy>;
  lastSyncedAt?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  tenantLocale?: InputMaybe<OrderBy>;
  trackedTenantId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "tracked_tenant_environments" */
export type TrackedTenantEnvironmentsMinOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastKnownTenantId?: InputMaybe<OrderBy>;
  lastSyncedAt?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  tenantLocale?: InputMaybe<OrderBy>;
  trackedTenantId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "tracked_tenant_environments" */
export type TrackedTenantEnvironmentsMutationResponse = {
  __typename?: 'TrackedTenantEnvironmentsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TrackedTenantEnvironments>;
};

/** on_conflict condition type for table "tracked_tenant_environments" */
export type TrackedTenantEnvironmentsOnConflict = {
  constraint: TrackedTenantEnvironmentsConstraint;
  updateColumns?: Array<TrackedTenantEnvironmentsUpdateColumn>;
  where?: InputMaybe<TrackedTenantEnvironmentsBoolExp>;
};

/** Ordering options when selecting data from "tracked_tenant_environments". */
export type TrackedTenantEnvironmentsOrderBy = {
  environment?: InputMaybe<EnvironmentsOrderBy>;
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastKnownTenantId?: InputMaybe<OrderBy>;
  lastSyncedAt?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantData?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  tenantLocale?: InputMaybe<OrderBy>;
  trackedTenant?: InputMaybe<TrackedTenantsOrderBy>;
  trackedTenantId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: tracked_tenant_environments */
export type TrackedTenantEnvironmentsPkColumnsInput = {
  id: Scalars['bigint']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type TrackedTenantEnvironmentsPrependInput = {
  tenantData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tracked_tenant_environments" */
export enum TrackedTenantEnvironmentsSelectColumn {
  /** column name */
  EnvironmentId = 'environmentId',
  /** column name */
  Id = 'id',
  /** column name */
  LastKnownTenantId = 'lastKnownTenantId',
  /** column name */
  LastSyncedAt = 'lastSyncedAt',
  /** column name */
  TenantData = 'tenantData',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  TenantLocale = 'tenantLocale',
  /** column name */
  TrackedTenantId = 'trackedTenantId'
}

/** input type for updating data in table "tracked_tenant_environments" */
export type TrackedTenantEnvironmentsSetInput = {
  lastKnownTenantId?: InputMaybe<Scalars['String']['input']>;
  lastSyncedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  tenantData?: InputMaybe<Scalars['jsonb']['input']>;
  tenantId?: InputMaybe<Scalars['bigint']['input']>;
  tenantLocale?: InputMaybe<Scalars['String']['input']>;
};

/** order by stddev() on columns of table "tracked_tenant_environments" */
export type TrackedTenantEnvironmentsStddevOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  trackedTenantId?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "tracked_tenant_environments" */
export type TrackedTenantEnvironmentsStddevPopOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  trackedTenantId?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "tracked_tenant_environments" */
export type TrackedTenantEnvironmentsStddevSampOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  trackedTenantId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "tracked_tenant_environments" */
export type TrackedTenantEnvironmentsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TrackedTenantEnvironmentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TrackedTenantEnvironmentsStreamCursorValueInput = {
  environmentId?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lastKnownTenantId?: InputMaybe<Scalars['String']['input']>;
  lastSyncedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  tenantData?: InputMaybe<Scalars['jsonb']['input']>;
  tenantId?: InputMaybe<Scalars['bigint']['input']>;
  tenantLocale?: InputMaybe<Scalars['String']['input']>;
  trackedTenantId?: InputMaybe<Scalars['bigint']['input']>;
};

/** order by sum() on columns of table "tracked_tenant_environments" */
export type TrackedTenantEnvironmentsSumOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  trackedTenantId?: InputMaybe<OrderBy>;
};

/** update columns of table "tracked_tenant_environments" */
export enum TrackedTenantEnvironmentsUpdateColumn {
  /** column name */
  LastKnownTenantId = 'lastKnownTenantId',
  /** column name */
  LastSyncedAt = 'lastSyncedAt',
  /** column name */
  TenantData = 'tenantData',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  TenantLocale = 'tenantLocale'
}

export type TrackedTenantEnvironmentsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<TrackedTenantEnvironmentsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<TrackedTenantEnvironmentsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<TrackedTenantEnvironmentsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<TrackedTenantEnvironmentsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TrackedTenantEnvironmentsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<TrackedTenantEnvironmentsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TrackedTenantEnvironmentsSetInput>;
  /** filter the rows which have to be updated */
  where: TrackedTenantEnvironmentsBoolExp;
};

/** order by varPop() on columns of table "tracked_tenant_environments" */
export type TrackedTenantEnvironmentsVarPopOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  trackedTenantId?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "tracked_tenant_environments" */
export type TrackedTenantEnvironmentsVarSampOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  trackedTenantId?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "tracked_tenant_environments" */
export type TrackedTenantEnvironmentsVarianceOrderBy = {
  environmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  trackedTenantId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "tracked_tenants" */
export type TrackedTenants = {
  __typename?: 'TrackedTenants';
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  googleSpreadsheets: Array<GoogleSpreadsheets>;
  /** An aggregate relationship */
  googleSpreadsheetsAggregate: GoogleSpreadsheetsAggregate;
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  project: Projects;
  projectId: Scalars['bigint']['output'];
  shortName: Scalars['String']['output'];
  status: TrackedTenantsStatesEnum;
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['bigint']['output'];
  /** An array relationship */
  trackedTenantEnvironments: Array<TrackedTenantEnvironments>;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "tracked_tenants" */
export type TrackedTenantsGoogleSpreadsheetsArgs = {
  distinctOn?: InputMaybe<Array<GoogleSpreadsheetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSpreadsheetsOrderBy>>;
  where?: InputMaybe<GoogleSpreadsheetsBoolExp>;
};


/** columns and relationships of "tracked_tenants" */
export type TrackedTenantsGoogleSpreadsheetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GoogleSpreadsheetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSpreadsheetsOrderBy>>;
  where?: InputMaybe<GoogleSpreadsheetsBoolExp>;
};


/** columns and relationships of "tracked_tenants" */
export type TrackedTenantsTrackedTenantEnvironmentsArgs = {
  distinctOn?: InputMaybe<Array<TrackedTenantEnvironmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrackedTenantEnvironmentsOrderBy>>;
  where?: InputMaybe<TrackedTenantEnvironmentsBoolExp>;
};

/** aggregated selection of "tracked_tenants" */
export type TrackedTenantsAggregate = {
  __typename?: 'TrackedTenantsAggregate';
  aggregate?: Maybe<TrackedTenantsAggregateFields>;
  nodes: Array<TrackedTenants>;
};

export type TrackedTenantsAggregateBoolExp = {
  count?: InputMaybe<TrackedTenantsAggregateBoolExpCount>;
};

/** aggregate fields of "tracked_tenants" */
export type TrackedTenantsAggregateFields = {
  __typename?: 'TrackedTenantsAggregateFields';
  avg?: Maybe<TrackedTenantsAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<TrackedTenantsMaxFields>;
  min?: Maybe<TrackedTenantsMinFields>;
  stddev?: Maybe<TrackedTenantsStddevFields>;
  stddevPop?: Maybe<TrackedTenantsStddevPopFields>;
  stddevSamp?: Maybe<TrackedTenantsStddevSampFields>;
  sum?: Maybe<TrackedTenantsSumFields>;
  varPop?: Maybe<TrackedTenantsVarPopFields>;
  varSamp?: Maybe<TrackedTenantsVarSampFields>;
  variance?: Maybe<TrackedTenantsVarianceFields>;
};


/** aggregate fields of "tracked_tenants" */
export type TrackedTenantsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TrackedTenantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tracked_tenants" */
export type TrackedTenantsAggregateOrderBy = {
  avg?: InputMaybe<TrackedTenantsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<TrackedTenantsMaxOrderBy>;
  min?: InputMaybe<TrackedTenantsMinOrderBy>;
  stddev?: InputMaybe<TrackedTenantsStddevOrderBy>;
  stddevPop?: InputMaybe<TrackedTenantsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<TrackedTenantsStddevSampOrderBy>;
  sum?: InputMaybe<TrackedTenantsSumOrderBy>;
  varPop?: InputMaybe<TrackedTenantsVarPopOrderBy>;
  varSamp?: InputMaybe<TrackedTenantsVarSampOrderBy>;
  variance?: InputMaybe<TrackedTenantsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "tracked_tenants" */
export type TrackedTenantsArrRelInsertInput = {
  data: Array<TrackedTenantsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<TrackedTenantsOnConflict>;
};

/** aggregate avg on columns */
export type TrackedTenantsAvgFields = {
  __typename?: 'TrackedTenantsAvgFields';
  id?: Maybe<Scalars['Float']['output']>;
  projectId?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "tracked_tenants" */
export type TrackedTenantsAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "tracked_tenants". All fields are combined with a logical 'AND'. */
export type TrackedTenantsBoolExp = {
  _and?: InputMaybe<Array<TrackedTenantsBoolExp>>;
  _not?: InputMaybe<TrackedTenantsBoolExp>;
  _or?: InputMaybe<Array<TrackedTenantsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  googleSpreadsheets?: InputMaybe<GoogleSpreadsheetsBoolExp>;
  googleSpreadsheetsAggregate?: InputMaybe<GoogleSpreadsheetsAggregateBoolExp>;
  id?: InputMaybe<BigintComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  project?: InputMaybe<ProjectsBoolExp>;
  projectId?: InputMaybe<BigintComparisonExp>;
  shortName?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<TrackedTenantsStatesEnumComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<BigintComparisonExp>;
  trackedTenantEnvironments?: InputMaybe<TrackedTenantEnvironmentsBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "tracked_tenants" */
export enum TrackedTenantsConstraint {
  /** unique or primary key constraint on columns "id" */
  TrackedTenantsPkey = 'tracked_tenants_pkey',
  /** unique or primary key constraint on columns "short_name", "project_id" */
  TrackedTenantsProjectIdShortNameKey = 'tracked_tenants_project_id_short_name_key'
}

/** input type for inserting data into table "tracked_tenants" */
export type TrackedTenantsInsertInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<ProjectsObjRelInsertInput>;
  projectId?: InputMaybe<Scalars['bigint']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TrackedTenantsStatesEnum>;
  tenantId?: InputMaybe<Scalars['bigint']['input']>;
  trackedTenantEnvironments?: InputMaybe<TrackedTenantEnvironmentsArrRelInsertInput>;
};

/** aggregate max on columns */
export type TrackedTenantsMaxFields = {
  __typename?: 'TrackedTenantsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['bigint']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "tracked_tenants" */
export type TrackedTenantsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  shortName?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type TrackedTenantsMinFields = {
  __typename?: 'TrackedTenantsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['bigint']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "tracked_tenants" */
export type TrackedTenantsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  shortName?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "tracked_tenants" */
export type TrackedTenantsMutationResponse = {
  __typename?: 'TrackedTenantsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TrackedTenants>;
};

/** input type for inserting object relation for remote table "tracked_tenants" */
export type TrackedTenantsObjRelInsertInput = {
  data: TrackedTenantsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<TrackedTenantsOnConflict>;
};

/** on_conflict condition type for table "tracked_tenants" */
export type TrackedTenantsOnConflict = {
  constraint: TrackedTenantsConstraint;
  updateColumns?: Array<TrackedTenantsUpdateColumn>;
  where?: InputMaybe<TrackedTenantsBoolExp>;
};

/** Ordering options when selecting data from "tracked_tenants". */
export type TrackedTenantsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  googleSpreadsheetsAggregate?: InputMaybe<GoogleSpreadsheetsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  project?: InputMaybe<ProjectsOrderBy>;
  projectId?: InputMaybe<OrderBy>;
  shortName?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  trackedTenantEnvironmentsAggregate?: InputMaybe<TrackedTenantEnvironmentsAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: tracked_tenants */
export type TrackedTenantsPkColumnsInput = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "tracked_tenants" */
export enum TrackedTenantsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  ShortName = 'shortName',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "tracked_tenants" */
export type TrackedTenantsSetInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TrackedTenantsStatesEnum>;
};

/** columns and relationships of "tracked_tenants_states" */
export type TrackedTenantsStates = {
  __typename?: 'TrackedTenantsStates';
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "tracked_tenants_states". All fields are combined with a logical 'AND'. */
export type TrackedTenantsStatesBoolExp = {
  _and?: InputMaybe<Array<TrackedTenantsStatesBoolExp>>;
  _not?: InputMaybe<TrackedTenantsStatesBoolExp>;
  _or?: InputMaybe<Array<TrackedTenantsStatesBoolExp>>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum TrackedTenantsStatesEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** Boolean expression to compare columns of type "TrackedTenantsStatesEnum". All fields are combined with logical 'AND'. */
export type TrackedTenantsStatesEnumComparisonExp = {
  _eq?: InputMaybe<TrackedTenantsStatesEnum>;
  _in?: InputMaybe<Array<TrackedTenantsStatesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<TrackedTenantsStatesEnum>;
  _nin?: InputMaybe<Array<TrackedTenantsStatesEnum>>;
};

/** Ordering options when selecting data from "tracked_tenants_states". */
export type TrackedTenantsStatesOrderBy = {
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "tracked_tenants_states" */
export enum TrackedTenantsStatesSelectColumn {
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "tracked_tenants_states" */
export type TrackedTenantsStatesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TrackedTenantsStatesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TrackedTenantsStatesStreamCursorValueInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type TrackedTenantsStddevFields = {
  __typename?: 'TrackedTenantsStddevFields';
  id?: Maybe<Scalars['Float']['output']>;
  projectId?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "tracked_tenants" */
export type TrackedTenantsStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type TrackedTenantsStddevPopFields = {
  __typename?: 'TrackedTenantsStddevPopFields';
  id?: Maybe<Scalars['Float']['output']>;
  projectId?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevPop() on columns of table "tracked_tenants" */
export type TrackedTenantsStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type TrackedTenantsStddevSampFields = {
  __typename?: 'TrackedTenantsStddevSampFields';
  id?: Maybe<Scalars['Float']['output']>;
  projectId?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevSamp() on columns of table "tracked_tenants" */
export type TrackedTenantsStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "tracked_tenants" */
export type TrackedTenantsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TrackedTenantsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TrackedTenantsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['bigint']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TrackedTenantsStatesEnum>;
  tenantId?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type TrackedTenantsSumFields = {
  __typename?: 'TrackedTenantsSumFields';
  id?: Maybe<Scalars['bigint']['output']>;
  projectId?: Maybe<Scalars['bigint']['output']>;
  tenantId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "tracked_tenants" */
export type TrackedTenantsSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** update columns of table "tracked_tenants" */
export enum TrackedTenantsUpdateColumn {
  /** column name */
  Name = 'name',
  /** column name */
  ShortName = 'shortName',
  /** column name */
  Status = 'status'
}

export type TrackedTenantsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TrackedTenantsSetInput>;
  /** filter the rows which have to be updated */
  where: TrackedTenantsBoolExp;
};

/** aggregate varPop on columns */
export type TrackedTenantsVarPopFields = {
  __typename?: 'TrackedTenantsVarPopFields';
  id?: Maybe<Scalars['Float']['output']>;
  projectId?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['Float']['output']>;
};

/** order by varPop() on columns of table "tracked_tenants" */
export type TrackedTenantsVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type TrackedTenantsVarSampFields = {
  __typename?: 'TrackedTenantsVarSampFields';
  id?: Maybe<Scalars['Float']['output']>;
  projectId?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['Float']['output']>;
};

/** order by varSamp() on columns of table "tracked_tenants" */
export type TrackedTenantsVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type TrackedTenantsVarianceFields = {
  __typename?: 'TrackedTenantsVarianceFields';
  id?: Maybe<Scalars['Float']['output']>;
  projectId?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "tracked_tenants" */
export type TrackedTenantsVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  projectId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "user_roles" */
export type UserRoles = {
  __typename?: 'UserRoles';
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "user_roles". All fields are combined with a logical 'AND'. */
export type UserRolesBoolExp = {
  _and?: InputMaybe<Array<UserRolesBoolExp>>;
  _not?: InputMaybe<UserRolesBoolExp>;
  _or?: InputMaybe<Array<UserRolesBoolExp>>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum UserRolesEnum {
  TenantAdmin = 'TENANT_ADMIN'
}

/** Boolean expression to compare columns of type "UserRolesEnum". All fields are combined with logical 'AND'. */
export type UserRolesEnumComparisonExp = {
  _eq?: InputMaybe<UserRolesEnum>;
  _in?: InputMaybe<Array<UserRolesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<UserRolesEnum>;
  _nin?: InputMaybe<Array<UserRolesEnum>>;
};

/** Ordering options when selecting data from "user_roles". */
export type UserRolesOrderBy = {
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "user_roles" */
export enum UserRolesSelectColumn {
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "user_roles" */
export type UserRolesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserRolesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserRolesStreamCursorValueInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "user_states" */
export type UserStates = {
  __typename?: 'UserStates';
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "user_states". All fields are combined with a logical 'AND'. */
export type UserStatesBoolExp = {
  _and?: InputMaybe<Array<UserStatesBoolExp>>;
  _not?: InputMaybe<UserStatesBoolExp>;
  _or?: InputMaybe<Array<UserStatesBoolExp>>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum UserStatesEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** Boolean expression to compare columns of type "UserStatesEnum". All fields are combined with logical 'AND'. */
export type UserStatesEnumComparisonExp = {
  _eq?: InputMaybe<UserStatesEnum>;
  _in?: InputMaybe<Array<UserStatesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<UserStatesEnum>;
  _nin?: InputMaybe<Array<UserStatesEnum>>;
};

/** Ordering options when selecting data from "user_states". */
export type UserStatesOrderBy = {
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "user_states" */
export enum UserStatesSelectColumn {
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "user_states" */
export type UserStatesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserStatesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserStatesStreamCursorValueInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "user_tenants" */
export type UserTenants = {
  __typename?: 'UserTenants';
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['bigint']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['bigint']['output'];
  userRole: UserRolesEnum;
};

/** order by aggregate values of table "user_tenants" */
export type UserTenantsAggregateOrderBy = {
  avg?: InputMaybe<UserTenantsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserTenantsMaxOrderBy>;
  min?: InputMaybe<UserTenantsMinOrderBy>;
  stddev?: InputMaybe<UserTenantsStddevOrderBy>;
  stddevPop?: InputMaybe<UserTenantsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<UserTenantsStddevSampOrderBy>;
  sum?: InputMaybe<UserTenantsSumOrderBy>;
  varPop?: InputMaybe<UserTenantsVarPopOrderBy>;
  varSamp?: InputMaybe<UserTenantsVarSampOrderBy>;
  variance?: InputMaybe<UserTenantsVarianceOrderBy>;
};

/** order by avg() on columns of table "user_tenants" */
export type UserTenantsAvgOrderBy = {
  tenantId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "user_tenants". All fields are combined with a logical 'AND'. */
export type UserTenantsBoolExp = {
  _and?: InputMaybe<Array<UserTenantsBoolExp>>;
  _not?: InputMaybe<UserTenantsBoolExp>;
  _or?: InputMaybe<Array<UserTenantsBoolExp>>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<BigintComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<BigintComparisonExp>;
  userRole?: InputMaybe<UserRolesEnumComparisonExp>;
};

/** order by max() on columns of table "user_tenants" */
export type UserTenantsMaxOrderBy = {
  tenantId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "user_tenants" */
export type UserTenantsMinOrderBy = {
  tenantId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "user_tenants". */
export type UserTenantsOrderBy = {
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  userRole?: InputMaybe<OrderBy>;
};

/** select columns of table "user_tenants" */
export enum UserTenantsSelectColumn {
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UserId = 'userId',
  /** column name */
  UserRole = 'userRole'
}

/** order by stddev() on columns of table "user_tenants" */
export type UserTenantsStddevOrderBy = {
  tenantId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "user_tenants" */
export type UserTenantsStddevPopOrderBy = {
  tenantId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "user_tenants" */
export type UserTenantsStddevSampOrderBy = {
  tenantId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "user_tenants" */
export type UserTenantsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserTenantsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserTenantsStreamCursorValueInput = {
  tenantId?: InputMaybe<Scalars['bigint']['input']>;
  userId?: InputMaybe<Scalars['bigint']['input']>;
  userRole?: InputMaybe<UserRolesEnum>;
};

/** order by sum() on columns of table "user_tenants" */
export type UserTenantsSumOrderBy = {
  tenantId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "user_tenants" */
export type UserTenantsVarPopOrderBy = {
  tenantId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "user_tenants" */
export type UserTenantsVarSampOrderBy = {
  tenantId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "user_tenants" */
export type UserTenantsVarianceOrderBy = {
  tenantId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'Users';
  clerkId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  emailVerified?: Maybe<Scalars['timestamptz']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  googleSpreadsheetSyncs: Array<GoogleSpreadsheetSyncs>;
  /** An aggregate relationship */
  googleSpreadsheetSyncsAggregate: GoogleSpreadsheetSyncsAggregate;
  id: Scalars['bigint']['output'];
  lastSignIn?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  lastTenant?: Maybe<Tenants>;
  lastTenantId?: Maybe<Scalars['bigint']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** An array relationship */
  ownedTenants: Array<Tenants>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  status: UserStatesEnum;
  /** An array relationship */
  userTenants: Array<UserTenants>;
};


/** columns and relationships of "users" */
export type UsersGoogleSpreadsheetSyncsArgs = {
  distinctOn?: InputMaybe<Array<GoogleSpreadsheetSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSpreadsheetSyncsOrderBy>>;
  where?: InputMaybe<GoogleSpreadsheetSyncsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersGoogleSpreadsheetSyncsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GoogleSpreadsheetSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSpreadsheetSyncsOrderBy>>;
  where?: InputMaybe<GoogleSpreadsheetSyncsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersOwnedTenantsArgs = {
  distinctOn?: InputMaybe<Array<TenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantsOrderBy>>;
  where?: InputMaybe<TenantsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersUserTenantsArgs = {
  distinctOn?: InputMaybe<Array<UserTenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserTenantsOrderBy>>;
  where?: InputMaybe<UserTenantsBoolExp>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type UsersBoolExp = {
  _and?: InputMaybe<Array<UsersBoolExp>>;
  _not?: InputMaybe<UsersBoolExp>;
  _or?: InputMaybe<Array<UsersBoolExp>>;
  clerkId?: InputMaybe<StringComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  emailVerified?: InputMaybe<TimestamptzComparisonExp>;
  familyName?: InputMaybe<StringComparisonExp>;
  givenName?: InputMaybe<StringComparisonExp>;
  googleSpreadsheetSyncs?: InputMaybe<GoogleSpreadsheetSyncsBoolExp>;
  googleSpreadsheetSyncsAggregate?: InputMaybe<GoogleSpreadsheetSyncsAggregateBoolExp>;
  id?: InputMaybe<BigintComparisonExp>;
  lastSignIn?: InputMaybe<TimestamptzComparisonExp>;
  lastTenant?: InputMaybe<TenantsBoolExp>;
  lastTenantId?: InputMaybe<BigintComparisonExp>;
  locale?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  ownedTenants?: InputMaybe<TenantsBoolExp>;
  pictureUrl?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<UserStatesEnumComparisonExp>;
  userTenants?: InputMaybe<UserTenantsBoolExp>;
};

/** unique or primary key constraints on table "users" */
export enum UsersConstraint {
  /** unique or primary key constraint on columns "clerk_id" */
  UsersClerkIdIdx = 'users_clerk_id_idx',
  /** unique or primary key constraint on columns "email" */
  UsersEmailUniq = 'users_email_uniq',
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey'
}

/** input type for incrementing numeric columns in table "users" */
export type UsersIncInput = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "users" */
export type UsersInsertInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  emailVerified?: InputMaybe<Scalars['timestamptz']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lastSignIn?: InputMaybe<Scalars['timestamptz']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pictureUrl?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatesEnum>;
};

/** response of any mutation on the table "users" */
export type UsersMutationResponse = {
  __typename?: 'UsersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** on_conflict condition type for table "users" */
export type UsersOnConflict = {
  constraint: UsersConstraint;
  updateColumns?: Array<UsersUpdateColumn>;
  where?: InputMaybe<UsersBoolExp>;
};

/** Ordering options when selecting data from "users". */
export type UsersOrderBy = {
  clerkId?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  emailVerified?: InputMaybe<OrderBy>;
  familyName?: InputMaybe<OrderBy>;
  givenName?: InputMaybe<OrderBy>;
  googleSpreadsheetSyncsAggregate?: InputMaybe<GoogleSpreadsheetSyncsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  lastSignIn?: InputMaybe<OrderBy>;
  lastTenant?: InputMaybe<TenantsOrderBy>;
  lastTenantId?: InputMaybe<OrderBy>;
  locale?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  ownedTenantsAggregate?: InputMaybe<TenantsAggregateOrderBy>;
  pictureUrl?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  userTenantsAggregate?: InputMaybe<UserTenantsAggregateOrderBy>;
};

/** primary key columns input for table: users */
export type UsersPkColumnsInput = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "users" */
export enum UsersSelectColumn {
  /** column name */
  ClerkId = 'clerkId',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerified = 'emailVerified',
  /** column name */
  FamilyName = 'familyName',
  /** column name */
  GivenName = 'givenName',
  /** column name */
  Id = 'id',
  /** column name */
  LastSignIn = 'lastSignIn',
  /** column name */
  LastTenantId = 'lastTenantId',
  /** column name */
  Locale = 'locale',
  /** column name */
  Name = 'name',
  /** column name */
  PictureUrl = 'pictureUrl',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "users" */
export type UsersSetInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  emailVerified?: InputMaybe<Scalars['timestamptz']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lastSignIn?: InputMaybe<Scalars['timestamptz']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pictureUrl?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatesEnum>;
};

/** Streaming cursor of the table "users" */
export type UsersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UsersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UsersStreamCursorValueInput = {
  clerkId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailVerified?: InputMaybe<Scalars['timestamptz']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lastSignIn?: InputMaybe<Scalars['timestamptz']['input']>;
  lastTenantId?: InputMaybe<Scalars['bigint']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pictureUrl?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatesEnum>;
};

/** update columns of table "users" */
export enum UsersUpdateColumn {
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerified = 'emailVerified',
  /** column name */
  FamilyName = 'familyName',
  /** column name */
  GivenName = 'givenName',
  /** column name */
  Id = 'id',
  /** column name */
  LastSignIn = 'lastSignIn',
  /** column name */
  Locale = 'locale',
  /** column name */
  Name = 'name',
  /** column name */
  PictureUrl = 'pictureUrl',
  /** column name */
  Status = 'status'
}

export type UsersUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UsersIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UsersSetInput>;
  /** filter the rows which have to be updated */
  where: UsersBoolExp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type UuidComparisonExp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type XyPosition = {
  __typename?: 'XYPosition';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type XyPositionInput = {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type AssignPgtunnelToEnvironmentArgs = {
  _environment_id?: InputMaybe<Scalars['bigint']['input']>;
};

export type CreateGoogleSpreadsheetResult = {
  __typename?: 'createGoogleSpreadsheetResult';
  createdGoogleSpreadsheetId: Scalars['String']['output'];
};

export type CreateTenantArgs = {
  _email?: InputMaybe<Scalars['String']['input']>;
  _logo?: InputMaybe<Scalars['String']['input']>;
  _name?: InputMaybe<Scalars['String']['input']>;
  _slug?: InputMaybe<Scalars['String']['input']>;
};

export type GoogleSpreadsheetOverviewArgs = {
  _project_id?: InputMaybe<Scalars['bigint']['input']>;
};

export type GoogleSpreadsheetSyncsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<GoogleSpreadsheetSyncsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<GoogleSpreadsheetSyncsBoolExp>;
  predicate: IntComparisonExp;
};

export type GoogleSpreadsheetsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<GoogleSpreadsheetsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<GoogleSpreadsheetsBoolExp>;
  predicate: IntComparisonExp;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** execute VOLATILE function "assign_pgtunnel_to_environment" which returns "pgtunnel_ports" */
  assignPgtunnelToEnvironment: Array<PgtunnelPorts>;
  createDemoPgDatasource?: Maybe<CreateDemoPgDatasourceResult>;
  createEnvironmentPgDatasource?: Maybe<CreateEnvironmentPgDatasourceResult>;
  createGoogleSpreadsheet?: Maybe<CreateGoogleSpreadsheetResult>;
  /** execute VOLATILE function "create_tenant" which returns "tenants" */
  createTenant: Array<Tenants>;
  /** delete data from the table: "datasources" */
  deleteDatasources?: Maybe<DatasourcesMutationResponse>;
  /** delete single row from the table: "datasources" */
  deleteDatasourcesByPk?: Maybe<Datasources>;
  /** delete data from the table: "environments" */
  deleteEnvironments?: Maybe<EnvironmentsMutationResponse>;
  /** delete single row from the table: "environments" */
  deleteEnvironmentsByPk?: Maybe<Environments>;
  deleteGoogleSpreadsheet?: Maybe<Scalars['Boolean']['output']>;
  /** delete data from the table: "projects" */
  deleteProjects?: Maybe<ProjectsMutationResponse>;
  /** delete single row from the table: "projects" */
  deleteProjectsByPk?: Maybe<Projects>;
  deployGASForGoogleSpreadsheet?: Maybe<Scalars['Boolean']['output']>;
  importFromGoogleSpreadsheet?: Maybe<ImportFromGoogleSpreadsheetResult>;
  inferGoogleSpreadsheet?: Maybe<InferGoogleSpreadsheetResult>;
  inferMDECandidates?: Maybe<InferMdeCandidatesResult>;
  /** insert data into the table: "environments" */
  insertEnvironments?: Maybe<EnvironmentsMutationResponse>;
  /** insert a single row into the table: "environments" */
  insertEnvironmentsOne?: Maybe<Environments>;
  /** insert data into the table: "projects" */
  insertProjects?: Maybe<ProjectsMutationResponse>;
  /** insert a single row into the table: "projects" */
  insertProjectsOne?: Maybe<Projects>;
  /** insert data into the table: "tracked_mde_environments" */
  insertTrackedMdeEnvironments?: Maybe<TrackedMdeEnvironmentsMutationResponse>;
  /** insert a single row into the table: "tracked_mde_environments" */
  insertTrackedMdeEnvironmentsOne?: Maybe<TrackedMdeEnvironments>;
  /** insert data into the table: "tracked_mdes" */
  insertTrackedMdes?: Maybe<TrackedMdesMutationResponse>;
  /** insert a single row into the table: "tracked_mdes" */
  insertTrackedMdesOne?: Maybe<TrackedMdes>;
  /** insert data into the table: "tracked_tenant_environments" */
  insertTrackedTenantEnvironments?: Maybe<TrackedTenantEnvironmentsMutationResponse>;
  /** insert a single row into the table: "tracked_tenant_environments" */
  insertTrackedTenantEnvironmentsOne?: Maybe<TrackedTenantEnvironments>;
  /** insert data into the table: "tracked_tenants" */
  insertTrackedTenants?: Maybe<TrackedTenantsMutationResponse>;
  /** insert a single row into the table: "tracked_tenants" */
  insertTrackedTenantsOne?: Maybe<TrackedTenants>;
  /** insert data into the table: "users" */
  insertUsers?: Maybe<UsersMutationResponse>;
  /** insert a single row into the table: "users" */
  insertUsersOne?: Maybe<Users>;
  inviteToTenant?: Maybe<Scalars['Boolean']['output']>;
  previewPostgresEnvironmentSync?: Maybe<PostgresEnvironmentSyncPreview>;
  removeUserFromTenant?: Maybe<Scalars['Boolean']['output']>;
  renderDatasourceSchemaMap?: Maybe<RenderDatasourceSchemaMapResult>;
  schemaMetrics?: Maybe<SchemaMetricsResult>;
  syncDatasourceI18n?: Maybe<Scalars['Boolean']['output']>;
  syncDatasourceSchemaMetadataOverview?: Maybe<Scalars['Boolean']['output']>;
  syncGoogleSpreadsheet?: Maybe<Scalars['Boolean']['output']>;
  syncPostgresEnvironment?: Maybe<PostgresEnvironmentSyncResult>;
  /** update data of the table: "environments" */
  updateEnvironments?: Maybe<EnvironmentsMutationResponse>;
  /** update single row of the table: "environments" */
  updateEnvironmentsByPk?: Maybe<Environments>;
  /** update multiples rows of table: "environments" */
  updateEnvironmentsMany?: Maybe<Array<Maybe<EnvironmentsMutationResponse>>>;
  updateProjectGoogleOauth2Creds?: Maybe<Scalars['Boolean']['output']>;
  updateProjectGoogleOauth2Tokens?: Maybe<Scalars['Boolean']['output']>;
  updateProjectGoogleServiceAccountCreds?: Maybe<Scalars['Boolean']['output']>;
  /** update data of the table: "projects" */
  updateProjects?: Maybe<ProjectsMutationResponse>;
  /** update single row of the table: "projects" */
  updateProjectsByPk?: Maybe<Projects>;
  /** update multiples rows of table: "projects" */
  updateProjectsMany?: Maybe<Array<Maybe<ProjectsMutationResponse>>>;
  /** update data of the table: "tracked_mde_environments" */
  updateTrackedMdeEnvironments?: Maybe<TrackedMdeEnvironmentsMutationResponse>;
  /** update single row of the table: "tracked_mde_environments" */
  updateTrackedMdeEnvironmentsByPk?: Maybe<TrackedMdeEnvironments>;
  /** update multiples rows of table: "tracked_mde_environments" */
  updateTrackedMdeEnvironmentsMany?: Maybe<Array<Maybe<TrackedMdeEnvironmentsMutationResponse>>>;
  /** update data of the table: "tracked_mdes" */
  updateTrackedMdes?: Maybe<TrackedMdesMutationResponse>;
  /** update single row of the table: "tracked_mdes" */
  updateTrackedMdesByPk?: Maybe<TrackedMdes>;
  /** update multiples rows of table: "tracked_mdes" */
  updateTrackedMdesMany?: Maybe<Array<Maybe<TrackedMdesMutationResponse>>>;
  /** update data of the table: "tracked_tenant_environments" */
  updateTrackedTenantEnvironments?: Maybe<TrackedTenantEnvironmentsMutationResponse>;
  /** update single row of the table: "tracked_tenant_environments" */
  updateTrackedTenantEnvironmentsByPk?: Maybe<TrackedTenantEnvironments>;
  /** update multiples rows of table: "tracked_tenant_environments" */
  updateTrackedTenantEnvironmentsMany?: Maybe<Array<Maybe<TrackedTenantEnvironmentsMutationResponse>>>;
  /** update data of the table: "tracked_tenants" */
  updateTrackedTenants?: Maybe<TrackedTenantsMutationResponse>;
  /** update single row of the table: "tracked_tenants" */
  updateTrackedTenantsByPk?: Maybe<TrackedTenants>;
  /** update multiples rows of table: "tracked_tenants" */
  updateTrackedTenantsMany?: Maybe<Array<Maybe<TrackedTenantsMutationResponse>>>;
  /** update data of the table: "users" */
  updateUsers?: Maybe<UsersMutationResponse>;
  /** update single row of the table: "users" */
  updateUsersByPk?: Maybe<Users>;
  /** update multiples rows of table: "users" */
  updateUsersMany?: Maybe<Array<Maybe<UsersMutationResponse>>>;
};


/** mutation root */
export type Mutation_RootAssignPgtunnelToEnvironmentArgs = {
  args: AssignPgtunnelToEnvironmentArgs;
  distinctOn?: InputMaybe<Array<PgtunnelPortsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PgtunnelPortsOrderBy>>;
  where?: InputMaybe<PgtunnelPortsBoolExp>;
};


/** mutation root */
export type Mutation_RootCreateDemoPgDatasourceArgs = {
  connectionString: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootCreateEnvironmentPgDatasourceArgs = {
  connectionString: Scalars['String']['input'];
  environmentId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootCreateGoogleSpreadsheetArgs = {
  environmentId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  sheetName: Scalars['String']['input'];
  spreadsheetName: Scalars['String']['input'];
  trackedMdeId: Scalars['String']['input'];
  trackedTenantId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootCreateTenantArgs = {
  args: CreateTenantArgs;
  distinctOn?: InputMaybe<Array<TenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantsOrderBy>>;
  where?: InputMaybe<TenantsBoolExp>;
};


/** mutation root */
export type Mutation_RootDeleteDatasourcesArgs = {
  where: DatasourcesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteDatasourcesByPkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDeleteEnvironmentsArgs = {
  where: EnvironmentsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEnvironmentsByPkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDeleteGoogleSpreadsheetArgs = {
  googleSpreadsheetId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteProjectsArgs = {
  where: ProjectsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteProjectsByPkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDeployGasForGoogleSpreadsheetArgs = {
  googleSpreadsheetId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootImportFromGoogleSpreadsheetArgs = {
  deleteValues?: InputMaybe<Array<Array<InputMaybe<Scalars['String']['input']>>>>;
  insertValues?: InputMaybe<Array<Array<InputMaybe<Scalars['String']['input']>>>>;
  secret: Scalars['String']['input'];
  updateValues?: InputMaybe<Array<Array<InputMaybe<Scalars['String']['input']>>>>;
  url: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootInferGoogleSpreadsheetArgs = {
  datasourceId: Scalars['String']['input'];
  flow?: InputMaybe<GoogleSpreadsheetReactFlowInput>;
  googleSpreadsheetId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootInferMdeCandidatesArgs = {
  datasourceIds: Array<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootInsertEnvironmentsArgs = {
  objects: Array<EnvironmentsInsertInput>;
  onConflict?: InputMaybe<EnvironmentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEnvironmentsOneArgs = {
  object: EnvironmentsInsertInput;
  onConflict?: InputMaybe<EnvironmentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertProjectsArgs = {
  objects: Array<ProjectsInsertInput>;
  onConflict?: InputMaybe<ProjectsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertProjectsOneArgs = {
  object: ProjectsInsertInput;
  onConflict?: InputMaybe<ProjectsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTrackedMdeEnvironmentsArgs = {
  objects: Array<TrackedMdeEnvironmentsInsertInput>;
  onConflict?: InputMaybe<TrackedMdeEnvironmentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTrackedMdeEnvironmentsOneArgs = {
  object: TrackedMdeEnvironmentsInsertInput;
  onConflict?: InputMaybe<TrackedMdeEnvironmentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTrackedMdesArgs = {
  objects: Array<TrackedMdesInsertInput>;
  onConflict?: InputMaybe<TrackedMdesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTrackedMdesOneArgs = {
  object: TrackedMdesInsertInput;
  onConflict?: InputMaybe<TrackedMdesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTrackedTenantEnvironmentsArgs = {
  objects: Array<TrackedTenantEnvironmentsInsertInput>;
  onConflict?: InputMaybe<TrackedTenantEnvironmentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTrackedTenantEnvironmentsOneArgs = {
  object: TrackedTenantEnvironmentsInsertInput;
  onConflict?: InputMaybe<TrackedTenantEnvironmentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTrackedTenantsArgs = {
  objects: Array<TrackedTenantsInsertInput>;
  onConflict?: InputMaybe<TrackedTenantsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTrackedTenantsOneArgs = {
  object: TrackedTenantsInsertInput;
  onConflict?: InputMaybe<TrackedTenantsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUsersArgs = {
  objects: Array<UsersInsertInput>;
  onConflict?: InputMaybe<UsersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUsersOneArgs = {
  object: UsersInsertInput;
  onConflict?: InputMaybe<UsersOnConflict>;
};


/** mutation root */
export type Mutation_RootInviteToTenantArgs = {
  emails: Array<Scalars['String']['input']>;
  role: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPreviewPostgresEnvironmentSyncArgs = {
  sourceDatasourceId: Scalars['String']['input'];
  sourceMdeWhere?: InputMaybe<Scalars['String']['input']>;
  sourceTrackedTenantId?: InputMaybe<Scalars['String']['input']>;
  targetDatasourceId: Scalars['String']['input'];
  targetTrackedTenantId?: InputMaybe<Scalars['String']['input']>;
  trackedMdeId?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootRemoveUserFromTenantArgs = {
  tenantId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootRenderDatasourceSchemaMapArgs = {
  datasourceId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootSchemaMetricsArgs = {
  datasourceId: Scalars['String']['input'];
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootSyncDatasourceI18nArgs = {
  datasourceId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootSyncDatasourceSchemaMetadataOverviewArgs = {
  datasourceId: Scalars['String']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
};


/** mutation root */
export type Mutation_RootSyncGoogleSpreadsheetArgs = {
  datasourceId: Scalars['String']['input'];
  flow: GoogleSpreadsheetReactFlowInput;
  googleSpreadsheetId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootSyncPostgresEnvironmentArgs = {
  sourceDatasourceId: Scalars['String']['input'];
  sourceMdeWhere?: InputMaybe<Scalars['String']['input']>;
  sourceTrackedTenantId?: InputMaybe<Scalars['String']['input']>;
  targetDatasourceId: Scalars['String']['input'];
  targetTrackedTenantId?: InputMaybe<Scalars['String']['input']>;
  trackedMdeId?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootUpdateEnvironmentsArgs = {
  _inc?: InputMaybe<EnvironmentsIncInput>;
  _set?: InputMaybe<EnvironmentsSetInput>;
  where: EnvironmentsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEnvironmentsByPkArgs = {
  _inc?: InputMaybe<EnvironmentsIncInput>;
  _set?: InputMaybe<EnvironmentsSetInput>;
  pkColumns: EnvironmentsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEnvironmentsManyArgs = {
  updates: Array<EnvironmentsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateProjectGoogleOauth2CredsArgs = {
  creds: GoogleOauth2CredsInput;
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootUpdateProjectGoogleOauth2TokensArgs = {
  creds: GoogleOauth2TokensInput;
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootUpdateProjectGoogleServiceAccountCredsArgs = {
  creds: GoogleServiceAccountCredsInput;
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootUpdateProjectsArgs = {
  _set?: InputMaybe<ProjectsSetInput>;
  where: ProjectsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateProjectsByPkArgs = {
  _set?: InputMaybe<ProjectsSetInput>;
  pkColumns: ProjectsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateProjectsManyArgs = {
  updates: Array<ProjectsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateTrackedMdeEnvironmentsArgs = {
  _set?: InputMaybe<TrackedMdeEnvironmentsSetInput>;
  where: TrackedMdeEnvironmentsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateTrackedMdeEnvironmentsByPkArgs = {
  _set?: InputMaybe<TrackedMdeEnvironmentsSetInput>;
  pkColumns: TrackedMdeEnvironmentsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateTrackedMdeEnvironmentsManyArgs = {
  updates: Array<TrackedMdeEnvironmentsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateTrackedMdesArgs = {
  _set?: InputMaybe<TrackedMdesSetInput>;
  where: TrackedMdesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateTrackedMdesByPkArgs = {
  _set?: InputMaybe<TrackedMdesSetInput>;
  pkColumns: TrackedMdesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateTrackedMdesManyArgs = {
  updates: Array<TrackedMdesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateTrackedTenantEnvironmentsArgs = {
  _append?: InputMaybe<TrackedTenantEnvironmentsAppendInput>;
  _deleteAtPath?: InputMaybe<TrackedTenantEnvironmentsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<TrackedTenantEnvironmentsDeleteElemInput>;
  _deleteKey?: InputMaybe<TrackedTenantEnvironmentsDeleteKeyInput>;
  _inc?: InputMaybe<TrackedTenantEnvironmentsIncInput>;
  _prepend?: InputMaybe<TrackedTenantEnvironmentsPrependInput>;
  _set?: InputMaybe<TrackedTenantEnvironmentsSetInput>;
  where: TrackedTenantEnvironmentsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateTrackedTenantEnvironmentsByPkArgs = {
  _append?: InputMaybe<TrackedTenantEnvironmentsAppendInput>;
  _deleteAtPath?: InputMaybe<TrackedTenantEnvironmentsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<TrackedTenantEnvironmentsDeleteElemInput>;
  _deleteKey?: InputMaybe<TrackedTenantEnvironmentsDeleteKeyInput>;
  _inc?: InputMaybe<TrackedTenantEnvironmentsIncInput>;
  _prepend?: InputMaybe<TrackedTenantEnvironmentsPrependInput>;
  _set?: InputMaybe<TrackedTenantEnvironmentsSetInput>;
  pkColumns: TrackedTenantEnvironmentsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateTrackedTenantEnvironmentsManyArgs = {
  updates: Array<TrackedTenantEnvironmentsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateTrackedTenantsArgs = {
  _set?: InputMaybe<TrackedTenantsSetInput>;
  where: TrackedTenantsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateTrackedTenantsByPkArgs = {
  _set?: InputMaybe<TrackedTenantsSetInput>;
  pkColumns: TrackedTenantsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateTrackedTenantsManyArgs = {
  updates: Array<TrackedTenantsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUsersArgs = {
  _inc?: InputMaybe<UsersIncInput>;
  _set?: InputMaybe<UsersSetInput>;
  where: UsersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUsersByPkArgs = {
  _inc?: InputMaybe<UsersIncInput>;
  _set?: InputMaybe<UsersSetInput>;
  pkColumns: UsersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUsersManyArgs = {
  updates: Array<UsersUpdates>;
};

export type Query_Root = {
  __typename?: 'query_root';
  checkDatasource?: Maybe<RemoteCheckDatasourceResult>;
  /** execute function "get_current_user" which returns "users" */
  currentUser: Array<Users>;
  /** An array relationship */
  datasourceI18ns: Array<DatasourceI18ns>;
  /** fetch data from the table: "datasource_i18ns" using primary key columns */
  datasourceI18nsByPk?: Maybe<DatasourceI18ns>;
  /** fetch data from the table: "datasource_schema_metadata_overview" */
  datasourceSchemaMetadataOverview: Array<DatasourceSchemaMetadataOverview>;
  /** fetch data from the table: "datasource_schema_metadata_overview" using primary key columns */
  datasourceSchemaMetadataOverviewByPk?: Maybe<DatasourceSchemaMetadataOverview>;
  /** An array relationship */
  datasources: Array<Datasources>;
  /** fetch data from the table: "datasources" using primary key columns */
  datasourcesByPk?: Maybe<Datasources>;
  /** fetch data from the table: "environment_types" */
  environmentTypes: Array<EnvironmentTypes>;
  /** fetch data from the table: "environment_types" using primary key columns */
  environmentTypesByPk?: Maybe<EnvironmentTypes>;
  /** An array relationship */
  environments: Array<Environments>;
  /** fetch data from the table: "environments" using primary key columns */
  environmentsByPk?: Maybe<Environments>;
  /** fetch data from the table: "events" */
  events: Array<Events>;
  /** fetch data from the table: "events" using primary key columns */
  eventsByPk?: Maybe<Events>;
  /** An array relationship */
  googleSheets: Array<GoogleSheets>;
  /** fetch data from the table: "google_sheets" using primary key columns */
  googleSheetsByPk?: Maybe<GoogleSheets>;
  /** execute function "google_spreadsheet_overview" which returns "google_spreadsheet_overviews" */
  googleSpreadsheetOverview: Array<GoogleSpreadsheetOverviews>;
  /** fetch data from the table: "google_spreadsheet_overviews" */
  googleSpreadsheetOverviews: Array<GoogleSpreadsheetOverviews>;
  /** An array relationship */
  googleSpreadsheetSyncs: Array<GoogleSpreadsheetSyncs>;
  /** An aggregate relationship */
  googleSpreadsheetSyncsAggregate: GoogleSpreadsheetSyncsAggregate;
  /** fetch data from the table: "google_spreadsheet_syncs" using primary key columns */
  googleSpreadsheetSyncsByPk?: Maybe<GoogleSpreadsheetSyncs>;
  /** An array relationship */
  googleSpreadsheets: Array<GoogleSpreadsheets>;
  /** An aggregate relationship */
  googleSpreadsheetsAggregate: GoogleSpreadsheetsAggregate;
  /** fetch data from the table: "google_spreadsheets" using primary key columns */
  googleSpreadsheetsByPk?: Maybe<GoogleSpreadsheets>;
  healthcheck?: Maybe<Scalars['Boolean']['output']>;
  listMDEs?: Maybe<Array<Maybe<RemoteListMdEsResult>>>;
  listProjectGoogleDriveFolders?: Maybe<Array<GoogleDriveFolder>>;
  listTenants?: Maybe<Array<Maybe<RemoteListTenantsResult>>>;
  /** An array relationship */
  pgtunnelPorts: Array<PgtunnelPorts>;
  /** fetch data from the table: "pgtunnel_ports" using primary key columns */
  pgtunnelPortsByPk?: Maybe<PgtunnelPorts>;
  /** An array relationship */
  projects: Array<Projects>;
  /** fetch data from the table: "projects" using primary key columns */
  projectsByPk?: Maybe<Projects>;
  readMDE?: Maybe<RemoteReadMdeResult>;
  /** fetch data from the table: "subscription_plans" */
  subscriptionPlans: Array<SubscriptionPlans>;
  /** fetch data from the table: "subscription_plans" using primary key columns */
  subscriptionPlansByPk?: Maybe<SubscriptionPlans>;
  /** fetch data from the table: "tenant_subscriptions" */
  tenantSubscriptions: Array<TenantSubscriptions>;
  /** An aggregate relationship */
  tenantSubscriptionsAggregate: TenantSubscriptionsAggregate;
  /** fetch data from the table: "tenant_subscriptions" using primary key columns */
  tenantSubscriptionsByPk?: Maybe<TenantSubscriptions>;
  /** fetch data from the table: "tenants" */
  tenants: Array<Tenants>;
  /** fetch data from the table: "tenants" using primary key columns */
  tenantsByPk?: Maybe<Tenants>;
  /** An array relationship */
  trackedMdeEnvironments: Array<TrackedMdeEnvironments>;
  /** fetch data from the table: "tracked_mde_environments" using primary key columns */
  trackedMdeEnvironmentsByPk?: Maybe<TrackedMdeEnvironments>;
  /** An array relationship */
  trackedMdes: Array<TrackedMdes>;
  /** fetch data from the table: "tracked_mdes" using primary key columns */
  trackedMdesByPk?: Maybe<TrackedMdes>;
  /** fetch data from the table: "tracked_mdes_states" */
  trackedMdesStates: Array<TrackedMdesStates>;
  /** fetch data from the table: "tracked_mdes_states" using primary key columns */
  trackedMdesStatesByPk?: Maybe<TrackedMdesStates>;
  /** An array relationship */
  trackedTenantEnvironments: Array<TrackedTenantEnvironments>;
  /** fetch data from the table: "tracked_tenant_environments" using primary key columns */
  trackedTenantEnvironmentsByPk?: Maybe<TrackedTenantEnvironments>;
  /** An array relationship */
  trackedTenants: Array<TrackedTenants>;
  /** An aggregate relationship */
  trackedTenantsAggregate: TrackedTenantsAggregate;
  /** fetch data from the table: "tracked_tenants" using primary key columns */
  trackedTenantsByPk?: Maybe<TrackedTenants>;
  /** fetch data from the table: "tracked_tenants_states" */
  trackedTenantsStates: Array<TrackedTenantsStates>;
  /** fetch data from the table: "tracked_tenants_states" using primary key columns */
  trackedTenantsStatesByPk?: Maybe<TrackedTenantsStates>;
  /** fetch data from the table: "user_roles" */
  userRoles: Array<UserRoles>;
  /** fetch data from the table: "user_roles" using primary key columns */
  userRolesByPk?: Maybe<UserRoles>;
  /** fetch data from the table: "user_states" */
  userStates: Array<UserStates>;
  /** fetch data from the table: "user_states" using primary key columns */
  userStatesByPk?: Maybe<UserStates>;
  /** An array relationship */
  userTenants: Array<UserTenants>;
  /** fetch data from the table: "user_tenants" using primary key columns */
  userTenantsByPk?: Maybe<UserTenants>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch data from the table: "users" using primary key columns */
  usersByPk?: Maybe<Users>;
};


export type Query_RootCheckDatasourceArgs = {
  datasourceId: Scalars['String']['input'];
};


export type Query_RootCurrentUserArgs = {
  distinctOn?: InputMaybe<Array<UsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  where?: InputMaybe<UsersBoolExp>;
};


export type Query_RootDatasourceI18nsArgs = {
  distinctOn?: InputMaybe<Array<DatasourceI18nsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DatasourceI18nsOrderBy>>;
  where?: InputMaybe<DatasourceI18nsBoolExp>;
};


export type Query_RootDatasourceI18nsByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootDatasourceSchemaMetadataOverviewArgs = {
  distinctOn?: InputMaybe<Array<DatasourceSchemaMetadataOverviewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DatasourceSchemaMetadataOverviewOrderBy>>;
  where?: InputMaybe<DatasourceSchemaMetadataOverviewBoolExp>;
};


export type Query_RootDatasourceSchemaMetadataOverviewByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootDatasourcesArgs = {
  distinctOn?: InputMaybe<Array<DatasourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DatasourcesOrderBy>>;
  where?: InputMaybe<DatasourcesBoolExp>;
};


export type Query_RootDatasourcesByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootEnvironmentTypesArgs = {
  distinctOn?: InputMaybe<Array<EnvironmentTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EnvironmentTypesOrderBy>>;
  where?: InputMaybe<EnvironmentTypesBoolExp>;
};


export type Query_RootEnvironmentTypesByPkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEnvironmentsArgs = {
  distinctOn?: InputMaybe<Array<EnvironmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EnvironmentsOrderBy>>;
  where?: InputMaybe<EnvironmentsBoolExp>;
};


export type Query_RootEnvironmentsByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootEventsArgs = {
  distinctOn?: InputMaybe<Array<EventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
  where?: InputMaybe<EventsBoolExp>;
};


export type Query_RootEventsByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGoogleSheetsArgs = {
  distinctOn?: InputMaybe<Array<GoogleSheetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSheetsOrderBy>>;
  where?: InputMaybe<GoogleSheetsBoolExp>;
};


export type Query_RootGoogleSheetsByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGoogleSpreadsheetOverviewArgs = {
  args: GoogleSpreadsheetOverviewArgs;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSpreadsheetOverviewsOrderBy>>;
  where?: InputMaybe<GoogleSpreadsheetOverviewsBoolExp>;
};


export type Query_RootGoogleSpreadsheetOverviewsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSpreadsheetOverviewsOrderBy>>;
  where?: InputMaybe<GoogleSpreadsheetOverviewsBoolExp>;
};


export type Query_RootGoogleSpreadsheetSyncsArgs = {
  distinctOn?: InputMaybe<Array<GoogleSpreadsheetSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSpreadsheetSyncsOrderBy>>;
  where?: InputMaybe<GoogleSpreadsheetSyncsBoolExp>;
};


export type Query_RootGoogleSpreadsheetSyncsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GoogleSpreadsheetSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSpreadsheetSyncsOrderBy>>;
  where?: InputMaybe<GoogleSpreadsheetSyncsBoolExp>;
};


export type Query_RootGoogleSpreadsheetSyncsByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGoogleSpreadsheetsArgs = {
  distinctOn?: InputMaybe<Array<GoogleSpreadsheetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSpreadsheetsOrderBy>>;
  where?: InputMaybe<GoogleSpreadsheetsBoolExp>;
};


export type Query_RootGoogleSpreadsheetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GoogleSpreadsheetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSpreadsheetsOrderBy>>;
  where?: InputMaybe<GoogleSpreadsheetsBoolExp>;
};


export type Query_RootGoogleSpreadsheetsByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootListMdEsArgs = {
  datasourceId: Scalars['String']['input'];
};


export type Query_RootListProjectGoogleDriveFoldersArgs = {
  projectId: Scalars['String']['input'];
};


export type Query_RootListTenantsArgs = {
  datasourceId: Scalars['String']['input'];
};


export type Query_RootPgtunnelPortsArgs = {
  distinctOn?: InputMaybe<Array<PgtunnelPortsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PgtunnelPortsOrderBy>>;
  where?: InputMaybe<PgtunnelPortsBoolExp>;
};


export type Query_RootPgtunnelPortsByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootProjectsArgs = {
  distinctOn?: InputMaybe<Array<ProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
  where?: InputMaybe<ProjectsBoolExp>;
};


export type Query_RootProjectsByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootReadMdeArgs = {
  datasourceId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  mdeName: Scalars['String']['input'];
};


export type Query_RootSubscriptionPlansArgs = {
  distinctOn?: InputMaybe<Array<SubscriptionPlansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SubscriptionPlansOrderBy>>;
  where?: InputMaybe<SubscriptionPlansBoolExp>;
};


export type Query_RootSubscriptionPlansByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootTenantSubscriptionsArgs = {
  distinctOn?: InputMaybe<Array<TenantSubscriptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantSubscriptionsOrderBy>>;
  where?: InputMaybe<TenantSubscriptionsBoolExp>;
};


export type Query_RootTenantSubscriptionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TenantSubscriptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantSubscriptionsOrderBy>>;
  where?: InputMaybe<TenantSubscriptionsBoolExp>;
};


export type Query_RootTenantSubscriptionsByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootTenantsArgs = {
  distinctOn?: InputMaybe<Array<TenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantsOrderBy>>;
  where?: InputMaybe<TenantsBoolExp>;
};


export type Query_RootTenantsByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootTrackedMdeEnvironmentsArgs = {
  distinctOn?: InputMaybe<Array<TrackedMdeEnvironmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrackedMdeEnvironmentsOrderBy>>;
  where?: InputMaybe<TrackedMdeEnvironmentsBoolExp>;
};


export type Query_RootTrackedMdeEnvironmentsByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootTrackedMdesArgs = {
  distinctOn?: InputMaybe<Array<TrackedMdesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrackedMdesOrderBy>>;
  where?: InputMaybe<TrackedMdesBoolExp>;
};


export type Query_RootTrackedMdesByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootTrackedMdesStatesArgs = {
  distinctOn?: InputMaybe<Array<TrackedMdesStatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrackedMdesStatesOrderBy>>;
  where?: InputMaybe<TrackedMdesStatesBoolExp>;
};


export type Query_RootTrackedMdesStatesByPkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootTrackedTenantEnvironmentsArgs = {
  distinctOn?: InputMaybe<Array<TrackedTenantEnvironmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrackedTenantEnvironmentsOrderBy>>;
  where?: InputMaybe<TrackedTenantEnvironmentsBoolExp>;
};


export type Query_RootTrackedTenantEnvironmentsByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootTrackedTenantsArgs = {
  distinctOn?: InputMaybe<Array<TrackedTenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrackedTenantsOrderBy>>;
  where?: InputMaybe<TrackedTenantsBoolExp>;
};


export type Query_RootTrackedTenantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TrackedTenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrackedTenantsOrderBy>>;
  where?: InputMaybe<TrackedTenantsBoolExp>;
};


export type Query_RootTrackedTenantsByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootTrackedTenantsStatesArgs = {
  distinctOn?: InputMaybe<Array<TrackedTenantsStatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrackedTenantsStatesOrderBy>>;
  where?: InputMaybe<TrackedTenantsStatesBoolExp>;
};


export type Query_RootTrackedTenantsStatesByPkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootUserRolesArgs = {
  distinctOn?: InputMaybe<Array<UserRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
  where?: InputMaybe<UserRolesBoolExp>;
};


export type Query_RootUserRolesByPkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootUserStatesArgs = {
  distinctOn?: InputMaybe<Array<UserStatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserStatesOrderBy>>;
  where?: InputMaybe<UserStatesBoolExp>;
};


export type Query_RootUserStatesByPkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootUserTenantsArgs = {
  distinctOn?: InputMaybe<Array<UserTenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserTenantsOrderBy>>;
  where?: InputMaybe<UserTenantsBoolExp>;
};


export type Query_RootUserTenantsByPkArgs = {
  tenantId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


export type Query_RootUsersArgs = {
  distinctOn?: InputMaybe<Array<UsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  where?: InputMaybe<UsersBoolExp>;
};


export type Query_RootUsersByPkArgs = {
  id: Scalars['bigint']['input'];
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** execute function "get_current_user" which returns "users" */
  currentUser: Array<Users>;
  /** An array relationship */
  datasourceI18ns: Array<DatasourceI18ns>;
  /** fetch data from the table: "datasource_i18ns" using primary key columns */
  datasourceI18nsByPk?: Maybe<DatasourceI18ns>;
  /** fetch data from the table in a streaming manner: "datasource_i18ns" */
  datasourceI18nsStream: Array<DatasourceI18ns>;
  /** fetch data from the table: "datasource_schema_metadata_overview" */
  datasourceSchemaMetadataOverview: Array<DatasourceSchemaMetadataOverview>;
  /** fetch data from the table: "datasource_schema_metadata_overview" using primary key columns */
  datasourceSchemaMetadataOverviewByPk?: Maybe<DatasourceSchemaMetadataOverview>;
  /** fetch data from the table in a streaming manner: "datasource_schema_metadata_overview" */
  datasourceSchemaMetadataOverviewStream: Array<DatasourceSchemaMetadataOverview>;
  /** An array relationship */
  datasources: Array<Datasources>;
  /** fetch data from the table: "datasources" using primary key columns */
  datasourcesByPk?: Maybe<Datasources>;
  /** fetch data from the table in a streaming manner: "datasources" */
  datasourcesStream: Array<Datasources>;
  /** fetch data from the table: "environment_types" */
  environmentTypes: Array<EnvironmentTypes>;
  /** fetch data from the table: "environment_types" using primary key columns */
  environmentTypesByPk?: Maybe<EnvironmentTypes>;
  /** fetch data from the table in a streaming manner: "environment_types" */
  environmentTypesStream: Array<EnvironmentTypes>;
  /** An array relationship */
  environments: Array<Environments>;
  /** fetch data from the table: "environments" using primary key columns */
  environmentsByPk?: Maybe<Environments>;
  /** fetch data from the table in a streaming manner: "environments" */
  environmentsStream: Array<Environments>;
  /** fetch data from the table: "events" */
  events: Array<Events>;
  /** fetch data from the table: "events" using primary key columns */
  eventsByPk?: Maybe<Events>;
  /** fetch data from the table in a streaming manner: "events" */
  eventsStream: Array<Events>;
  /** An array relationship */
  googleSheets: Array<GoogleSheets>;
  /** fetch data from the table: "google_sheets" using primary key columns */
  googleSheetsByPk?: Maybe<GoogleSheets>;
  /** fetch data from the table in a streaming manner: "google_sheets" */
  googleSheetsStream: Array<GoogleSheets>;
  /** execute function "google_spreadsheet_overview" which returns "google_spreadsheet_overviews" */
  googleSpreadsheetOverview: Array<GoogleSpreadsheetOverviews>;
  /** fetch data from the table: "google_spreadsheet_overviews" */
  googleSpreadsheetOverviews: Array<GoogleSpreadsheetOverviews>;
  /** An array relationship */
  googleSpreadsheetSyncs: Array<GoogleSpreadsheetSyncs>;
  /** An aggregate relationship */
  googleSpreadsheetSyncsAggregate: GoogleSpreadsheetSyncsAggregate;
  /** fetch data from the table: "google_spreadsheet_syncs" using primary key columns */
  googleSpreadsheetSyncsByPk?: Maybe<GoogleSpreadsheetSyncs>;
  /** fetch data from the table in a streaming manner: "google_spreadsheet_syncs" */
  googleSpreadsheetSyncsStream: Array<GoogleSpreadsheetSyncs>;
  /** An array relationship */
  googleSpreadsheets: Array<GoogleSpreadsheets>;
  /** An aggregate relationship */
  googleSpreadsheetsAggregate: GoogleSpreadsheetsAggregate;
  /** fetch data from the table: "google_spreadsheets" using primary key columns */
  googleSpreadsheetsByPk?: Maybe<GoogleSpreadsheets>;
  /** fetch data from the table in a streaming manner: "google_spreadsheets" */
  googleSpreadsheetsStream: Array<GoogleSpreadsheets>;
  /** An array relationship */
  pgtunnelPorts: Array<PgtunnelPorts>;
  /** fetch data from the table: "pgtunnel_ports" using primary key columns */
  pgtunnelPortsByPk?: Maybe<PgtunnelPorts>;
  /** fetch data from the table in a streaming manner: "pgtunnel_ports" */
  pgtunnelPortsStream: Array<PgtunnelPorts>;
  /** An array relationship */
  projects: Array<Projects>;
  /** fetch data from the table: "projects" using primary key columns */
  projectsByPk?: Maybe<Projects>;
  /** fetch data from the table in a streaming manner: "projects" */
  projectsStream: Array<Projects>;
  /** fetch data from the table: "subscription_plans" */
  subscriptionPlans: Array<SubscriptionPlans>;
  /** fetch data from the table: "subscription_plans" using primary key columns */
  subscriptionPlansByPk?: Maybe<SubscriptionPlans>;
  /** fetch data from the table in a streaming manner: "subscription_plans" */
  subscriptionPlansStream: Array<SubscriptionPlans>;
  /** fetch data from the table: "tenant_subscriptions" */
  tenantSubscriptions: Array<TenantSubscriptions>;
  /** An aggregate relationship */
  tenantSubscriptionsAggregate: TenantSubscriptionsAggregate;
  /** fetch data from the table: "tenant_subscriptions" using primary key columns */
  tenantSubscriptionsByPk?: Maybe<TenantSubscriptions>;
  /** fetch data from the table in a streaming manner: "tenant_subscriptions" */
  tenantSubscriptionsStream: Array<TenantSubscriptions>;
  /** fetch data from the table: "tenants" */
  tenants: Array<Tenants>;
  /** fetch data from the table: "tenants" using primary key columns */
  tenantsByPk?: Maybe<Tenants>;
  /** fetch data from the table in a streaming manner: "tenants" */
  tenantsStream: Array<Tenants>;
  /** An array relationship */
  trackedMdeEnvironments: Array<TrackedMdeEnvironments>;
  /** fetch data from the table: "tracked_mde_environments" using primary key columns */
  trackedMdeEnvironmentsByPk?: Maybe<TrackedMdeEnvironments>;
  /** fetch data from the table in a streaming manner: "tracked_mde_environments" */
  trackedMdeEnvironmentsStream: Array<TrackedMdeEnvironments>;
  /** An array relationship */
  trackedMdes: Array<TrackedMdes>;
  /** fetch data from the table: "tracked_mdes" using primary key columns */
  trackedMdesByPk?: Maybe<TrackedMdes>;
  /** fetch data from the table: "tracked_mdes_states" */
  trackedMdesStates: Array<TrackedMdesStates>;
  /** fetch data from the table: "tracked_mdes_states" using primary key columns */
  trackedMdesStatesByPk?: Maybe<TrackedMdesStates>;
  /** fetch data from the table in a streaming manner: "tracked_mdes_states" */
  trackedMdesStatesStream: Array<TrackedMdesStates>;
  /** fetch data from the table in a streaming manner: "tracked_mdes" */
  trackedMdesStream: Array<TrackedMdes>;
  /** An array relationship */
  trackedTenantEnvironments: Array<TrackedTenantEnvironments>;
  /** fetch data from the table: "tracked_tenant_environments" using primary key columns */
  trackedTenantEnvironmentsByPk?: Maybe<TrackedTenantEnvironments>;
  /** fetch data from the table in a streaming manner: "tracked_tenant_environments" */
  trackedTenantEnvironmentsStream: Array<TrackedTenantEnvironments>;
  /** An array relationship */
  trackedTenants: Array<TrackedTenants>;
  /** An aggregate relationship */
  trackedTenantsAggregate: TrackedTenantsAggregate;
  /** fetch data from the table: "tracked_tenants" using primary key columns */
  trackedTenantsByPk?: Maybe<TrackedTenants>;
  /** fetch data from the table: "tracked_tenants_states" */
  trackedTenantsStates: Array<TrackedTenantsStates>;
  /** fetch data from the table: "tracked_tenants_states" using primary key columns */
  trackedTenantsStatesByPk?: Maybe<TrackedTenantsStates>;
  /** fetch data from the table in a streaming manner: "tracked_tenants_states" */
  trackedTenantsStatesStream: Array<TrackedTenantsStates>;
  /** fetch data from the table in a streaming manner: "tracked_tenants" */
  trackedTenantsStream: Array<TrackedTenants>;
  /** fetch data from the table: "user_roles" */
  userRoles: Array<UserRoles>;
  /** fetch data from the table: "user_roles" using primary key columns */
  userRolesByPk?: Maybe<UserRoles>;
  /** fetch data from the table in a streaming manner: "user_roles" */
  userRolesStream: Array<UserRoles>;
  /** fetch data from the table: "user_states" */
  userStates: Array<UserStates>;
  /** fetch data from the table: "user_states" using primary key columns */
  userStatesByPk?: Maybe<UserStates>;
  /** fetch data from the table in a streaming manner: "user_states" */
  userStatesStream: Array<UserStates>;
  /** An array relationship */
  userTenants: Array<UserTenants>;
  /** fetch data from the table: "user_tenants" using primary key columns */
  userTenantsByPk?: Maybe<UserTenants>;
  /** fetch data from the table in a streaming manner: "user_tenants" */
  userTenantsStream: Array<UserTenants>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch data from the table: "users" using primary key columns */
  usersByPk?: Maybe<Users>;
  /** fetch data from the table in a streaming manner: "users" */
  usersStream: Array<Users>;
};


export type Subscription_RootCurrentUserArgs = {
  distinctOn?: InputMaybe<Array<UsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  where?: InputMaybe<UsersBoolExp>;
};


export type Subscription_RootDatasourceI18nsArgs = {
  distinctOn?: InputMaybe<Array<DatasourceI18nsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DatasourceI18nsOrderBy>>;
  where?: InputMaybe<DatasourceI18nsBoolExp>;
};


export type Subscription_RootDatasourceI18nsByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootDatasourceI18nsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DatasourceI18nsStreamCursorInput>>;
  where?: InputMaybe<DatasourceI18nsBoolExp>;
};


export type Subscription_RootDatasourceSchemaMetadataOverviewArgs = {
  distinctOn?: InputMaybe<Array<DatasourceSchemaMetadataOverviewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DatasourceSchemaMetadataOverviewOrderBy>>;
  where?: InputMaybe<DatasourceSchemaMetadataOverviewBoolExp>;
};


export type Subscription_RootDatasourceSchemaMetadataOverviewByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootDatasourceSchemaMetadataOverviewStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DatasourceSchemaMetadataOverviewStreamCursorInput>>;
  where?: InputMaybe<DatasourceSchemaMetadataOverviewBoolExp>;
};


export type Subscription_RootDatasourcesArgs = {
  distinctOn?: InputMaybe<Array<DatasourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DatasourcesOrderBy>>;
  where?: InputMaybe<DatasourcesBoolExp>;
};


export type Subscription_RootDatasourcesByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootDatasourcesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DatasourcesStreamCursorInput>>;
  where?: InputMaybe<DatasourcesBoolExp>;
};


export type Subscription_RootEnvironmentTypesArgs = {
  distinctOn?: InputMaybe<Array<EnvironmentTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EnvironmentTypesOrderBy>>;
  where?: InputMaybe<EnvironmentTypesBoolExp>;
};


export type Subscription_RootEnvironmentTypesByPkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEnvironmentTypesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EnvironmentTypesStreamCursorInput>>;
  where?: InputMaybe<EnvironmentTypesBoolExp>;
};


export type Subscription_RootEnvironmentsArgs = {
  distinctOn?: InputMaybe<Array<EnvironmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EnvironmentsOrderBy>>;
  where?: InputMaybe<EnvironmentsBoolExp>;
};


export type Subscription_RootEnvironmentsByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootEnvironmentsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EnvironmentsStreamCursorInput>>;
  where?: InputMaybe<EnvironmentsBoolExp>;
};


export type Subscription_RootEventsArgs = {
  distinctOn?: InputMaybe<Array<EventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
  where?: InputMaybe<EventsBoolExp>;
};


export type Subscription_RootEventsByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootEventsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EventsStreamCursorInput>>;
  where?: InputMaybe<EventsBoolExp>;
};


export type Subscription_RootGoogleSheetsArgs = {
  distinctOn?: InputMaybe<Array<GoogleSheetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSheetsOrderBy>>;
  where?: InputMaybe<GoogleSheetsBoolExp>;
};


export type Subscription_RootGoogleSheetsByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootGoogleSheetsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<GoogleSheetsStreamCursorInput>>;
  where?: InputMaybe<GoogleSheetsBoolExp>;
};


export type Subscription_RootGoogleSpreadsheetOverviewArgs = {
  args: GoogleSpreadsheetOverviewArgs;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSpreadsheetOverviewsOrderBy>>;
  where?: InputMaybe<GoogleSpreadsheetOverviewsBoolExp>;
};


export type Subscription_RootGoogleSpreadsheetOverviewsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSpreadsheetOverviewsOrderBy>>;
  where?: InputMaybe<GoogleSpreadsheetOverviewsBoolExp>;
};


export type Subscription_RootGoogleSpreadsheetSyncsArgs = {
  distinctOn?: InputMaybe<Array<GoogleSpreadsheetSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSpreadsheetSyncsOrderBy>>;
  where?: InputMaybe<GoogleSpreadsheetSyncsBoolExp>;
};


export type Subscription_RootGoogleSpreadsheetSyncsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GoogleSpreadsheetSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSpreadsheetSyncsOrderBy>>;
  where?: InputMaybe<GoogleSpreadsheetSyncsBoolExp>;
};


export type Subscription_RootGoogleSpreadsheetSyncsByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootGoogleSpreadsheetSyncsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<GoogleSpreadsheetSyncsStreamCursorInput>>;
  where?: InputMaybe<GoogleSpreadsheetSyncsBoolExp>;
};


export type Subscription_RootGoogleSpreadsheetsArgs = {
  distinctOn?: InputMaybe<Array<GoogleSpreadsheetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSpreadsheetsOrderBy>>;
  where?: InputMaybe<GoogleSpreadsheetsBoolExp>;
};


export type Subscription_RootGoogleSpreadsheetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GoogleSpreadsheetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GoogleSpreadsheetsOrderBy>>;
  where?: InputMaybe<GoogleSpreadsheetsBoolExp>;
};


export type Subscription_RootGoogleSpreadsheetsByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootGoogleSpreadsheetsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<GoogleSpreadsheetsStreamCursorInput>>;
  where?: InputMaybe<GoogleSpreadsheetsBoolExp>;
};


export type Subscription_RootPgtunnelPortsArgs = {
  distinctOn?: InputMaybe<Array<PgtunnelPortsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PgtunnelPortsOrderBy>>;
  where?: InputMaybe<PgtunnelPortsBoolExp>;
};


export type Subscription_RootPgtunnelPortsByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootPgtunnelPortsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PgtunnelPortsStreamCursorInput>>;
  where?: InputMaybe<PgtunnelPortsBoolExp>;
};


export type Subscription_RootProjectsArgs = {
  distinctOn?: InputMaybe<Array<ProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
  where?: InputMaybe<ProjectsBoolExp>;
};


export type Subscription_RootProjectsByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootProjectsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProjectsStreamCursorInput>>;
  where?: InputMaybe<ProjectsBoolExp>;
};


export type Subscription_RootSubscriptionPlansArgs = {
  distinctOn?: InputMaybe<Array<SubscriptionPlansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SubscriptionPlansOrderBy>>;
  where?: InputMaybe<SubscriptionPlansBoolExp>;
};


export type Subscription_RootSubscriptionPlansByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootSubscriptionPlansStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<SubscriptionPlansStreamCursorInput>>;
  where?: InputMaybe<SubscriptionPlansBoolExp>;
};


export type Subscription_RootTenantSubscriptionsArgs = {
  distinctOn?: InputMaybe<Array<TenantSubscriptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantSubscriptionsOrderBy>>;
  where?: InputMaybe<TenantSubscriptionsBoolExp>;
};


export type Subscription_RootTenantSubscriptionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TenantSubscriptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantSubscriptionsOrderBy>>;
  where?: InputMaybe<TenantSubscriptionsBoolExp>;
};


export type Subscription_RootTenantSubscriptionsByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootTenantSubscriptionsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TenantSubscriptionsStreamCursorInput>>;
  where?: InputMaybe<TenantSubscriptionsBoolExp>;
};


export type Subscription_RootTenantsArgs = {
  distinctOn?: InputMaybe<Array<TenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantsOrderBy>>;
  where?: InputMaybe<TenantsBoolExp>;
};


export type Subscription_RootTenantsByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootTenantsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TenantsStreamCursorInput>>;
  where?: InputMaybe<TenantsBoolExp>;
};


export type Subscription_RootTrackedMdeEnvironmentsArgs = {
  distinctOn?: InputMaybe<Array<TrackedMdeEnvironmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrackedMdeEnvironmentsOrderBy>>;
  where?: InputMaybe<TrackedMdeEnvironmentsBoolExp>;
};


export type Subscription_RootTrackedMdeEnvironmentsByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootTrackedMdeEnvironmentsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TrackedMdeEnvironmentsStreamCursorInput>>;
  where?: InputMaybe<TrackedMdeEnvironmentsBoolExp>;
};


export type Subscription_RootTrackedMdesArgs = {
  distinctOn?: InputMaybe<Array<TrackedMdesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrackedMdesOrderBy>>;
  where?: InputMaybe<TrackedMdesBoolExp>;
};


export type Subscription_RootTrackedMdesByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootTrackedMdesStatesArgs = {
  distinctOn?: InputMaybe<Array<TrackedMdesStatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrackedMdesStatesOrderBy>>;
  where?: InputMaybe<TrackedMdesStatesBoolExp>;
};


export type Subscription_RootTrackedMdesStatesByPkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootTrackedMdesStatesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TrackedMdesStatesStreamCursorInput>>;
  where?: InputMaybe<TrackedMdesStatesBoolExp>;
};


export type Subscription_RootTrackedMdesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TrackedMdesStreamCursorInput>>;
  where?: InputMaybe<TrackedMdesBoolExp>;
};


export type Subscription_RootTrackedTenantEnvironmentsArgs = {
  distinctOn?: InputMaybe<Array<TrackedTenantEnvironmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrackedTenantEnvironmentsOrderBy>>;
  where?: InputMaybe<TrackedTenantEnvironmentsBoolExp>;
};


export type Subscription_RootTrackedTenantEnvironmentsByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootTrackedTenantEnvironmentsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TrackedTenantEnvironmentsStreamCursorInput>>;
  where?: InputMaybe<TrackedTenantEnvironmentsBoolExp>;
};


export type Subscription_RootTrackedTenantsArgs = {
  distinctOn?: InputMaybe<Array<TrackedTenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrackedTenantsOrderBy>>;
  where?: InputMaybe<TrackedTenantsBoolExp>;
};


export type Subscription_RootTrackedTenantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TrackedTenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrackedTenantsOrderBy>>;
  where?: InputMaybe<TrackedTenantsBoolExp>;
};


export type Subscription_RootTrackedTenantsByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootTrackedTenantsStatesArgs = {
  distinctOn?: InputMaybe<Array<TrackedTenantsStatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrackedTenantsStatesOrderBy>>;
  where?: InputMaybe<TrackedTenantsStatesBoolExp>;
};


export type Subscription_RootTrackedTenantsStatesByPkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootTrackedTenantsStatesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TrackedTenantsStatesStreamCursorInput>>;
  where?: InputMaybe<TrackedTenantsStatesBoolExp>;
};


export type Subscription_RootTrackedTenantsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TrackedTenantsStreamCursorInput>>;
  where?: InputMaybe<TrackedTenantsBoolExp>;
};


export type Subscription_RootUserRolesArgs = {
  distinctOn?: InputMaybe<Array<UserRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
  where?: InputMaybe<UserRolesBoolExp>;
};


export type Subscription_RootUserRolesByPkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootUserRolesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserRolesStreamCursorInput>>;
  where?: InputMaybe<UserRolesBoolExp>;
};


export type Subscription_RootUserStatesArgs = {
  distinctOn?: InputMaybe<Array<UserStatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserStatesOrderBy>>;
  where?: InputMaybe<UserStatesBoolExp>;
};


export type Subscription_RootUserStatesByPkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootUserStatesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserStatesStreamCursorInput>>;
  where?: InputMaybe<UserStatesBoolExp>;
};


export type Subscription_RootUserTenantsArgs = {
  distinctOn?: InputMaybe<Array<UserTenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserTenantsOrderBy>>;
  where?: InputMaybe<UserTenantsBoolExp>;
};


export type Subscription_RootUserTenantsByPkArgs = {
  tenantId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


export type Subscription_RootUserTenantsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserTenantsStreamCursorInput>>;
  where?: InputMaybe<UserTenantsBoolExp>;
};


export type Subscription_RootUsersArgs = {
  distinctOn?: InputMaybe<Array<UsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  where?: InputMaybe<UsersBoolExp>;
};


export type Subscription_RootUsersByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUsersStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UsersStreamCursorInput>>;
  where?: InputMaybe<UsersBoolExp>;
};

export type TenantSubscriptionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TenantSubscriptionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<TenantSubscriptionsBoolExp>;
  predicate: IntComparisonExp;
};

export type TrackedTenantsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TrackedTenantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<TrackedTenantsBoolExp>;
  predicate: IntComparisonExp;
};

export type GetSubscriptionPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubscriptionPlansQuery = { __typename?: 'query_root', subscriptionPlans: Array<{ __typename?: 'SubscriptionPlans', id: string, name: string, slug: string, description?: string | null, maxGoogleSheets: string, maxTrackedTenants: string, monthlyTransferMegabyteLimits: string, billingIntervalMonths: number }> };

export type UpdateAdminProjectGoogleOauth2CredsProjectMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  creds: GoogleOauth2CredsInput;
}>;


export type UpdateAdminProjectGoogleOauth2CredsProjectMutation = { __typename?: 'mutation_root', updateProjectGoogleOauth2Creds?: boolean | null };

export type UpdateAdminProjectGoogleServiceAccountCredsProjectMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  creds: GoogleServiceAccountCredsInput;
}>;


export type UpdateAdminProjectGoogleServiceAccountCredsProjectMutation = { __typename?: 'mutation_root', updateProjectGoogleServiceAccountCreds?: boolean | null };

export type CreateEnvironmentPgDatasourceMutationVariables = Exact<{
  connectionString: Scalars['String']['input'];
  environmentId: Scalars['String']['input'];
}>;


export type CreateEnvironmentPgDatasourceMutation = { __typename?: 'mutation_root', createEnvironmentPgDatasource?: { __typename?: 'CreateEnvironmentPgDatasourceResult', datasourceId: string, initialSchemamapSql: string, datasource: Array<{ __typename?: 'Datasources', id: string, host: string, port: number, database: string, createdAt: string, updatedAt: string }> } | null };

export type CheckDatasourceQueryVariables = Exact<{
  datasourceId: Scalars['String']['input'];
}>;


export type CheckDatasourceQuery = { __typename?: 'query_root', checkDatasource?: { __typename?: 'RemoteCheckDatasourceResult', connected: boolean, migrations?: Array<{ __typename?: 'FlywaySchemaHistory', installedRank?: number | null, version?: string | null, description?: string | null, type?: string | null, script?: string | null, checksum?: string | null, installedBy?: string | null, installedOn?: string | null, executionTime?: number | null, success: boolean }> | null } | null };

export type DeleteDatasourceMutationVariables = Exact<{
  datasourceId: Scalars['bigint']['input'];
}>;


export type DeleteDatasourceMutation = { __typename?: 'mutation_root', deleteDatasourcesByPk?: { __typename?: 'Datasources', id: string, host: string } | null };

export type LatestDatasourceI18nQueryVariables = Exact<{
  datasourceId: Scalars['bigint']['input'];
}>;


export type LatestDatasourceI18nQuery = { __typename?: 'query_root', datasourceI18ns: Array<{ __typename?: 'DatasourceI18ns', id: string, value: string, valueHash: string, lastSeenAt: string, createdAt: string, updatedAt: string }> };

export type AssignPgTunnelPortMutationVariables = Exact<{
  environmentId: Scalars['bigint']['input'];
}>;


export type AssignPgTunnelPortMutation = { __typename?: 'mutation_root', assignPgtunnelToEnvironment: Array<{ __typename?: 'PgtunnelPorts', id: string, port: number, token: string, createdAt: string, updatedAt: string }> };

export type CreateDemoPgDatasourceMutationVariables = Exact<{
  connectionString: Scalars['String']['input'];
}>;


export type CreateDemoPgDatasourceMutation = { __typename?: 'mutation_root', createDemoPgDatasource?: { __typename?: 'CreateDemoPgDatasourceResult', datasourceId: string, datasource?: { __typename?: 'Datasources', id: string, host: string, port: number, database: string, createdAt: string, updatedAt: string } | null } | null };

export type PreviewPostgresEnvironmentSyncMutationVariables = Exact<{
  sourceDatasourceId: Scalars['String']['input'];
  trackedMdeId?: InputMaybe<Scalars['String']['input']>;
  sourceTrackedTenantId?: InputMaybe<Scalars['String']['input']>;
  sourceWhere?: InputMaybe<Scalars['String']['input']>;
  targetDatasourceId: Scalars['String']['input'];
  targetTrackedTenantId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PreviewPostgresEnvironmentSyncMutation = { __typename?: 'mutation_root', previewPostgresEnvironmentSync?: { __typename?: 'PostgresEnvironmentSyncPreview', recordCount: number, sourceMDEs: { __typename?: 'RemoteReadMDEResult', columns: Array<string>, rows: Array<Array<string>> }, targetMDEs: { __typename?: 'RemoteReadMDEResult', columns: Array<string>, rows: Array<Array<string>> }, d2LODSvgs: Array<{ __typename?: 'D2LODSvg', lod: number, d2Svg: string, d2Text: string }>, flow: { __typename?: 'GoogleSpreadsheetReactFlow', viewport: { __typename?: 'ReactFlowViewport', x: number, y: number, zoom: number }, edges: Array<{ __typename?: 'GoogleSpreadsheetReactFlowEdge', id: string, source: string, target: string, type?: string | null, animated?: boolean | null, selected?: boolean | null, data?: string | null, markerEnd?: { __typename?: 'GoogleSpreadsheetReactFlowEdgeMarker', type: string, color?: string | null, width?: number | null, height?: number | null, markerUnits?: string | null, orient?: string | null, strokeWidth?: string | null } | null, markerStart?: { __typename?: 'GoogleSpreadsheetReactFlowEdgeMarker', type: string, color?: string | null, width?: number | null, height?: number | null, markerUnits?: string | null, orient?: string | null, strokeWidth?: string | null } | null }>, nodes: Array<{ __typename?: 'GoogleSpreadsheetReactFlowNode', id: string, type?: string | null, width?: number | null, height?: number | null, deletable?: boolean | null, draggable?: boolean | null, dragging?: boolean | null, parentNode?: string | null, expandParent?: boolean | null, extent?: string | null, selected?: boolean | null, style?: string | null, data: string, position: { __typename?: 'XYPosition', x: number, y: number }, positionAbsolute?: { __typename?: 'XYPosition', x: number, y: number } | null }> } } | null };

export type SyncPostgresEnvMutationVariables = Exact<{
  sourceDatasourceId: Scalars['String']['input'];
  trackedMdeId?: InputMaybe<Scalars['String']['input']>;
  sourceTrackedTenantId?: InputMaybe<Scalars['String']['input']>;
  sourceMdeWhere?: InputMaybe<Scalars['String']['input']>;
  targetDatasourceId: Scalars['String']['input'];
  targetTrackedTenantId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SyncPostgresEnvMutation = { __typename?: 'mutation_root', syncPostgresEnvironment?: { __typename?: 'PostgresEnvironmentSyncResult', syncDurationSeconds: number, syncedTotalMegabytes: number, syncedTotalRecords: number, dataMigration: { __typename?: 'DataMigration', createdAt: string, id: string, importStartedAt?: string | null, importedAt?: string | null, mdeName: string, requesterEmail?: string | null, requesterUserId?: string | null, source: string, state: string, summary?: string | null, tenantId?: string | null, tenantName?: string | null, updatedAt: string, version: number } } | null };

export type GetEnvironmentsForProjectQueryVariables = Exact<{
  projectId: Scalars['bigint']['input'];
}>;


export type GetEnvironmentsForProjectQuery = { __typename?: 'query_root', environments: Array<{ __typename?: 'Environments', id: string, name: string, type: EnvironmentTypesEnum, description?: string | null, createdAt: string, updatedAt: string }> };

export type GetEnvironmentForProjectQueryVariables = Exact<{
  projectId: Scalars['bigint']['input'];
  environmentId: Scalars['bigint']['input'];
}>;


export type GetEnvironmentForProjectQuery = { __typename?: 'query_root', environments: Array<{ __typename?: 'Environments', id: string, name: string, type: EnvironmentTypesEnum, description?: string | null, createdAt: string, updatedAt: string, project?: { __typename?: 'Projects', id: string, name: string, description?: string | null, createdAt: string, updatedAt: string } | null, pgtunnelPorts: Array<{ __typename?: 'PgtunnelPorts', id: string, port: number, token: string, createdAt: string, updatedAt: string }>, datasources: Array<{ __typename?: 'Datasources', id: string, tenantId: string, host: string, port: number, database: string, username: string, sslmode: string, rootcert?: string | null, createdAt: string, updatedAt: string, lastConnectionAttemptAt?: string | null, lastSuccessfulConnectionAttemptAt?: string | null }>, trackedTenantEnvironments: Array<{ __typename?: 'TrackedTenantEnvironments', lastSyncedAt: string, trackedTenant: { __typename?: 'TrackedTenants', id: string, name: string, shortName: string, status: TrackedTenantsStatesEnum, createdAt: string, updatedAt: string } }>, trackedMdeEnvironments: Array<{ __typename?: 'TrackedMdeEnvironments', lastSyncedAt: string, trackedMde: { __typename?: 'TrackedMdes', id: string, name: string, shortName: string, status: TrackedTenantsStatesEnum, createdAt: string, updatedAt: string } }> }> };

export type CreateEnvironmentsMutationVariables = Exact<{
  environments: Array<EnvironmentsInsertInput> | EnvironmentsInsertInput;
}>;


export type CreateEnvironmentsMutation = { __typename?: 'mutation_root', insertEnvironments?: { __typename?: 'EnvironmentsMutationResponse', returning: Array<{ __typename?: 'Environments', id: string, name: string, description?: string | null, type: EnvironmentTypesEnum }> } | null };

export type DeleteEnvironmentMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type DeleteEnvironmentMutation = { __typename?: 'mutation_root', deleteEnvironmentsByPk?: { __typename?: 'Environments', id: string, name: string, description?: string | null, projectId?: string | null } | null };

export type GetProjectGoogleDriveFoldersQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetProjectGoogleDriveFoldersQuery = { __typename?: 'query_root', listProjectGoogleDriveFolders?: Array<{ __typename?: 'GoogleDriveFolder', id: string, name: string }> | null };

export type CreateGoogleSpreadsheetMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  environmentId: Scalars['String']['input'];
  spreadsheetName: Scalars['String']['input'];
  sheetName: Scalars['String']['input'];
  trackedMdeId: Scalars['String']['input'];
  trackedTenantId: Scalars['String']['input'];
}>;


export type CreateGoogleSpreadsheetMutation = { __typename?: 'mutation_root', createGoogleSpreadsheet?: { __typename?: 'createGoogleSpreadsheetResult', createdGoogleSpreadsheetId: string } | null };

export type UpdateProjectGoogleDriveFolderIdMutationVariables = Exact<{
  projectId: Scalars['bigint']['input'];
  googleDriveFolderId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateProjectGoogleDriveFolderIdMutation = { __typename?: 'mutation_root', updateProjectsByPk?: { __typename?: 'Projects', id: string, googleDriveFolderId?: string | null } | null };

export type CreateProjectMutationVariables = Exact<{
  project: ProjectsInsertInput;
}>;


export type CreateProjectMutation = { __typename?: 'mutation_root', insertProjectsOne?: { __typename?: 'Projects', id: string, name: string, description?: string | null, createdAt: string, updatedAt: string } | null };

export type DeleteProjectMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type DeleteProjectMutation = { __typename?: 'mutation_root', deleteProjectsByPk?: { __typename?: 'Projects', id: string, name: string, description?: string | null, createdAt: string, updatedAt: string } | null };

export type GetSchemaOverviewQueryVariables = Exact<{
  projectId: Scalars['bigint']['input'];
}>;


export type GetSchemaOverviewQuery = { __typename?: 'query_root', datasourceSchemaMetadataOverview: Array<{ __typename?: 'DatasourceSchemaMetadataOverview', schemaName: string, tableName: string, columnName: string, lastSeenAt: string, tableDescription?: string | null, columnDescription?: string | null, indexes?: string | null, createdAt: string, constraints?: string | null, dataType: string, datasourceId: string, id: string, notNull: boolean, objectType: string, valueHash: string, tenantId: string, updatedAt: string, datasource: { __typename?: 'Datasources', environment: { __typename?: 'Environments', id: string, name: string, project?: { __typename?: 'Projects', id: string, name: string } | null } } }> };

export type RenderSchemamapMutationVariables = Exact<{
  datasourceId: Scalars['String']['input'];
}>;


export type RenderSchemamapMutation = { __typename?: 'mutation_root', renderDatasourceSchemaMap?: { __typename?: 'RenderDatasourceSchemaMapResult', d2Svg: string, d2Text: string } | null };

export type SchemaMetricsMutationVariables = Exact<{
  datasourceId: Scalars['String']['input'];
  start: Scalars['String']['input'];
  end: Scalars['String']['input'];
}>;


export type SchemaMetricsMutation = { __typename?: 'mutation_root', schemaMetrics?: { __typename?: 'SchemaMetricsResult', status: string, tableCountCurrent: number, tableCountPrevious: number, columnCountCurrent: number, columnCountPrevious: number, schemaGrowthCurrent: number, schemaGrowthPrevious: number, schemaBreakageCurrent: number, schemaBreakagePrevious: number, constraintPerColumnPercentageCurrent: number, constraintPerColumnPercentagePrevious: number, tableClusters: Array<{ __typename?: 'TableCluster', id: string, tables: Array<{ __typename?: 'PostgresTable', schema: string, name: string }>, mutationOrders: Array<{ __typename?: 'MutationOrder', type: string, columns: Array<string>, returningColumns: Array<string>, table: { __typename?: 'PostgresTable', schema: string, name: string } }> }> } | null };

export type GetLatestSmosForDsQueryVariables = Exact<{
  environmentId: Scalars['bigint']['input'];
  datasourceId: Scalars['bigint']['input'];
}>;


export type GetLatestSmosForDsQuery = { __typename?: 'query_root', datasourceSchemaMetadataOverview: Array<{ __typename?: 'DatasourceSchemaMetadataOverview', schemaName: string, tableName: string, columnName: string, lastSeenAt: string, tableDescription?: string | null, columnDescription?: string | null, indexes?: string | null, createdAt: string, constraints?: string | null, dataType: string, datasourceId: string, id: string, notNull: boolean, objectType: string, valueHash: string, tenantId: string, updatedAt: string }>, trackedTenantEnvironments: Array<{ __typename?: 'TrackedTenantEnvironments', trackedTenant: { __typename?: 'TrackedTenants', shortName: string, name: string } }> };

export type ProjectGoogleSpreadsheetOverviewQueryVariables = Exact<{
  projectId: Scalars['bigint']['input'];
}>;


export type ProjectGoogleSpreadsheetOverviewQuery = { __typename?: 'query_root', googleSpreadsheetOverview: Array<{ __typename?: 'GoogleSpreadsheetOverviews', trackedMde: { __typename?: 'TrackedMdes', id: string, name: string, shortName: string }, trackedTenant: { __typename?: 'TrackedTenants', id: string, name: string, shortName: string }, environment: { __typename?: 'Environments', id: string, name: string }, trackedMdeEnvironment: { __typename?: 'TrackedMdeEnvironments', id: string, lastSyncedAt: string }, trackedTenantEnvironment: { __typename?: 'TrackedTenantEnvironments', id: string, lastSyncedAt: string }, googleSpreadsheet?: { __typename?: 'GoogleSpreadsheets', id: string, spreadsheetId: string, name: string, googleScriptId: string, project: { __typename?: 'Projects', name: string, id: string }, trackedTenant: { __typename?: 'TrackedTenants', id: string, name: string, shortName: string }, trackedMde: { __typename?: 'TrackedMdes', id: string, name: string, shortName: string }, environment: { __typename?: 'Environments', id: string, description?: string | null, name: string }, googleSheets: Array<{ __typename?: 'GoogleSheets', name: string, lastSyncedAt?: string | null, id: string }> } | null }> };

export type GetGoogleSpreadsheetQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type GetGoogleSpreadsheetQuery = { __typename?: 'query_root', googleSpreadsheetsByPk?: { __typename?: 'GoogleSpreadsheets', id: string, readonlyDatasourceId?: string | null, rwDatasourceId?: string | null, spreadsheetId: string, name: string, googleScriptId: string, createdAt: string, updatedAt: string, project: { __typename?: 'Projects', name: string, id: string }, trackedTenant: { __typename?: 'TrackedTenants', id: string, name: string, shortName: string }, trackedMde: { __typename?: 'TrackedMdes', id: string, name: string, shortName: string }, environment: { __typename?: 'Environments', id: string, description?: string | null, name: string, datasources: Array<{ __typename?: 'Datasources', id: string, tenantId: string, host: string, port: number, database: string, username: string, sslmode: string, rootcert?: string | null, createdAt: string, updatedAt: string, lastConnectionAttemptAt?: string | null, lastSuccessfulConnectionAttemptAt?: string | null }> }, googleSpreadsheetSyncs: Array<{ __typename?: 'GoogleSpreadsheetSyncs', id: string, state: GoogleSpreadsheetSyncStatesEnum, requesterEmail?: string | null, requesterUserId?: string | null, flow: string, syncType: GoogleSpreadsheetSyncTypesEnum, comment?: string | null, user?: { __typename?: 'Users', id: string, name: string } | null, datasource: { __typename?: 'Datasources', id: string } }>, syncSummary: Array<{ __typename?: 'GoogleSpreadsheetSyncs', id: string, state: GoogleSpreadsheetSyncStatesEnum, syncType: GoogleSpreadsheetSyncTypesEnum, createdAt: string, updatedAt: string, finishedAt?: string | null, comment?: string | null, requesterEmail?: string | null, requesterUserId?: string | null, user?: { __typename?: 'Users', id: string, name: string, pictureUrl?: string | null } | null, datasource: { __typename?: 'Datasources', id: string } }>, googleSheets: Array<{ __typename?: 'GoogleSheets', name: string, lastSyncedAt?: string | null, id: string }> } | null };

export type DeleteGoogleSpreadsheetMutationVariables = Exact<{
  googleSpreadsheetId: Scalars['String']['input'];
}>;


export type DeleteGoogleSpreadsheetMutation = { __typename?: 'mutation_root', deleteGoogleSpreadsheet?: boolean | null };

export type SyncGoogleSpreadsheetMutationVariables = Exact<{
  spreadsheetId: Scalars['String']['input'];
  datasourceId: Scalars['String']['input'];
  flow: GoogleSpreadsheetReactFlowInput;
}>;


export type SyncGoogleSpreadsheetMutation = { __typename?: 'mutation_root', syncGoogleSpreadsheet?: boolean | null };

export type ReadMdeQueryVariables = Exact<{
  datasourceId: Scalars['String']['input'];
  mdeName: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ReadMdeQuery = { __typename?: 'query_root', readMDE?: { __typename?: 'RemoteReadMDEResult', columns: Array<string>, rows: Array<Array<string>> } | null };

export type EdgeMarkerFragment = { __typename?: 'GoogleSpreadsheetReactFlowEdgeMarker', type: string, color?: string | null, width?: number | null, height?: number | null, markerUnits?: string | null, orient?: string | null, strokeWidth?: string | null };

export type ReactFlowEdgeFragment = { __typename?: 'GoogleSpreadsheetReactFlowEdge', id: string, source: string, target: string, type?: string | null, animated?: boolean | null, selected?: boolean | null, data?: string | null, markerEnd?: { __typename?: 'GoogleSpreadsheetReactFlowEdgeMarker', type: string, color?: string | null, width?: number | null, height?: number | null, markerUnits?: string | null, orient?: string | null, strokeWidth?: string | null } | null, markerStart?: { __typename?: 'GoogleSpreadsheetReactFlowEdgeMarker', type: string, color?: string | null, width?: number | null, height?: number | null, markerUnits?: string | null, orient?: string | null, strokeWidth?: string | null } | null };

export type ReactFlowNodeFragment = { __typename?: 'GoogleSpreadsheetReactFlowNode', id: string, type?: string | null, width?: number | null, height?: number | null, deletable?: boolean | null, draggable?: boolean | null, dragging?: boolean | null, parentNode?: string | null, expandParent?: boolean | null, extent?: string | null, selected?: boolean | null, style?: string | null, data: string, position: { __typename?: 'XYPosition', x: number, y: number }, positionAbsolute?: { __typename?: 'XYPosition', x: number, y: number } | null };

export type InferGoogleSpreadsheetMutationVariables = Exact<{
  datasourceId: Scalars['String']['input'];
  googleSpreadsheetId: Scalars['String']['input'];
  flow?: InputMaybe<GoogleSpreadsheetReactFlowInput>;
}>;


export type InferGoogleSpreadsheetMutation = { __typename?: 'mutation_root', inferGoogleSpreadsheet?: { __typename?: 'InferGoogleSpreadsheetResult', flow?: { __typename?: 'GoogleSpreadsheetReactFlow', viewport: { __typename?: 'ReactFlowViewport', x: number, y: number, zoom: number }, edges: Array<{ __typename?: 'GoogleSpreadsheetReactFlowEdge', id: string, source: string, target: string, type?: string | null, animated?: boolean | null, selected?: boolean | null, data?: string | null, markerEnd?: { __typename?: 'GoogleSpreadsheetReactFlowEdgeMarker', type: string, color?: string | null, width?: number | null, height?: number | null, markerUnits?: string | null, orient?: string | null, strokeWidth?: string | null } | null, markerStart?: { __typename?: 'GoogleSpreadsheetReactFlowEdgeMarker', type: string, color?: string | null, width?: number | null, height?: number | null, markerUnits?: string | null, orient?: string | null, strokeWidth?: string | null } | null }>, nodes: Array<{ __typename?: 'GoogleSpreadsheetReactFlowNode', id: string, type?: string | null, width?: number | null, height?: number | null, deletable?: boolean | null, draggable?: boolean | null, dragging?: boolean | null, parentNode?: string | null, expandParent?: boolean | null, extent?: string | null, selected?: boolean | null, style?: string | null, data: string, position: { __typename?: 'XYPosition', x: number, y: number }, positionAbsolute?: { __typename?: 'XYPosition', x: number, y: number } | null }> } | null } | null };

export type RemoteListTenantsQueryVariables = Exact<{
  datasourceId: Scalars['String']['input'];
}>;


export type RemoteListTenantsQuery = { __typename?: 'query_root', listTenants?: Array<{ __typename?: 'RemoteListTenantsResult', id?: string | null, name?: string | null, shortName?: string | null, locale?: string | null, data?: string | null } | null> | null };

export type RemoteListMdEsQueryVariables = Exact<{
  datasourceId: Scalars['String']['input'];
}>;


export type RemoteListMdEsQuery = { __typename?: 'query_root', listMDEs?: Array<{ __typename?: 'RemoteListMDEsResult', name: string, shortName: string } | null> | null };

export type InferCandidateMdesMutationVariables = Exact<{
  datasourceIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type InferCandidateMdesMutation = { __typename?: 'mutation_root', inferMDECandidates?: { __typename?: 'InferMDECandidatesResult', candidates: Array<{ __typename?: 'MDECandidate', schema: string, tableName: string, tableClusterId: string, depth: number, naturalKeyConstraintAst: string, dependencies: Array<string>, neededBy: Array<string> }> } | null };

export type SyncDatasourceI18nMutationVariables = Exact<{
  datasourceId: Scalars['String']['input'];
}>;


export type SyncDatasourceI18nMutation = { __typename?: 'mutation_root', syncDatasourceI18n?: boolean | null };

export type SyncDatasourceSmoMutationVariables = Exact<{
  datasourceId: Scalars['String']['input'];
  refresh: Scalars['Boolean']['input'];
}>;


export type SyncDatasourceSmoMutation = { __typename?: 'mutation_root', syncDatasourceSchemaMetadataOverview?: boolean | null };

export type DeployGasMutationVariables = Exact<{
  googleSpreadsheetId: Scalars['String']['input'];
}>;


export type DeployGasMutation = { __typename?: 'mutation_root', deployGASForGoogleSpreadsheet?: boolean | null };

export type InviteToTenantMutationVariables = Exact<{
  emails: Array<Scalars['String']['input']> | Scalars['String']['input'];
  role: Scalars['String']['input'];
}>;


export type InviteToTenantMutation = { __typename?: 'mutation_root', inviteToTenant?: boolean | null };

export type RemoveUserFromTenantMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
}>;


export type RemoveUserFromTenantMutation = { __typename?: 'mutation_root', removeUserFromTenant?: boolean | null };

export type CreateTenantMutationVariables = Exact<{
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  email: Scalars['String']['input'];
  logo: Scalars['String']['input'];
}>;


export type CreateTenantMutation = { __typename?: 'mutation_root', createTenant: Array<{ __typename?: 'Tenants', id: string, name: string, slug: string, email?: string | null, logo?: string | null }> };

export type TrackTenantsMutationVariables = Exact<{
  trackedTenants: Array<TrackedTenantsInsertInput> | TrackedTenantsInsertInput;
}>;


export type TrackTenantsMutation = { __typename?: 'mutation_root', insertTrackedTenants?: { __typename?: 'TrackedTenantsMutationResponse', returning: Array<{ __typename?: 'TrackedTenants', id: string, name: string, shortName: string, status: TrackedTenantsStatesEnum, trackedTenantEnvironments: Array<{ __typename?: 'TrackedTenantEnvironments', id: string, environmentId: string, lastSyncedAt: string, lastKnownTenantId?: string | null, tenantData?: string | null, tenantLocale?: string | null }> }> } | null };

export type GetTrackedTenantsQueryVariables = Exact<{
  projectId: Scalars['bigint']['input'];
}>;


export type GetTrackedTenantsQuery = { __typename?: 'query_root', trackedTenants: Array<{ __typename?: 'TrackedTenants', id: string, name: string, shortName: string, status: TrackedTenantsStatesEnum, createdAt: string, updatedAt: string, project: { __typename?: 'Projects', id: string, name: string }, trackedTenantEnvironments: Array<{ __typename?: 'TrackedTenantEnvironments', id: string, environmentId: string, lastSyncedAt: string, lastKnownTenantId?: string | null, tenantData?: string | null, tenantLocale?: string | null, environment: { __typename?: 'Environments', id: string, name: string } }> }> };

export type TrackMdEsMutationVariables = Exact<{
  trackedMdes: Array<TrackedMdesInsertInput> | TrackedMdesInsertInput;
}>;


export type TrackMdEsMutation = { __typename?: 'mutation_root', insertTrackedMdes?: { __typename?: 'TrackedMdesMutationResponse', returning: Array<{ __typename?: 'TrackedMdes', id: string, name: string, shortName: string, status: TrackedTenantsStatesEnum, trackedMdeEnvironments: Array<{ __typename?: 'TrackedMdeEnvironments', id: string, environmentId: string, lastSyncedAt: string }> }> } | null };

export type GetTrackedMdEsQueryVariables = Exact<{
  projectId: Scalars['bigint']['input'];
}>;


export type GetTrackedMdEsQuery = { __typename?: 'query_root', trackedMdes: Array<{ __typename?: 'TrackedMdes', id: string, name: string, shortName: string, status: TrackedTenantsStatesEnum, createdAt: string, updatedAt: string, project: { __typename?: 'Projects', id: string, name: string }, trackedMdeEnvironments: Array<{ __typename?: 'TrackedMdeEnvironments', id: string, environmentId: string, lastSyncedAt: string, environment: { __typename?: 'Environments', id: string, name: string } }> }> };

export type GetUsageByTrackedTenantsQueryVariables = Exact<{
  projectId: Scalars['bigint']['input'];
}>;


export type GetUsageByTrackedTenantsQuery = { __typename?: 'query_root', trackedTenants: Array<{ __typename?: 'TrackedTenants', id: string, name: string, shortName: string, status: TrackedTenantsStatesEnum, googleSpreadsheets: Array<{ __typename?: 'GoogleSpreadsheets', googleSpreadsheetSyncsAggregate: { __typename?: 'GoogleSpreadsheetSyncsAggregate', aggregate?: { __typename?: 'GoogleSpreadsheetSyncsAggregateFields', count: number } | null } }> }> };

export type GetUserQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type GetUserQuery = { __typename?: 'query_root', usersByPk?: { __typename?: 'Users', id: string, givenName?: string | null, familyName?: string | null, name: string, email: string, pictureUrl?: string | null, emailVerified?: string | null } | null };

export type GetUsersQueryVariables = Exact<{
  where: UsersBoolExp;
}>;


export type GetUsersQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', id: string, givenName?: string | null, familyName?: string | null, name: string, email: string, pictureUrl?: string | null, emailVerified?: string | null }> };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename?: 'query_root', currentUser: Array<{ __typename?: 'Users', id: string, givenName?: string | null, familyName?: string | null, name: string, email: string, pictureUrl?: string | null, lastTenantId?: string | null, userTenants: Array<{ __typename?: 'UserTenants', userRole: UserRolesEnum, tenant: { __typename?: 'Tenants', slug: string, id: string, clerkId?: string | null, name: string, logo?: string | null, hasSlackIntegration?: boolean | null, hasGoogleOauthIntegration?: boolean | null, currentSubscription?: Array<{ __typename?: 'TenantSubscriptions', valid: string, maxGoogleSheets: string, monthlyTransferMegabyteLimits: string, overageMbTransferEuroCent: string, priceEuroCent: string, subscriptionPlan: { __typename?: 'SubscriptionPlans', name: string, description?: string | null, id: string, slug: string, lemonsqueezyProductId?: string | null, lemonsqueezyCheckoutId?: string | null, billingIntervalMonths: number } }> | null, userTenants: Array<{ __typename?: 'UserTenants', user: { __typename?: 'Users', id: string, name: string, email: string, status: UserStatesEnum } }> }, user: { __typename?: 'Users', id: string, name: string, familyName?: string | null, givenName?: string | null, email: string, emailVerified?: string | null, status: UserStatesEnum } }> }>, projects: Array<{ __typename?: 'Projects', id: string, name: string, slug: string, description?: string | null, createdAt: string, updatedAt: string, googleDriveFolderId?: string | null, environments: Array<{ __typename?: 'Environments', id: string, name: string, slug: string, type: EnvironmentTypesEnum, description?: string | null, createdAt: string, updatedAt: string, project?: { __typename?: 'Projects', id: string, name: string, createdAt: string, updatedAt: string } | null, datasources: Array<{ __typename?: 'Datasources', id: string, tenantId: string, host: string, port: number, database: string, username: string, sslmode: string, rootcert?: string | null, createdAt: string, updatedAt: string, lastConnectionAttemptAt?: string | null, lastSuccessfulConnectionAttemptAt?: string | null }>, pgtunnelPorts: Array<{ __typename?: 'PgtunnelPorts', id: string, port: number, token: string, createdAt: string, updatedAt: string }>, trackedTenantEnvironments: Array<{ __typename?: 'TrackedTenantEnvironments', lastSyncedAt: string, trackedTenant: { __typename?: 'TrackedTenants', id: string, name: string, shortName: string, status: TrackedTenantsStatesEnum, createdAt: string, updatedAt: string } }>, trackedMdeEnvironments: Array<{ __typename?: 'TrackedMdeEnvironments', lastSyncedAt: string, trackedMde: { __typename?: 'TrackedMdes', id: string, name: string, shortName: string, status: TrackedTenantsStatesEnum, createdAt: string, updatedAt: string } }> }>, trackedTenants: Array<{ __typename?: 'TrackedTenants', id: string, name: string, status: TrackedTenantsStatesEnum, shortName: string }>, trackedMdes: Array<{ __typename?: 'TrackedMdes', id: string, name: string, status: TrackedTenantsStatesEnum, shortName: string }> }>, subscriptionPlans: Array<{ __typename?: 'SubscriptionPlans', name: string, description?: string | null, id: string, slug: string, lemonsqueezyProductId?: string | null, lemonsqueezyCheckoutId?: string | null, overageMbTransferEuroCent?: string | null, priceEuroCent?: string | null, billingIntervalMonths: number, maxGoogleSheets: string, maxTrackedTenants: string, monthlyTransferMegabyteLimits: string }> };

export type UpdateUserMutationVariables = Exact<{
  user: UsersInsertInput;
}>;


export type UpdateUserMutation = { __typename?: 'mutation_root', insertUsersOne?: { __typename?: 'Users', id: string, givenName?: string | null, familyName?: string | null, name: string, email: string, emailVerified?: string | null } | null };

export type CreateUserMutationVariables = Exact<{
  user: UsersInsertInput;
}>;


export type CreateUserMutation = { __typename?: 'mutation_root', insertUsersOne?: { __typename?: 'Users', id: string, givenName?: string | null, familyName?: string | null, name: string, email: string, pictureUrl?: string | null, emailVerified?: string | null } | null };

export const EdgeMarkerFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EdgeMarker"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleSpreadsheetReactFlowEdgeMarker"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"markerUnits"}},{"kind":"Field","name":{"kind":"Name","value":"orient"}},{"kind":"Field","name":{"kind":"Name","value":"strokeWidth"}}]}}]} as unknown as DocumentNode<EdgeMarkerFragment, unknown>;
export const ReactFlowEdgeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReactFlowEdge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleSpreadsheetReactFlowEdge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"animated"}},{"kind":"Field","name":{"kind":"Name","value":"selected"}},{"kind":"Field","name":{"kind":"Name","value":"markerEnd"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EdgeMarker"}}]}},{"kind":"Field","name":{"kind":"Name","value":"markerStart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EdgeMarker"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EdgeMarker"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleSpreadsheetReactFlowEdgeMarker"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"markerUnits"}},{"kind":"Field","name":{"kind":"Name","value":"orient"}},{"kind":"Field","name":{"kind":"Name","value":"strokeWidth"}}]}}]} as unknown as DocumentNode<ReactFlowEdgeFragment, unknown>;
export const ReactFlowNodeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReactFlowNode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleSpreadsheetReactFlowNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"deletable"}},{"kind":"Field","name":{"kind":"Name","value":"draggable"}},{"kind":"Field","name":{"kind":"Name","value":"dragging"}},{"kind":"Field","name":{"kind":"Name","value":"parentNode"}},{"kind":"Field","name":{"kind":"Name","value":"expandParent"}},{"kind":"Field","name":{"kind":"Name","value":"extent"}},{"kind":"Field","name":{"kind":"Name","value":"selected"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"positionAbsolute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"style"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]} as unknown as DocumentNode<ReactFlowNodeFragment, unknown>;
export const GetSubscriptionPlansDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSubscriptionPlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionPlans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"monthlyTransferMegabyteLimits"},"value":{"kind":"EnumValue","value":"DESC"}},{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"maxGoogleSheets"}},{"kind":"Field","name":{"kind":"Name","value":"maxTrackedTenants"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyTransferMegabyteLimits"}},{"kind":"Field","name":{"kind":"Name","value":"billingIntervalMonths"}}]}}]}}]} as unknown as DocumentNode<GetSubscriptionPlansQuery, GetSubscriptionPlansQueryVariables>;
export const UpdateAdminProjectGoogleOauth2CredsProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAdminProjectGoogleOauth2CredsProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"creds"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleOauth2CredsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProjectGoogleOauth2Creds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"creds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"creds"}}}]}]}}]} as unknown as DocumentNode<UpdateAdminProjectGoogleOauth2CredsProjectMutation, UpdateAdminProjectGoogleOauth2CredsProjectMutationVariables>;
export const UpdateAdminProjectGoogleServiceAccountCredsProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAdminProjectGoogleServiceAccountCredsProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"creds"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleServiceAccountCredsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProjectGoogleServiceAccountCreds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"creds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"creds"}}}]}]}}]} as unknown as DocumentNode<UpdateAdminProjectGoogleServiceAccountCredsProjectMutation, UpdateAdminProjectGoogleServiceAccountCredsProjectMutationVariables>;
export const CreateEnvironmentPgDatasourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateEnvironmentPgDatasource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"connectionString"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"environmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createEnvironmentPgDatasource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"connectionString"},"value":{"kind":"Variable","name":{"kind":"Name","value":"connectionString"}}},{"kind":"Argument","name":{"kind":"Name","value":"environmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"environmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"datasourceId"}},{"kind":"Field","name":{"kind":"Name","value":"initialSchemamapSql"}},{"kind":"Field","name":{"kind":"Name","value":"datasource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"host"}},{"kind":"Field","name":{"kind":"Name","value":"port"}},{"kind":"Field","name":{"kind":"Name","value":"database"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode<CreateEnvironmentPgDatasourceMutation, CreateEnvironmentPgDatasourceMutationVariables>;
export const CheckDatasourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckDatasource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"datasourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkDatasource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"datasourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"datasourceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"connected"}},{"kind":"Field","name":{"kind":"Name","value":"migrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installedRank"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"script"}},{"kind":"Field","name":{"kind":"Name","value":"checksum"}},{"kind":"Field","name":{"kind":"Name","value":"installedBy"}},{"kind":"Field","name":{"kind":"Name","value":"installedOn"}},{"kind":"Field","name":{"kind":"Name","value":"executionTime"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<CheckDatasourceQuery, CheckDatasourceQueryVariables>;
export const DeleteDatasourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteDatasource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"datasourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteDatasourcesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"datasourceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"host"}}]}}]}}]} as unknown as DocumentNode<DeleteDatasourceMutation, DeleteDatasourceMutationVariables>;
export const LatestDatasourceI18nDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LatestDatasourceI18n"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"datasourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"datasourceI18ns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datasourceId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"datasourceId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lastSeenAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"valueHash"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<LatestDatasourceI18nQuery, LatestDatasourceI18nQueryVariables>;
export const AssignPgTunnelPortDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AssignPgTunnelPort"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"environmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignPgtunnelToEnvironment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_environment_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"environmentId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"port"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<AssignPgTunnelPortMutation, AssignPgTunnelPortMutationVariables>;
export const CreateDemoPgDatasourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateDemoPgDatasource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"connectionString"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDemoPgDatasource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"connectionString"},"value":{"kind":"Variable","name":{"kind":"Name","value":"connectionString"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"datasourceId"}},{"kind":"Field","name":{"kind":"Name","value":"datasource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"host"}},{"kind":"Field","name":{"kind":"Name","value":"port"}},{"kind":"Field","name":{"kind":"Name","value":"database"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode<CreateDemoPgDatasourceMutation, CreateDemoPgDatasourceMutationVariables>;
export const PreviewPostgresEnvironmentSyncDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PreviewPostgresEnvironmentSync"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceDatasourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trackedMdeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceTrackedTenantId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetDatasourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetTrackedTenantId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewPostgresEnvironmentSync"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sourceDatasourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceDatasourceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"targetDatasourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetDatasourceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sourceMdeWhere"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"sourceTrackedTenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceTrackedTenantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"targetTrackedTenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetTrackedTenantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"trackedMdeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trackedMdeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourceMDEs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"columns"}},{"kind":"Field","name":{"kind":"Name","value":"rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetMDEs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"columns"}},{"kind":"Field","name":{"kind":"Name","value":"rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recordCount"}},{"kind":"Field","name":{"kind":"Name","value":"d2LODSvgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lod"}},{"kind":"Field","name":{"kind":"Name","value":"d2Svg"}},{"kind":"Field","name":{"kind":"Name","value":"d2Text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"zoom"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReactFlowEdge"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReactFlowNode"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EdgeMarker"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleSpreadsheetReactFlowEdgeMarker"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"markerUnits"}},{"kind":"Field","name":{"kind":"Name","value":"orient"}},{"kind":"Field","name":{"kind":"Name","value":"strokeWidth"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReactFlowEdge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleSpreadsheetReactFlowEdge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"animated"}},{"kind":"Field","name":{"kind":"Name","value":"selected"}},{"kind":"Field","name":{"kind":"Name","value":"markerEnd"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EdgeMarker"}}]}},{"kind":"Field","name":{"kind":"Name","value":"markerStart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EdgeMarker"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReactFlowNode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleSpreadsheetReactFlowNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"deletable"}},{"kind":"Field","name":{"kind":"Name","value":"draggable"}},{"kind":"Field","name":{"kind":"Name","value":"dragging"}},{"kind":"Field","name":{"kind":"Name","value":"parentNode"}},{"kind":"Field","name":{"kind":"Name","value":"expandParent"}},{"kind":"Field","name":{"kind":"Name","value":"extent"}},{"kind":"Field","name":{"kind":"Name","value":"selected"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"positionAbsolute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"style"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]} as unknown as DocumentNode<PreviewPostgresEnvironmentSyncMutation, PreviewPostgresEnvironmentSyncMutationVariables>;
export const SyncPostgresEnvDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SyncPostgresEnv"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceDatasourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trackedMdeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceTrackedTenantId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceMdeWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetDatasourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetTrackedTenantId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"syncPostgresEnvironment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sourceDatasourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceDatasourceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"targetDatasourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetDatasourceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sourceMdeWhere"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceMdeWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"sourceTrackedTenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceTrackedTenantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"targetTrackedTenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetTrackedTenantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"trackedMdeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trackedMdeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataMigration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"importStartedAt"}},{"kind":"Field","name":{"kind":"Name","value":"importedAt"}},{"kind":"Field","name":{"kind":"Name","value":"mdeName"}},{"kind":"Field","name":{"kind":"Name","value":"requesterEmail"}},{"kind":"Field","name":{"kind":"Name","value":"requesterUserId"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}},{"kind":"Field","name":{"kind":"Name","value":"tenantName"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"syncDurationSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"syncedTotalMegabytes"}},{"kind":"Field","name":{"kind":"Name","value":"syncedTotalRecords"}}]}}]}}]} as unknown as DocumentNode<SyncPostgresEnvMutation, SyncPostgresEnvMutationVariables>;
export const GetEnvironmentsForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEnvironmentsForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"environments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetEnvironmentsForProjectQuery, GetEnvironmentsForProjectQueryVariables>;
export const GetEnvironmentForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEnvironmentForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"environmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"environments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"environmentId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pgtunnelPorts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"port"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"datasources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}},{"kind":"Field","name":{"kind":"Name","value":"host"}},{"kind":"Field","name":{"kind":"Name","value":"port"}},{"kind":"Field","name":{"kind":"Name","value":"database"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"sslmode"}},{"kind":"Field","name":{"kind":"Name","value":"rootcert"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastConnectionAttemptAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastSuccessfulConnectionAttemptAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trackedTenantEnvironments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"trackedTenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"trackedMdeEnvironments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"trackedMde"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetEnvironmentForProjectQuery, GetEnvironmentForProjectQueryVariables>;
export const CreateEnvironmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateEnvironments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"environments"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EnvironmentsInsertInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertEnvironments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"environments"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<CreateEnvironmentsMutation, CreateEnvironmentsMutationVariables>;
export const DeleteEnvironmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteEnvironment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteEnvironmentsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}}]}}]}}]} as unknown as DocumentNode<DeleteEnvironmentMutation, DeleteEnvironmentMutationVariables>;
export const GetProjectGoogleDriveFoldersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectGoogleDriveFolders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listProjectGoogleDriveFolders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetProjectGoogleDriveFoldersQuery, GetProjectGoogleDriveFoldersQueryVariables>;
export const CreateGoogleSpreadsheetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateGoogleSpreadsheet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"environmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spreadsheetName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sheetName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trackedMdeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trackedTenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createGoogleSpreadsheet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"environmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"environmentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"spreadsheetName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spreadsheetName"}}},{"kind":"Argument","name":{"kind":"Name","value":"sheetName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sheetName"}}},{"kind":"Argument","name":{"kind":"Name","value":"trackedMdeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trackedMdeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"trackedTenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trackedTenantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdGoogleSpreadsheetId"}}]}}]}}]} as unknown as DocumentNode<CreateGoogleSpreadsheetMutation, CreateGoogleSpreadsheetMutationVariables>;
export const UpdateProjectGoogleDriveFolderIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProjectGoogleDriveFolderId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"googleDriveFolderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProjectsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"googleDriveFolderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"googleDriveFolderId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"googleDriveFolderId"}}]}}]}}]} as unknown as DocumentNode<UpdateProjectGoogleDriveFolderIdMutation, UpdateProjectGoogleDriveFolderIdMutationVariables>;
export const CreateProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectsInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertProjectsOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<CreateProjectMutation, CreateProjectMutationVariables>;
export const DeleteProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProjectsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<DeleteProjectMutation, DeleteProjectMutationVariables>;
export const GetSchemaOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSchemaOverview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"datasourceSchemaMetadataOverview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datasource"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"environment"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lastSeenAt"},"value":{"kind":"EnumValue","value":"DESC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tableName"},"value":{"kind":"EnumValue","value":"ASC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"columnName"},"value":{"kind":"EnumValue","value":"ASC"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schemaName"}},{"kind":"Field","name":{"kind":"Name","value":"tableName"}},{"kind":"Field","name":{"kind":"Name","value":"columnName"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"tableDescription"}},{"kind":"Field","name":{"kind":"Name","value":"columnDescription"}},{"kind":"Field","name":{"kind":"Name","value":"indexes"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"constraints"}},{"kind":"Field","name":{"kind":"Name","value":"tableName"}},{"kind":"Field","name":{"kind":"Name","value":"dataType"}},{"kind":"Field","name":{"kind":"Name","value":"datasourceId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notNull"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"valueHash"}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"datasource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"environment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSchemaOverviewQuery, GetSchemaOverviewQueryVariables>;
export const RenderSchemamapDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"renderSchemamap"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"datasourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"renderDatasourceSchemaMap"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"datasourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"datasourceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"d2Svg"}},{"kind":"Field","name":{"kind":"Name","value":"d2Text"}}]}}]}}]} as unknown as DocumentNode<RenderSchemamapMutation, RenderSchemamapMutationVariables>;
export const SchemaMetricsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SchemaMetrics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"datasourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schemaMetrics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"datasourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"datasourceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"Argument","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tableCountCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"tableCountPrevious"}},{"kind":"Field","name":{"kind":"Name","value":"columnCountCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"columnCountPrevious"}},{"kind":"Field","name":{"kind":"Name","value":"schemaGrowthCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"schemaGrowthPrevious"}},{"kind":"Field","name":{"kind":"Name","value":"schemaBreakageCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"schemaBreakagePrevious"}},{"kind":"Field","name":{"kind":"Name","value":"constraintPerColumnPercentageCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"constraintPerColumnPercentagePrevious"}},{"kind":"Field","name":{"kind":"Name","value":"tableClusters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tables"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schema"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mutationOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"table"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schema"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"columns"}},{"kind":"Field","name":{"kind":"Name","value":"returningColumns"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SchemaMetricsMutation, SchemaMetricsMutationVariables>;
export const GetLatestSmosForDsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLatestSmosForDs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"environmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"datasourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"datasourceSchemaMetadataOverview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datasourceId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"datasourceId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lastSeenAt"},"value":{"kind":"EnumValue","value":"DESC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tableName"},"value":{"kind":"EnumValue","value":"ASC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"columnName"},"value":{"kind":"EnumValue","value":"ASC"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schemaName"}},{"kind":"Field","name":{"kind":"Name","value":"tableName"}},{"kind":"Field","name":{"kind":"Name","value":"columnName"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"tableDescription"}},{"kind":"Field","name":{"kind":"Name","value":"columnDescription"}},{"kind":"Field","name":{"kind":"Name","value":"indexes"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"constraints"}},{"kind":"Field","name":{"kind":"Name","value":"tableName"}},{"kind":"Field","name":{"kind":"Name","value":"dataType"}},{"kind":"Field","name":{"kind":"Name","value":"datasourceId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notNull"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"valueHash"}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trackedTenantEnvironments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"environmentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"environmentId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trackedTenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetLatestSmosForDsQuery, GetLatestSmosForDsQueryVariables>;
export const ProjectGoogleSpreadsheetOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectGoogleSpreadsheetOverview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"googleSpreadsheetOverview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_project_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"googleSpreadsheet"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"DESC_NULLS_LAST"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"trackedTenant"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"trackedMde"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"environment"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trackedMde"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trackedTenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"environment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trackedMdeEnvironment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastSyncedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trackedTenantEnvironment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastSyncedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"googleSpreadsheet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"spreadsheetId"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"googleScriptId"}},{"kind":"Field","name":{"kind":"Name","value":"trackedTenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trackedMde"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"environment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"googleSheets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sheetId"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProjectGoogleSpreadsheetOverviewQuery, ProjectGoogleSpreadsheetOverviewQueryVariables>;
export const GetGoogleSpreadsheetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetGoogleSpreadsheet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"googleSpreadsheetsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"readonlyDatasourceId"}},{"kind":"Field","name":{"kind":"Name","value":"rwDatasourceId"}},{"kind":"Field","name":{"kind":"Name","value":"spreadsheetId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"googleScriptId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trackedTenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trackedMde"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"environment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"datasources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}},{"kind":"Field","name":{"kind":"Name","value":"host"}},{"kind":"Field","name":{"kind":"Name","value":"port"}},{"kind":"Field","name":{"kind":"Name","value":"database"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"sslmode"}},{"kind":"Field","name":{"kind":"Name","value":"rootcert"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastConnectionAttemptAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastSuccessfulConnectionAttemptAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"googleSpreadsheetSyncs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"COMPLETED"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"finishedAt"},"value":{"kind":"EnumValue","value":"DESC_NULLS_LAST"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requesterEmail"}},{"kind":"Field","name":{"kind":"Name","value":"requesterUserId"}},{"kind":"Field","name":{"kind":"Name","value":"flow"}},{"kind":"Field","name":{"kind":"Name","value":"syncType"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"datasource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"syncSummary"},"name":{"kind":"Name","value":"googleSpreadsheetSyncs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"finishedAt"},"value":{"kind":"EnumValue","value":"DESC_NULLS_LAST"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"syncType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"requesterEmail"}},{"kind":"Field","name":{"kind":"Name","value":"requesterUserId"}},{"kind":"Field","name":{"kind":"Name","value":"datasource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"googleSheets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sheetId"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetGoogleSpreadsheetQuery, GetGoogleSpreadsheetQueryVariables>;
export const DeleteGoogleSpreadsheetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteGoogleSpreadsheet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"googleSpreadsheetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteGoogleSpreadsheet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"googleSpreadsheetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"googleSpreadsheetId"}}}]}]}}]} as unknown as DocumentNode<DeleteGoogleSpreadsheetMutation, DeleteGoogleSpreadsheetMutationVariables>;
export const SyncGoogleSpreadsheetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SyncGoogleSpreadsheet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spreadsheetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"datasourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"flow"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleSpreadsheetReactFlowInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"syncGoogleSpreadsheet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"googleSpreadsheetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spreadsheetId"}}},{"kind":"Argument","name":{"kind":"Name","value":"datasourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"datasourceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"flow"},"value":{"kind":"Variable","name":{"kind":"Name","value":"flow"}}}]}]}}]} as unknown as DocumentNode<SyncGoogleSpreadsheetMutation, SyncGoogleSpreadsheetMutationVariables>;
export const ReadMdeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"readMDE"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"datasourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mdeName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"readMDE"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"datasourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"datasourceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"mdeName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mdeName"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"columns"}},{"kind":"Field","name":{"kind":"Name","value":"rows"}}]}}]}}]} as unknown as DocumentNode<ReadMdeQuery, ReadMdeQueryVariables>;
export const InferGoogleSpreadsheetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InferGoogleSpreadsheet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"datasourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"googleSpreadsheetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"flow"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleSpreadsheetReactFlowInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inferGoogleSpreadsheet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"datasourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"datasourceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"googleSpreadsheetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"googleSpreadsheetId"}}},{"kind":"Argument","name":{"kind":"Name","value":"flow"},"value":{"kind":"Variable","name":{"kind":"Name","value":"flow"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"zoom"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReactFlowEdge"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReactFlowNode"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EdgeMarker"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleSpreadsheetReactFlowEdgeMarker"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"markerUnits"}},{"kind":"Field","name":{"kind":"Name","value":"orient"}},{"kind":"Field","name":{"kind":"Name","value":"strokeWidth"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReactFlowEdge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleSpreadsheetReactFlowEdge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"animated"}},{"kind":"Field","name":{"kind":"Name","value":"selected"}},{"kind":"Field","name":{"kind":"Name","value":"markerEnd"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EdgeMarker"}}]}},{"kind":"Field","name":{"kind":"Name","value":"markerStart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EdgeMarker"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReactFlowNode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleSpreadsheetReactFlowNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"deletable"}},{"kind":"Field","name":{"kind":"Name","value":"draggable"}},{"kind":"Field","name":{"kind":"Name","value":"dragging"}},{"kind":"Field","name":{"kind":"Name","value":"parentNode"}},{"kind":"Field","name":{"kind":"Name","value":"expandParent"}},{"kind":"Field","name":{"kind":"Name","value":"extent"}},{"kind":"Field","name":{"kind":"Name","value":"selected"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"positionAbsolute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"style"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]} as unknown as DocumentNode<InferGoogleSpreadsheetMutation, InferGoogleSpreadsheetMutationVariables>;
export const RemoteListTenantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RemoteListTenants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"datasourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listTenants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"datasourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"datasourceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}}]} as unknown as DocumentNode<RemoteListTenantsQuery, RemoteListTenantsQueryVariables>;
export const RemoteListMdEsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RemoteListMDEs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"datasourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listMDEs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"datasourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"datasourceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}}]} as unknown as DocumentNode<RemoteListMdEsQuery, RemoteListMdEsQueryVariables>;
export const InferCandidateMdesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InferCandidateMDES"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"datasourceIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inferMDECandidates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"datasourceIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"datasourceIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"candidates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schema"}},{"kind":"Field","name":{"kind":"Name","value":"tableName"}},{"kind":"Field","name":{"kind":"Name","value":"tableClusterId"}},{"kind":"Field","name":{"kind":"Name","value":"depth"}},{"kind":"Field","name":{"kind":"Name","value":"naturalKeyConstraintAst"}},{"kind":"Field","name":{"kind":"Name","value":"dependencies"}},{"kind":"Field","name":{"kind":"Name","value":"neededBy"}}]}}]}}]}}]} as unknown as DocumentNode<InferCandidateMdesMutation, InferCandidateMdesMutationVariables>;
export const SyncDatasourceI18nDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SyncDatasourceI18n"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"datasourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"syncDatasourceI18n"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"datasourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"datasourceId"}}}]}]}}]} as unknown as DocumentNode<SyncDatasourceI18nMutation, SyncDatasourceI18nMutationVariables>;
export const SyncDatasourceSmoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SyncDatasourceSmo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"datasourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refresh"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"syncDatasourceSchemaMetadataOverview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"datasourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"datasourceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"refresh"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refresh"}}}]}]}}]} as unknown as DocumentNode<SyncDatasourceSmoMutation, SyncDatasourceSmoMutationVariables>;
export const DeployGasDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeployGas"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"googleSpreadsheetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deployGASForGoogleSpreadsheet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"googleSpreadsheetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"googleSpreadsheetId"}}}]}]}}]} as unknown as DocumentNode<DeployGasMutation, DeployGasMutationVariables>;
export const InviteToTenantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"inviteToTenant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emails"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inviteToTenant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"emails"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emails"}}},{"kind":"Argument","name":{"kind":"Name","value":"role"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}}]}]}}]} as unknown as DocumentNode<InviteToTenantMutation, InviteToTenantMutationVariables>;
export const RemoveUserFromTenantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveUserFromTenant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeUserFromTenant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}}]}]}}]} as unknown as DocumentNode<RemoveUserFromTenantMutation, RemoveUserFromTenantMutationVariables>;
export const CreateTenantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTenant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"logo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTenant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_logo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"logo"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}}]} as unknown as DocumentNode<CreateTenantMutation, CreateTenantMutationVariables>;
export const TrackTenantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"trackTenants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trackedTenants"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrackedTenantsInsertInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertTrackedTenants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trackedTenants"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"tracked_tenants_project_id_short_name_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"name"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"trackedTenantEnvironments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"environmentId"}},{"kind":"Field","name":{"kind":"Name","value":"lastSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastKnownTenantId"}},{"kind":"Field","name":{"kind":"Name","value":"tenantData"}},{"kind":"Field","name":{"kind":"Name","value":"tenantLocale"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TrackTenantsMutation, TrackTenantsMutationVariables>;
export const GetTrackedTenantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTrackedTenants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trackedTenants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trackedTenantEnvironments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"environmentId"}},{"kind":"Field","name":{"kind":"Name","value":"environment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastKnownTenantId"}},{"kind":"Field","name":{"kind":"Name","value":"tenantData"}},{"kind":"Field","name":{"kind":"Name","value":"tenantLocale"}}]}}]}}]}}]} as unknown as DocumentNode<GetTrackedTenantsQuery, GetTrackedTenantsQueryVariables>;
export const TrackMdEsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"trackMDEs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trackedMdes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrackedMdesInsertInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertTrackedMdes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trackedMdes"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"tracked_mdes_project_id_short_name_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"name"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"trackedMdeEnvironments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"environmentId"}},{"kind":"Field","name":{"kind":"Name","value":"lastSyncedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TrackMdEsMutation, TrackMdEsMutationVariables>;
export const GetTrackedMdEsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTrackedMDEs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trackedMdes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trackedMdeEnvironments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"environmentId"}},{"kind":"Field","name":{"kind":"Name","value":"environment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastSyncedAt"}}]}}]}}]}}]} as unknown as DocumentNode<GetTrackedMdEsQuery, GetTrackedMdEsQueryVariables>;
export const GetUsageByTrackedTenantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsageByTrackedTenants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trackedTenants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"googleSpreadsheets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"googleSpreadsheetSyncsAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUsageByTrackedTenantsQuery, GetUsageByTrackedTenantsQueryVariables>;
export const GetUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usersByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"pictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}}]}}]}}]} as unknown as DocumentNode<GetUserQuery, GetUserQueryVariables>;
export const GetUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersBoolExp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"pictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}}]}}]}}]} as unknown as DocumentNode<GetUsersQuery, GetUsersQueryVariables>;
export const GetCurrentUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"pictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"lastTenantId"}},{"kind":"Field","name":{"kind":"Name","value":"userTenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clerkId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"hasSlackIntegration"}},{"kind":"Field","name":{"kind":"Name","value":"hasGoogleOauthIntegration"}},{"kind":"Field","name":{"kind":"Name","value":"currentSubscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"lemonsqueezyProductId"}},{"kind":"Field","name":{"kind":"Name","value":"lemonsqueezyCheckoutId"}},{"kind":"Field","name":{"kind":"Name","value":"billingIntervalMonths"}}]}},{"kind":"Field","name":{"kind":"Name","value":"valid"}},{"kind":"Field","name":{"kind":"Name","value":"maxGoogleSheets"}},{"kind":"Field","name":{"kind":"Name","value":"maxGoogleSheets"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyTransferMegabyteLimits"}},{"kind":"Field","name":{"kind":"Name","value":"overageMbTransferEuroCent"}},{"kind":"Field","name":{"kind":"Name","value":"priceEuroCent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userTenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"googleDriveFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"environments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"datasources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}},{"kind":"Field","name":{"kind":"Name","value":"host"}},{"kind":"Field","name":{"kind":"Name","value":"port"}},{"kind":"Field","name":{"kind":"Name","value":"database"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"sslmode"}},{"kind":"Field","name":{"kind":"Name","value":"rootcert"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastConnectionAttemptAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastSuccessfulConnectionAttemptAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pgtunnelPorts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"port"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trackedTenantEnvironments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"trackedTenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"trackedMdeEnvironments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"trackedMde"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"trackedTenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trackedMdes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionPlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"lemonsqueezyProductId"}},{"kind":"Field","name":{"kind":"Name","value":"lemonsqueezyCheckoutId"}},{"kind":"Field","name":{"kind":"Name","value":"overageMbTransferEuroCent"}},{"kind":"Field","name":{"kind":"Name","value":"priceEuroCent"}},{"kind":"Field","name":{"kind":"Name","value":"billingIntervalMonths"}},{"kind":"Field","name":{"kind":"Name","value":"maxGoogleSheets"}},{"kind":"Field","name":{"kind":"Name","value":"maxTrackedTenants"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyTransferMegabyteLimits"}}]}}]}}]} as unknown as DocumentNode<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertUsersOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"users_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"givenName"},{"kind":"EnumValue","value":"familyName"},{"kind":"EnumValue","value":"name"},{"kind":"EnumValue","value":"email"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}}]}}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const CreateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertUsersOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"pictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}}]}}]}}]} as unknown as DocumentNode<CreateUserMutation, CreateUserMutationVariables>;